import axios from 'axios';
import axiosRetry from 'axios-retry';
import * as Sentry from '@sentry/browser';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { v4 } from 'uuid';
import pkceChallenge from 'pkce-challenge';
import isDate from 'validator/es/lib/isDate';

var arrow_match_button_continue$1 = "Continue";
var arrow_match_button_left_web$1 = "(Z) Left";
var arrow_match_button_right_web$1 = "Right (M)";
var arrow_match_conclusion_1_heading$1 = "Assessment Complete!";
var arrow_match_intro_1_heading$1 = "Arrow Match";
var arrow_match_intro_1_paragraph$1 = "This 3-minute assessment will measure your attention.";
var arrow_match_phase_1_intro_1$1 = "You will see a series of arrows in the middle of your screen.";
var arrow_match_phase_1_intro_2$1 = "Choose whether the center arrow is pointing left or right.";
var arrow_match_phase_1_intro_2_web$1 = "Using your keyboard, you will choose whether the center arrow is pointing left or right.";
var arrow_match_phase_1_intro_3$1 = "Tap the ‘Left’ button when the center arrow is pointing left.";
var arrow_match_phase_1_intro_3_web$1 = "Tap the Z key when the center arrow is pointing left.";
var arrow_match_phase_1_intro_4$1 = "Tap the ‘Right’ button when the center arrow is pointing right.";
var arrow_match_phase_1_intro_4_web$1 = "Tap the M key when the center arrow is pointing right.";
var arrow_match_phase_1_intro_5_web$1 = "Remember, you will use your keyboard for this task. Locate the Z and M keys and tap them now.";
var arrow_match_phase_1_intro_6_header_web$1 = "Nice!";
var arrow_match_phase_1_intro_6_web$1 = "Press spacebar to continue.";
var arrow_match_phase_1_start_1$1 = "You’re ready for the assessment. You will only have a few seconds to respond, so please work as quickly and accurately as possible.";
var arrow_match_phase_1_start_1_header$1 = "Great work!";
var arrow_match_phase_1_start_2$1 = "Between trials, you will see a \"+\" to help you focus on the center of the screen. Remember to choose whether the center arrow is pointing left or right.";
var arrow_match_start_practice$1 = "Next, we’ll have a quick practice session before the assessment begins.";
var arrow_match_start_practice_web$1 = "Next, we’ll have a quick practice session before the assessment begins. Press spacebar to continue.";
var arrow_match_title$1 = "Arrow Match";
var arrow_match_tutorial_feedback_body_left_web$1 = "The center arrow was pointing left. Press spacebar to continue.";
var arrow_match_tutorial_feedback_body_right_web$1 = "The center arrow was pointing right. Press spacebar to continue.";
var arrow_match_tutorial_feedback_header_correct$1 = "Correct!";
var arrow_match_tutorial_feedback_header_incorrect$1 = "Sorry, that's incorrect.";
var demographics_age_heading$1 = "Age";
var demographics_biological_sex_answer_1$1 = "Female";
var demographics_biological_sex_answer_2$1 = "Male";
var demographics_biological_sex_heading$1 = "Biological Sex";
var demographics_button_label$1 = "Continue";
var demographics_education_answer_1$1 = "0-6 years of school";
var demographics_education_answer_10$1 = "Doctorate degree (PhD)";
var demographics_education_answer_2$1 = "7-9 years of school";
var demographics_education_answer_3$1 = "10-11 years of school";
var demographics_education_answer_4$1 = "High school graduate, diploma or equivalent";
var demographics_education_answer_5$1 = "Some college, no degree";
var demographics_education_answer_6$1 = "Associate degree";
var demographics_education_answer_7$1 = "Bachelor’s degree";
var demographics_education_answer_8$1 = "Master’s degree";
var demographics_education_answer_9$1 = "Professional degree (MD, JD)";
var demographics_education_heading$1 = "Education";
var demographics_paragraph$1 = "To begin, please enter the following information as accurately as possible. Your responses are anonymous and secure.";
var demographics_race_ethnicity_answer_1$1 = "American Indian or Alaskan Native";
var demographics_race_ethnicity_answer_2$1 = "Asian";
var demographics_race_ethnicity_answer_3$1 = "Black or African-American";
var demographics_race_ethnicity_answer_4$1 = "Hispanic or Latino";
var demographics_race_ethnicity_answer_5$1 = "Native Hawaiian or other Pacific Islander";
var demographics_race_ethnicity_answer_6$1 = "White";
var demographics_race_ethnicity_heading$1 = "Race / Ethnicity";
var demographics_worker_id_heading$1 = "Worker ID";
var demographics_worker_id_prompt$1 = "Enter your worker ID";
var exam_complete_mturk_body$1 = "Your responses have been recorded. Please use this unique MTurk completion code.";
var exam_complete_mturk_error_body$1 = "We are unable to provide you with your unique code. Please use your worker ID as your MTurk completion code instead.";
var exam_complete_mturk_error_header$1 = "Oops, something went wrong!";
var exam_complete_mturk_header$1 = "Assessment complete!";
var exam_instructions_header$1 = "Instructions";
var exam_practice_header$1 = "Practice";
var exam_start_exam_button_label$1 = "Let's start";
var exam_start_practice_button_label$1 = "Let's practice";
var exam_start_practice_header$1 = "Let's practice";
var experiments_arrow_match_button_correct$1 = "Correct";
var experiments_arrow_match_button_incorrect$1 = "Incorrect";
var experiments_arrow_match_pre_practice_1$1 = "Between trials, you will see a \"+\" to help you focus on the center of the screen.";
var experiments_mouse_arrow_match_phase_1_intro_3_web$1 = "Click the ‘Left’ button when the center arrow is pointing left.";
var experiments_mouse_arrow_match_phase_1_intro_4_web$1 = "Click the ‘Right’ button when the center arrow is pointing left.";
var experiments_timer_arrow_match_post_practice$1 = "You’re ready for the assessment. Remember to choose whether the center arrow is pointing left or right.";
var experiments_timer_arrow_match_start_practice_web$1 = "Next, we’ll have a quick practice session before the assessment begins. You will only have a few seconds to respond, so please work as quickly and accurately as possible. Press spacebar to continue.";
var flanker_prepractice_button_label$1 = "Let's Practice";
var flanker_prepractice_description$1 = "Next, we'll have a quick practice session before the assessment begins. Press the spacebar to continue.";
var flanker_prepractice_title$1 = "Let's Practice";
var go_no_go_button_continue$1 = "Continue";
var go_no_go_conclusion_1_heading$1 = "Assessment Complete!";
var go_no_go_feedback_body_early$1 = "Remember to wait until the light turns green to respond.";
var go_no_go_feedback_body_early_web$1 = "Remember to wait until the light turns green to respond.\n\nPress the spacebar to continue.";
var go_no_go_feedback_body_go_correct$1 = "The light turned green.";
var go_no_go_feedback_body_go_correct_web$1 = "The light turned green.\n\nPress the spacebar to continue.";
var go_no_go_feedback_body_go_incorrect$1 = "Remember to respond when the light turns green.";
var go_no_go_feedback_body_go_incorrect_web$1 = "Remember to respond when the light turns green.\n\nPress the spacebar to continue.";
var go_no_go_feedback_body_no_go_correct$1 = "The light turned red.";
var go_no_go_feedback_body_no_go_correct_web$1 = "The light turned red.\n\nPress spacebar to continue.";
var go_no_go_feedback_body_no_go_incorrect$1 = "Remember to only respond when the light turns green.";
var go_no_go_feedback_body_no_go_incorrect_web$1 = "Remember to only respond when the light turns green.\n\nPress the spacebar to continue.";
var go_no_go_feedback_header_correct$1 = "Correct!";
var go_no_go_feedback_header_early$1 = "Oops, you were early!";
var go_no_go_feedback_header_incorrect$1 = "Sorry, that's incorrect.";
var go_no_go_intro_1_heading$1 = "Light Reaction";
var go_no_go_intro_1_paragraph$1 = "This 3-minute assessment will measure your inhibition.";
var go_no_go_phase_1_intro_1$1 = "In this assessment, you will be shown an image of a single traffic light and a button below the image.";
var go_no_go_phase_1_intro_1_web$1 = "In this assessment, you will be shown an image of a single traffic light and a button below the image. The button will not have a label. During the assessment, you will use the “Enter” (or “Return”) key on your keyboard for the button.";
var go_no_go_phase_1_intro_2$1 = "When the traffic light turns green, tap the button as quickly as possible.";
var go_no_go_phase_1_intro_2_web$1 = "When the traffic light turns green, tap the “Enter” (or “Return”) key as quickly as possible.";
var go_no_go_phase_1_intro_3$1 = "When the traffic light turns red, do not respond at all. You will advance automatically after a couple of seconds.";
var go_no_go_phase_1_intro_3_web$1 = "When the traffic light turns red, do not respond at all. You will advance automatically after a couple of seconds.";
var go_no_go_phase_1_start_body$1 = "Next, the assessment will begin. You will only have a few seconds to respond, so please work as quickly and accurately as possible.";
var go_no_go_phase_1_start_body_web$1 = "Next, the assessment will begin. You will only have a few seconds to respond, so please work as quickly and accurately as possible. Press the spacebar to continue.";
var go_no_go_phase_1_start_header$1 = "Great work!";
var go_no_go_response_button_web$1 = "Spacebar";
var go_no_go_start_practice$1 = "Next, we’ll have a quick practice session before the assessment begins.";
var go_no_go_start_practice_web$1 = "Next, we’ll have a quick practice session before the assessment begins. Remember you will use the \"Enter\" (or \"Return\") key to respond. Press spacebar to continue.";
var go_no_go_title$1 = "Light Reaction";
var image_pairs_button_continue$1 = "Continue";
var image_pairs_title$1 = "Read the instructions carefully";
var instructions_heading$1 = "Instructions";
var item_price_button_continue$1 = "Continue";
var item_price_button_no_web$1 = "No (M)";
var item_price_button_yes_web$1 = "(Z) Yes";
var item_price_phase_1_end$1 = "Part 1 complete!";
var item_price_phase_1_end_body$1 = "You will now begin Part 2.";
var item_price_phase_1_intro_1$1 = "In Part 1, we will show you prices for eight fruits and vegetables.";
var item_price_phase_1_intro_2$1 = "In Part 2, we will ask you to recognize the prices for each fruit and vegetable.";
var item_price_phase_1_intro_3$1 = "For example, cabbage is $4.99. Remember this price.";
var item_price_phase_1_intro_3_price$1 = "$4.99";
var item_price_phase_1_intro_4$1 = "Is this the correct price? The correct answer is no. Cabbage cost $4.99.";
var item_price_phase_1_intro_4_price$1 = "$5.99";
var item_price_phase_1_intro_5_button$1 = "Start Part 1";
var item_price_phase_1_intro_5_web$1 = "Remember the prices of these eight fruits and vegetables. Press spacebar to continue.";
var item_price_phase_2_intro_1$1 = "For Part 2, you will now see a price next to a fruit or vegetable again.";
var item_price_phase_2_intro_2_web$1 = "Using your keyboard, you will choose whether the price is correct or incorrect based on Part 1.";
var item_price_phase_2_intro_3_web$1 = "Tap the Z key when the price is correct.";
var item_price_phase_2_intro_4_web$1 = "Tap the M key when the price is incorrect.";
var item_price_phase_2_intro_5$1 = "You will only have a few seconds to respond, so please work as quickly and accurately as possible.";
var item_price_phase_2_intro_6_button$1 = "Start Part 2";
var item_price_phase_2_intro_6_web$1 = "Choose whether the prices you see are correct or incorrect based on Part 1. Press spacebar to continue.";
var item_price_phase_2_trial_prompt$1 = "Correct price?";
var item_price_title$1 = "Item Price";
var path_points_button_continue$1 = "Continue";
var path_points_conclusion_1_heading$1 = "Well done!";
var path_points_intro_1_paragraph$1 = "   ";
var path_points_node_a$1 = "A";
var path_points_node_b$1 = "B";
var path_points_node_c$1 = "C";
var path_points_node_d$1 = "D";
var path_points_node_e$1 = "E";
var path_points_node_f$1 = "F";
var path_points_node_g$1 = "G";
var path_points_phase_1_intro_1$1 = "You will see a series of numbers and letters on your screen.";
var path_points_phase_1_intro_2$1 = "Tap the buttons in order, alternating between numbers and letters. Start with “1”, then “A”, then “2”, and so on.";
var path_points_phase_1_intro_2_web$1 = "Press the buttons in order, alternating between numbers and letters. Start with “1”, then “A”, then “2”, and so on.";
var path_points_phase_1_intro_3$1 = "Continue this pattern until all the buttons have been tapped in the correct order.";
var path_points_phase_1_intro_3_alternate$1 = "Start with “1”, then “A”, then “2”, and so on.";
var path_points_phase_1_intro_3_web$1 = "Continue this pattern until all the buttons have been clicked in the correct order.";
var path_points_phase_1_start_body$1 = "You’re ready for the assessment. Remember to work as quickly and accurately as possible, starting with “1” and alternating between numbers and letters.";
var path_points_phase_1_start_header$1 = "Great work!";
var path_points_start_practice$1 = "Next, we’ll have a quick practice session before the assessment begins.";
var path_points_title$1 = "Read the instructions carefully";
var path_points_tutorial_incorrect_body$1 = "Remember to alternate between numbers and letters in ascending order.";
var path_points_tutorial_incorrect_header$1 = "Oops!";
var path_points_tutorial_prompt$1 = "Start by tapping the \"1\".";
var path_points_tutorial_prompt_web$1 = "Start by clicking the \"1\".";
var symbol_match_button_continue$1 = "Continue";
var symbol_match_button_equal$1 = "=";
var symbol_match_button_equal_web$1 = "(Z) Equal";
var symbol_match_button_unequal$1 = "≠";
var symbol_match_button_unequal_web$1 = "Unequal (M)";
var symbol_match_phase_1_intro_1$1 = "First, we will show you pairs of symbols with a chart above them.";
var symbol_match_phase_1_intro_2$1 = "Determine the value of each symbol by using the chart.";
var symbol_match_phase_1_intro_3$1 = "In this example, the star has a value of 2 and the circle has a value of 1.";
var symbol_match_phase_1_intro_4$1 = "In this example, both symbols have a value of 1.";
var symbol_match_phase_1_intro_5_web$1 = "Tap the Z key when the symbols are equal in value.";
var symbol_match_phase_1_intro_6_web$1 = "Tap the M key when the symbols are unequal in value.";
var symbol_match_phase_1_intro_7_web$1 = "Remember to use the chart to determine the value of each symbol. Press spacebar to continue.";
var symbol_match_phase_1_start_header$1 = "Great work!";
var symbol_match_phase_1_start_web$1 = "Remember to use the chart to determine the value of each symbol. Press spacebar to continue.";
var symbol_match_title$1 = "Read the instructions carefully";
var symbol_match_tutorial_1_paragraph_web$1 = "The left symbol has a value of 1 and the right symbol has a value of 2. Unequal was the correct choice. Press spacebar to continue.";
var symbol_match_tutorial_2_paragraph_web$1 = "The left symbol has a value of 3 and the right symbol has a value of 3. Equal was the correct choice. Press spacebar to continue.";
var symbol_match_tutorial_3_paragraph_web$1 = "The left symbol has a value of 5 and the right symbol has a value of 4. Unequal was the correct choice. Press spacebar to continue.";
var symbol_match_tutorial_correct_heading$1 = "Correct";
var symbol_match_tutorial_incorrect_heading$1 = "Sorry, that’s incorrect";
var web_button_next$1 = "Next";
var web_button_previous$1 = "Previous";
var account_created_body_confirmation$1 = "Your account has been successfully created. Download the Neurotrack app and start taking care of your brain today!";
var account_created_body_confirmation_webuser$1 = "Please visit {0} to start taking your cognitive assessments.";
var account_created_verification_instructions_body$1 = "Please use {0} as the email address to log in to the app.\nIf the email you registered with is incorrect, contact {1}.\n\nLook for a welcome email from braincare@neurotrack.com. To make sure you receive Neurotrack’s emails, please add braincare@neurotrack.com to your allowed contacts. Check your spam folder if you don’t see the email.\nFor other frequently asked questions, go to {2}.";
var account_created_verification_instructions_body_webuser$1 = "Login with {0} to start taking your cognitive assessments. If the email address doesn’t work, please contact {1}.";
var account_link$1 = "Your account";
var alert_action_ok$1 = "Ok";
var alert_body_expired_coupon$1 = "The code you input does not accept any new members. Please try again or contact customer support at your sponsored organization for assistance.";
var alert_body_invalid_coupon$1 = "We do not recognize the code you input. Please try again or contact customer support at your sponsored organization for assistance.";
var alert_bulk_create_account_success$1 = "Accounts successfully created";
var alert_forgot_password_body_confirm$1 = "Instructions on how to reset your password have been sent to your email address if it is associated with an account. You may now safely close this page.";
var alert_forgot_password_body_header$1 = "Enter your email";
var alert_header_forgot_password$1 = "Forgot password";
var alert_header_invalid_coupon$1 = "Invalid code";
var alert_header_invalid_login$1 = "Log in failed";
var alert_header_reg_error$1 = "Account creation failed";
var alert_invalid_extension$1 = "Incorrect file type. Please select a CSV file.";
var alert_invalid_login_body$1 = "Your email or password is incorrect.\nPlease try again.";
var alert_invalid_login_email$1 = "support@neurotrack.com";
var alert_reg_error_body$1 = "We were unable to create your account. Please try again or contact customer support ({0}) for assistance.";
var alert_session_expired$1 = "You have been logged out due to inactivity. Please log in to continue.";
var alert_unsupported_media_recorder$1 = "Your browser does not support video recording. We recommend switching to Google Chrome or Mozilla Firefox.";
var apple_app_store$1 = "Apple App Store";
var assessment_processing$1 = "Assessment processing";
var assessment_unavailable_camera_body$1 = "Please check camera settings";
var assessment_unavailable_camera_header$1 = "Video requirement not met";
var assessments_available_body$1 = "Below are your available Cognitive Assessments. Click on an assessment card to begin taking the assessment. Instructions will be provided at the beginning of each assessment.";
var assessments_available_empty_body$1 = "Congratulations! You’ve completed all assessments for this session.";
var assessments_available_header$1 = "Your Cognitive Assessments";
var assessments_history_empty_body$1 = "You haven’t taken any exams yet! Once you’ve taken some assessments, you’ll be able to see what you’ve taken and when you’ve taken them.";
var assessments_history_header$1 = "Assessment History";
var assessments_history_table_assessment_header$1 = "Assessment";
var assessments_history_table_bucket_header$1 = "Bucket";
var assessments_history_table_date_header$1 = "Date taken";
var assessments_history_table_domain_header$1 = "Domain measured";
var assessments_history_table_percentile_header$1 = "Percentile";
var assessments_history_with_scores_empty_body$1 = "You haven’t taken any exams yet! Once you’ve taken some assessments, you’ll be able to see which exams you’ve taken and your scores for each one.";
var associative_learning$1 = "Associative learning";
var associative_memory$1 = "Associative memory";
var attention$1 = "Attention";
var available_exams_label$1 = "Available exams";
var back_to_faqs$1 = "Back to FAQs";
var browser_tab_title$1 = "Neurotrack";
var button_agree$1 = "Agree and continue";
var button_back_to_assessments$1 = "Go back to Assessments";
var button_cancel$1 = "Cancel";
var button_check_camera$1 = "Check camera";
var button_close$1 = "Close";
var button_continue$1 = "Continue";
var button_continue_session$1 = "Continue session";
var button_delete$1 = "Delete";
var button_disagree$1 = "I do not agree";
var button_edit$1 = "Edit";
var button_forgot_password$1 = "Forgot password";
var button_forgot_password_log_in$1 = "Go back to log in";
var button_go_back$1 = "Go back";
var button_learn_more$1 = "Learn more";
var button_login$1 = "Login";
var button_open_app$1 = "Open app";
var button_register$1 = "Register";
var button_save$1 = "Save";
var button_set$1 = "Set";
var button_sign_in$1 = "Log in";
var button_sign_out$1 = "Log out";
var button_sign_up$1 = "Sign up";
var button_skip$1 = "Skip";
var button_submit$1 = "Submit";
var button_try_again$1 = "Try again";
var camera_check_button_continue_with$1 = "Continue with camera check";
var camera_check_button_continue_without$1 = "Continue without camera check";
var camera_check_header$1 = "Web camera check";
var camera_check_intro$1 = "We ask that you allow camera access during the cognitive assessments to ensure the accuracy of your scores. You can change your preferences through your browser at any time. For assessments that are scored using eye-tracking, you must allow camera access before taking them.";
var camera_check_media_recorder_unsupported$1 = "Your browser does not support video recording. We recommend that you switch to Google Chrome or Mozilla Firefox to use this feature. Video recorded during the assessments is used to ensure the accuracy of your scores. For assessments that are scored using eye-tracking, you must allow video recording to access them.";
var camera_check_more_information$1 = "Learn more about why we record your video.";
var camera_check_not_found$1 = "Your web camera has not been detected. We recommend that you use a device with a camera to ensure the accuracy of your scores. For assessments that are scored using eye-tracking, you must have a camera to access them.";
var camera_check_pre_exam_accepted$1 = "Before you begin the assessment, please make sure your video is properly set up. We ask that you sit in a comfortable position at a desk or table with your face on camera. If needed, adjust the lighting so that your face is visible.";
var camera_check_prompt$1 = "Please allow camera access. A video preview will be shown below.";
var camera_status_accepted$1 = "Your web camera has been detected and meets the minimum technical requirements.";
var camera_status_blocked$1 = "Your web camera has not been detected. We recommend that you allow camera access so you can access all cognitive assessments and your scores can be interpreted reliably. Please check your browser preferences to update your settings.";
var camera_status_dismissed$1 = "We recommend that you allow camera access so you can access all cognitive assessments and your scores can be interpreted reliably.";
var camera_status_header$1 = "Camera and video recording status";
var camera_status_more_information$1 = "Learn more about why we record video";
var camera_status_overconstrained$1 = "Your web camera does not meet the minimum technical requirements.";
var card_body_checkup_instructions_complete$1 = "We suggest every 3 months";
var card_body_checkup_instructions_start$1 = "And get your Cognitive Report";
var card_footer_brain_animation_complete$1 = "Assessment complete!";
var card_footer_brain_animation_start$1 = "Complete a task";
var card_footer_brain_animation_state_three$1 = "Two of three tasks complete";
var card_footer_brain_animation_state_two$1 = "One of three tasks complete";
var card_results_date_last_updated$1 = "Last updated";
var card_results_interp_below_expected$1 = "Below expected";
var card_results_interp_expected$1 = "Expected";
var card_results_interp_percentile$1 = "{0}% of people your age";
var card_results_slug_better_than$1 = "You did better than...";
var card_results_slug_your_result$1 = "Your result";
var card_results_status_active$1 = "Show results";
var card_results_status_inactive$1 = "Task not completed";
var card_results_title_attention$1 = "Attention";
var card_results_title_memory$1 = "Memory";
var card_results_title_thinking$1 = "Thinking";
var card_status_exam_complete$1 = "Complete";
var card_status_exam_error$1 = "See error";
var card_status_exam_processing$1 = "Processing...";
var card_status_exam_start$1 = "Start task";
var card_title_brain_animation$1 = "Assess your brain";
var card_title_checkup_instructions_complete$1 = "Repeat tasks anytime";
var card_title_checkup_instructions_start$1 = "Complete all 3 tasks";
var card_title_exam_attention$1 = "Attention";
var card_title_exam_memory$1 = "Memory";
var card_title_exam_thinking$1 = "Thinking";
var care_category_cognitive$1 = "Most recent cognitive scores";
var care_category_lifestyle$1 = "Most recent lifestyle scores";
var care_chat_cta$1 = "Message";
var care_chat_file_error$1 = "{0} is too large";
var care_chat_file_tooltip$1 = "Attach a photo or file";
var care_chat_header$1 = "Messages";
var care_chat_no_messages$1 = "No messages yet";
var care_chat_placeholder$1 = "Type your message...";
var care_chat_see_profile$1 = "See full profile";
var care_chat_title$1 = "Chat with {0}";
var care_chat_today$1 = "Today";
var care_chat_uploading$1 = "Uploading…";
var care_general_error$1 = "An error has occurred";
var care_homepage_header$1 = "Neurotrack Care Portal";
var care_nav_home$1 = "Home";
var care_nav_logout$1 = "Log out";
var care_patient_age$1 = "Age";
var care_patient_cognitive_pathway$1 = "Cognitive Pathway";
var care_patient_creation_date$1 = "Account created on";
var care_patient_education$1 = "Level of education";
var care_patient_email$1 = "Email";
var care_patient_focus$1 = "Focus";
var care_patient_fullname$1 = "Full Name";
var care_patient_org$1 = "Partner Org";
var care_patient_profile_tab$1 = "Profile";
var care_patient_program_join_date$1 = "Joined program on";
var care_patient_program_status$1 = "Status";
var care_patient_program_title$1 = "Coaching early access";
var care_patient_race$1 = "Race";
var care_patient_scores_tab$1 = "Scores";
var care_patient_sex$1 = "Biological sex";
var care_patients_header$1 = "Patients";
var care_patients_search_button$1 = "Search";
var care_patients_search_placeholder$1 = "Search by name or email...";
var care_patients_table_email$1 = "Email";
var care_patients_table_focus$1 = "Focus";
var care_patients_table_joining_date$1 = "Joining Date";
var care_patients_table_name$1 = "Name";
var care_patients_table_no_user$1 = "No users found";
var care_patients_table_org$1 = "Partner Org";
var care_scores_filter_all$1 = "All";
var care_scores_filter_cognitive$1 = "All cognitive domains";
var care_scores_filter_date_range$1 = "Date Range";
var care_scores_filter_domain$1 = "Domain";
var care_scores_filter_last_six_months$1 = "Last six months";
var care_scores_filter_last_three_months$1 = "Last three months";
var care_scores_filter_lifestyle$1 = "All lifestyle domains";
var care_scores_filter_most_recent$1 = "Most recent";
var care_scores_filter_status$1 = "Exam Status";
var care_scores_filter_status_flagged$1 = "Flagged";
var care_scores_filter_status_incomplete$1 = "Incomplete";
var care_scores_filter_status_successful$1 = "Successful";
var care_scores_header$1 = "Assessment history";
var care_scores_table_assessment$1 = "Assessment";
var care_scores_table_bucket$1 = "Bucket";
var care_scores_table_date$1 = "Date taken";
var care_scores_table_domain$1 = "Domain measured";
var care_scores_table_id$1 = "Exam ID";
var care_scores_table_score$1 = "Score";
var care_scores_table_status$1 = "Status";
var care_users_header$1 = "Users";
var change_password_attempt_limit_exceeded$1 = "Oops, you've exceeded the attempt limits. Please try again after a few minutes.";
var change_password_body$1 = "You’ve successfully changed your password.";
var change_password_body_header$1 = "Change Password";
var change_password_body_instructions$1 = "Enter your email address, and we will email you instructions to reset your password if we confirm that you have an account.";
var change_password_close_window$1 = "Close window";
var change_password_confirm_new_password$1 = "Confirm password";
var change_password_enter_new_password_for$1 = "Your password must be at least 8 characters.";
var change_password_enter_new_password_for_personalized$1 = "Enter a new password for {0}.\nYour password must be at least 8 characters.";
var change_password_enter_password$1 = "New password";
var change_password_go_to_login$1 = "Login";
var change_password_invalid_password$1 = "Your password must be at least 8 characters";
var change_password_success_header$1 = "You've got yourself a new password.";
var chat_edited_label$1 = "(Edited)";
var coaching_start_date$1 = "Coaching Start Date";
var cognitive_training$1 = "Cognitive training";
var confirm_start_date_body$1 = "This will set the coaching start date to today. This cannot be undone.";
var confirm_start_date_title$1 = "Confirm Start Date";
var confirmation_failure_mylinkx_retry_button$1 = "Try again";
var confirmation_success_mylinkx_body$1 = "Your Neurotrack account has been successfully linked to your MyLinkX account.";
var confirmation_success_mylinkx_description$1 = "Now that your accounts are linked, your free access to the Neurotrack app is extended until June 2022. You will continue to use the Neurotrack app for free afterwards, provided that you hold an active insurance with S O M P O.";
var confirmation_success_mylinkx_header$1 = "Congratulations!";
var confirmation_success_mylinkx_next_button$1 = "Open Neurotrack";
var consent_failure_mylinkx_body$1 = "You have opted out of sharing your MyLinkX information with Neurotrack.";
var consent_failure_mylinkx_description$1 = "That prohibits us from linking your accounts.";
var consent_failure_mylinkx_retry$1 = "You can try again later by starting over.";
var contact_support_body$1 = "We designed this program to help you manage your brain health and reduce the risk of future cognitive decline. We welcome your feedback and suggestions.";
var contact_support_button$1 = "Contact support";
var contact_support_detail$1 = "If you have other questions, you can contact Neurotrack customer support at support.jp@neurotrack.com for further assistance.";
var contact_support_header$1 = "Contact support";
var coupon_body$1 = "What is your sponsored organization (insurance company) code?";
var coupon_code_placeholder$1 = "Enter a code";
var create_accounts_tab$1 = "Create accounts";
var default_language_label$1 = "Default language";
var delete_confirm_body$1 = "Deleting this message will remove it for both you and the recipient. This cannot be undone.";
var delete_confirm_title$1 = "Delete message?";
var demographics_biological_sex_1_answer$1 = "Female";
var demographics_biological_sex_2_answer$1 = "Male";
var demographics_biological_sex_field$1 = "Biological Sex";
var demographics_birthday_field$1 = "Birthday";
var demographics_education_10_answer$1 = "Doctorate degree (PhD)";
var demographics_education_1_answer$1 = "0-6 years of school";
var demographics_education_2_answer$1 = "7-9 years of school";
var demographics_education_3_answer$1 = "10-11 years of school";
var demographics_education_4_answer$1 = "High school graduate, diploma or equivalent";
var demographics_education_5_answer$1 = "Some college, no degree";
var demographics_education_6_answer$1 = "Associate degree";
var demographics_education_7_answer$1 = "Bachelor’s degree";
var demographics_education_8_answer$1 = "Master’s degree";
var demographics_education_field$1 = "Education";
var demographics_experiments_header$1 = "About Yourself";
var demographics_header$1 = "Setting up your profile";
var demographics_prompt$1 = "Please enter the following information as accurately as possible. The information gathered here is used to help generate your scores.";
var demographics_race_ethnicity_1_answer$1 = "American Indian or Alaskan Native";
var demographics_race_ethnicity_2_answer$1 = "Asian";
var demographics_race_ethnicity_3_answer$1 = "Black or African-American";
var demographics_race_ethnicity_4_answer$1 = "Hispanic or Latino";
var demographics_race_ethnicity_5_answer$1 = "Native Hawaiian or other Pacific Islander";
var demographics_race_ethnicity_6_answer$1 = "White";
var demographics_race_ethnicity_field$1 = "Race and Ethnicity";
var demographics_why_link$1 = "Why do we ask for this information?";
var description_label$1 = "Description";
var disclaimer_header$1 = "Disclaimers";
var dob_compliance_error$1 = "Please enter a valid date";
var domain_measured$1 = "Domain measured:";
var drag_drop_csv$1 = "Drag & drop CSV file or… ";
var editing_message$1 = "Editing message";
var email_address$1 = "Email address";
var email_prompt$1 = "Enter your email address";
var error_browser_viewport_body$1 = "You are unable to view the entire page currently. This may affect your performance on the cognitive assessments because some images may not be visible.  To continue, please resize your browser so that the entire page is visible.";
var error_browser_viewport_header$1 = "Please resize your browser";
var error_camera_overconstrained_body$1 = "Your camera does not meet the minimum technical requirements. We recommend that you use a camera with a resolution of 640x480 or above. Video recorded during the assessments is used to help interpret your scores. In addition, you will be unable to access assessments that use eye-tracking to calculate your scores.";
var error_camera_overconstrained_header$1 = "Camera unsupported";
var error_cookies_disabled_body$1 = "You must allow cookies to access this site. We use strictly necessary cookies to provide a quality experience. We do not use cookies to track your personal information. To continue, please enable cookies in your browser settings and try again.";
var error_cookies_disabled_header$1 = "Cookies are disabled";
var error_device_display_body$1 = "Your device screen size is too small. This may affect your performance on the cognitive assessments because some images may not be visible. We recommend using a desktop or laptop computer. To continue, please switch to a device with a larger screen size.";
var error_device_unsupported_header$1 = "Device unsupported";
var error_generic_detail$1 = "It looks like we were not able to proceed with your request. Please try refreshing this page or go through the same steps again.";
var error_generic_exam_failed_body$1 = "Please return to the homepage and try again.";
var error_generic_experiments_exam_failed$1 = "Sorry, we were unable to proceed with the task. If you accessed this task from another website, please try the link again or contact our customer support at support@neurotrack.com.";
var error_generic_header$1 = "Something's wrong";
var error_invalid_code$1 = "Sorry, this link is invalid. Please request another email.";
var error_no_user_found$1 = "Sorry, we couldn't find an account with that email address. Please try again or contact our customer support at support@neurotrack.com.";
var error_password_policy$1 = "Please use 8 characters or more for your password.";
var error_too_many_attempts$1 = "Too many failed attempts. For security reasons, please try again later.";
var error_unsupported_browser_body$1 = "You are using a browser that we do not support. To continue, please switch to one of our recommended browsers: Google Chrome, Mozilla Firefox, or Microsoft Edge.";
var error_unsupported_browser_header$1 = "Browser unsupported";
var error_unsupported_media_recorder_body$1 = "Your browser does not support video recording. We recommend that you switch to Google Chrome or Mozilla Firefox to use this feature. Video recorded during the assessments is used to help interpret your scores. In addition, you will be unable to access assessments that use eye-tracking to calculate your scores.";
var error_unsupported_media_recorder_header$1 = "Video recording unsupported";
var exam_portal_page_title_nonbranded$1 = "Cognitive Assessment Portal";
var exam_session_instructions_body$1 = "Take all of the assessments available in the Cognitive Assessments section below. Please read through the assessment instructions carefully before beginning. You will need to respond using the mouse or the keyboard, depending on the assessment. The assessments measure both speed and accuracy as part of your scores.";
var exam_session_instructions_header$1 = "Instructions";
var executive_function$1 = "Executive Function";
var exercise$1 = "Exercise";
var existing_diagnoses_answer_1$1 = "Mild cognitive impairment";
var existing_diagnoses_answer_2$1 = "Dementia";
var existing_diagnoses_answer_3$1 = "ADHD";
var existing_diagnoses_answer_4$1 = "Depression";
var existing_diagnoses_answer_5$1 = "Anxiety";
var existing_diagnoses_answer_6$1 = "Traumatic brain injury";
var existing_diagnoses_answer_7$1 = "Other neurological disorders not listed (e.g. epilepsy, MS)";
var existing_diagnoses_answer_8$1 = "Not diagnosed but I am experiencing memory loss";
var existing_diagnoses_answer_9$1 = "None of the above";
var existing_diagnoses_header$1 = "Your health status";
var existing_diagnoses_paragraph$1 = "Do you currently have any of the following diagnoses?";
var experiments_task_complete_header$1 = "Task complete!";
var experiments_task_completion_code$1 = "Your responses have been recorded. Please use this code to indicate that you have completed the task.";
var faqs_header$1 = "Frequently Asked Questions";
var faqs_link$1 = "FAQs";
var filter_no_result$1 = "No data available";
var first_name_label$1 = "First Name";
var follow_up_days_label$1 = "Follow-up days";
var forgot_password_header$1 = "Forgot Password";
var forgot_password_instructions_sompo$1 = "Start from Step2 - MyLinkX to activate your benefits after resetting your password.";
var free_trial_extension_body_download$1 = "If you haven't already, download the Neurotrack app now to get started.";
var generic_loading_message$1 = "Loading";
var generic_log_in_message$1 = "Please log in to continue";
var get_started_button$1 = "Get started";
var global_cognitive$1 = "Global cognitive score";
var global_lifestyle$1 = "Global lifestyle score";
var google_play_store$1 = "Google Play Store";
var header_account_created$1 = "Thank you for registering";
var header_login$1 = "Login to Neurotrack";
var header_register$1 = "Register";
var header_sign_in$1 = "Log in";
var header_welcome$1 = "Welcome";
var header_welcome_2$1 = "Welcome to Neurotrack!";
var implicit_learning$1 = "Implicit learning";
var inhibition$1 = "Inhibition";
var input_device_answer_1$1 = "Mouse";
var input_device_answer_2$1 = "Trackpad";
var input_device_answer_3$1 = "Touchscreen";
var input_device_header$1 = "What device are you using?";
var input_device_paragraph$1 = "You will need to use a computer for this task. (It will not work properly on a smartphone or tablet.) Please let us know if you are using a trackpad or mouse today.";
var invalid_token_mylinkx_body$1 = "Unfortunately we do not recognize the MyLinkX account you logged into. Please try again.";
var invalid_token_mylinkx_header$1 = "Authentication failed.";
var invalid_token_mylinkx_retry_button$1 = "Try again";
var landing_header$1 = "Try a quick brain exercise!";
var landing_image_pairs_header$1 = "Try Image Pairs!";
var landing_paragraph$1 = "Give your mind a workout with a brain exercise you can do in 2 minutes or less. Then enter a drawing to win a $50 Amazon gift card.";
var landing_paragraph_innovatemr$1 = "Neurotrack is building the most accurate cognitive assessments in the world. Today you’ll be helping us by trying three brain exercises. This should only take about 10 minutes. You will not receive a score as these products are still in development. Research shows that reading, doing puzzles, and playing games can help protect against cognitive decline, so it’s time well spent! \n\nDo your best and have fun!";
var landing_processing_speed_header$1 = "Try Symbol Match!";
var landing_trails_header$1 = "Try Path Points!";
var last_name_label$1 = "Last Name";
var learn_body$1 = "Learn from our experts on how you can improve your cognitive health and reduce your risk of Alzheimer’s and dementia.";
var learn_header$1 = "Learn";
var linkage_failure_another_mlx_mylinkx_body$1 = "The Neurotrack account you tried to link is already linked to another MyLinkX account.";
var linkage_failure_another_mlx_mylinkx_retry$1 = "Try again with another Neurotrack account.";
var linkage_failure_another_nt_mylinkx_body$1 = "The MyLinkX account you tried to link is already linked to another Neurotrack account.";
var linkage_failure_another_nt_mylinkx_retry$1 = "Try again with another MyLinkX account.";
var linkage_failure_mylinkx_body$1 = "We could not link your Neurotrack and MyLinkX accounts.";
var linkage_failure_mylinkx_header$1 = "Something went wrong.";
var linkage_failure_mylinkx_retry$1 = "Please try again later, or contact {0}";
var logged_out_header$1 = "You have been logged out.";
var login_loggedin_body$1 = "You're logged in as {0}.";
var login_loggedin_description$1 = "Do you want to use another Neurotrack account? Log out of this one and start over.";
var login_loggedin_header$1 = "Welcome back!";
var login_loggedin_link$1 = "Click here to continue to:";
var login_loggedin_mylinkx_body$1 = "You're already logged in as {0}.";
var login_loggedin_mylinkx_description$1 = "If you want to use another Neurotrack account, please log out of this one and start over.";
var login_loggedin_mylinkx_header$1 = "Welcome back!";
var login_loggedin_mylinkx_link$1 = "Click here if you want to link a MyLinkX account to this Neurotrack account";
var mailchimp_audience_id_label$1 = "Mailchimp audience ID";
var mailing_address$1 = "Mailing address";
var maximum_usage_label$1 = "Maximum usage";
var memory$1 = "Memory";
var minutes$1 = "minutes";
var modal_body_task_error$1 = "You need a good internet connection and charged device. ";
var modal_contact_support_body$1 = "Please contact us to ask for help or to provide feedback and suggestions. \n\nEmail us: support@neurotrack.com \n\nWrite to us: \nNeurotrack Technologies \n39 Bradford St, Ste 101\nRedwood City, CA 94063";
var modal_contact_support_title$1 = "Contact support";
var modal_cta_task_error$1 = "Try again";
var modal_log_out_prompt_cta1$1 = "Log out";
var modal_log_out_prompt_cta2$1 = "Cancel";
var modal_log_out_prompt_title$1 = "Are you sure you want to log out?";
var modal_performance_accuracy$1 = "Accuracy";
var modal_performance_speed$1 = "Speed";
var modal_pullout_performance$1 = "How it's scored";
var modal_pullout_task_error$1 = "Something went wrong";
var modal_start_task_cta$1 = "Start task";
var modal_task_pullout_attention$1 = "Attention task";
var modal_task_pullout_memory$1 = "Memory task";
var modal_task_pullout_thinking$1 = "Thinking task";
var modal_task_title_attention$1 = "Do the symbol values match?";
var modal_task_title_memory$1 = "Remember the images";
var modal_task_title_thinking$1 = "Connect dots, alternating numbers and letters";
var modal_time_attention$1 = "3 minutes";
var modal_time_memory$1 = "5 minutes";
var modal_time_thinking$1 = "2 minutes";
var modal_title_task_error$1 = "Check your connection";
var more_information_demographics_why_detail$1 = "We compare your cognitive performance to your peers who share your biological sex and age range. This is the standard for defining demographic groups in neuropsychology.";
var more_information_demographics_why_header$1 = "Why do we ask for this information?";
var more_information_video_why_detail$1 = "The video recorded during the assessments is used to help interpret your scores. For example, scores may be inaccurate if you are distracted, or if your environment is not optimal. In addition, some of our assessments leverage eye-tracking technology to determine where on the screen you are looking, which helps calculate your scores.";
var more_information_video_why_header$1 = "Why do we record your video?";
var mylinkx$1 = "MyLinkX";
var mylinkx_authentication_failure_header$1 = "Authentication failure";
var mylinkx_authentication_failure_header_body$1 = "Sorry, we do not recognize the MyLinkX account.";
var mylinkx_login_button$1 = "Log in MyLinkX";
var mylinkx_signup_button$1 = "Sign up MyLinkX";
var mylinkx_taken_failure_body$1 = "Looks like that you have already activated your benefits and have access to the Neurotrack app. If you haven’t already, download the app now to get started.";
var mylinkx_taken_failure_header$1 = "Benefits activated already";
var mylinkx_usage_qualification_failure_body$1 = "Registration not available";
var mylinkx_usage_qualification_failure_header$1 = "You need to agree to sharing your MyLinkX information with Neurotrack to be able to register with Neurotrack.";
var nav__main_learn$1 = "Learn ";
var nav_account_log_out$1 = "Log out";
var nav_account_profile$1 = "Your profile";
var nav_help_contact_support$1 = "Contact Support";
var nav_help_faq$1 = "FAQ";
var nav_help_privacy$1 = "Privacy policy";
var nav_help_terms$1 = "Terms of use";
var nav_main_account$1 = "Account";
var nav_main_checkup$1 = "Checkup";
var nav_main_help$1 = "Help";
var nav_main_results$1 = "Results ";
var not_selected$1 = "Not selected";
var nutrition$1 = "Nutrition";
var or_separator$1 = "or";
var organization_code_label$1 = "Organization code";
var organization_tab$1 = "Organization";
var page_title_checkup$1 = "Checkup";
var partner_code_label$1 = "Partner code";
var partner_codes_tab$1 = "Partner codes";
var processing_message_mylinkx_body$1 = "We are processing your Neurotrack and MyLinkX accounts.";
var processing_message_mylinkx_header$1 = "Linking your accounts...";
var processing_speed$1 = "Processing speed";
var profile_link$1 = "Your profile";
var read_receipt_label$1 = "Read";
var read_receipt_tooltip$1 = "Read by {0} at {1}";
var recognition_memory$1 = "Recognition memory";
var redirect_mylinx_signin$1 = "You will be redirected to MyLinkX authentication page shortly. Thank you for you patience!";
var redirecting_body$1 = "Thank you for logging into your Neurotrack account.";
var redirecting_description$1 = "We will now redirect you to:";
var redirecting_header$1 = "Redirecting...";
var redirecting_link$1 = "Click here if you are not redirected within 2 seconds";
var redirecting_mylinkx_body$1 = "Thank you for logging into your Neurotrack account.";
var redirecting_mylinkx_description$1 = "We will now redirect you to log in to your MyLinkX account.";
var redirecting_mylinkx_header$1 = "Redirecting you to MyLinkX...";
var redirecting_mylinkx_link$1 = "Click here if you are not redirected within 2 seconds";
var register_body_agreement$1 = "By signing up you agree to Neurotrack's {0} and {1}.";
var register_body_disclaimer_header$1 = "Disclaimer";
var register_body_disclaimer_para$1 = "This service is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.";
var register_body_pp_link$1 = "privacy policy";
var register_body_tos_link$1 = "terms of service";
var register_email_placeholder$1 = "Email address";
var register_firstname_placeholder$1 = "Please enter your first name.";
var register_lastname_placeholder$1 = "Please enter your last name.";
var register_login_email_compliance_error$1 = "Please enter a valid email address.";
var register_marketing_radio_yes$1 = "I agree to receive marketing communications from Neurotrack.";
var register_marketing_radio_yes_with_partner$1 = "I agree to receive marketing communications from Neurotrack and {0}.";
var register_password_compliance_error$1 = "Password must contain at least 8 characters.";
var register_password_hint$1 = "Your password must contain at least 8 characters";
var register_password_match_error$1 = "Passwords do not match.";
var register_password_placeholder$1 = "Password";
var register_scores_sharing_radio_yes$1 = "I agree to share my scores with {0}.";
var register_terms_and_privacy_policy_checkbox$1 = "I agree to Neurotrack's {0} and {1}.";
var register_terms_and_privacy_policy_detail$1 = "Please check the box to give your consent.";
var registration_in_progress_wait$1 = "Please wait while we complete your registration";
var required_consent_intro$1 = "Please read and agree to the following consent to continue with your session. If you do not agree you will be logged out of your account.";
var reset_password_body$1 = "If the above button doesn’t work for you, copy & paste this link into your browser’s address bar:\nhttps://app-dev.neurotrack.com/change-password?code=864849&username=9e2a0bae-f889-4869-a3e6-c2f18deffe07";
var reset_password_button$1 = "Reset password";
var reset_password_title$1 = "Hello [name], let's reset your password.";
var screen_onboarding_button_continue$1 = "Continue";
var screen_onboarding_button_create_account$1 = "Create account";
var screen_onboarding_button_getstarted$1 = "Get started";
var screen_onboarding_button_large_login$1 = "Log in";
var screen_onboarding_button_skip$1 = "Skip";
var screen_onboarding_button_small_login$1 = "Log in";
var screen_onboarding_code_error$1 = "That access code did not work. Please try again. ";
var screen_onboarding_code_example$1 = "Example: AABBCCNT1";
var screen_onboarding_code_example_mobile$1 = "e.g.: AABBCCNT1";
var screen_onboarding_code_intro$1 = "Enter the access code you received. \nCan't find it? Contact support.";
var screen_onboarding_code_slug$1 = "Access code";
var screen_onboarding_code_title$1 = "What's your access code? ";
var screen_onboarding_dob_example_day$1 = "DD";
var screen_onboarding_dob_example_year$1 = "YYYY";
var screen_onboarding_dob_intro$1 = "We use this information in scoring your assessment.";
var screen_onboarding_dob_month_dropdown_1$1 = "Select an option";
var screen_onboarding_dob_month_dropdown_10$1 = "September";
var screen_onboarding_dob_month_dropdown_11$1 = "October";
var screen_onboarding_dob_month_dropdown_12$1 = "November";
var screen_onboarding_dob_month_dropdown_13$1 = "December";
var screen_onboarding_dob_month_dropdown_2$1 = "January";
var screen_onboarding_dob_month_dropdown_3$1 = "February";
var screen_onboarding_dob_month_dropdown_4$1 = "March";
var screen_onboarding_dob_month_dropdown_5$1 = "April";
var screen_onboarding_dob_month_dropdown_6$1 = "May";
var screen_onboarding_dob_month_dropdown_7$1 = "June";
var screen_onboarding_dob_month_dropdown_8$1 = "July";
var screen_onboarding_dob_month_dropdown_9$1 = "August";
var screen_onboarding_dob_race_intro$1 = "";
var screen_onboarding_dob_slug_day$1 = "Day (DD)";
var screen_onboarding_dob_slug_month$1 = "Month";
var screen_onboarding_dob_slug_year$1 = "Year (YYYY)";
var screen_onboarding_dob_title$1 = "What's your date of birth?";
var screen_onboarding_education_dropdown$1 = "Select an option";
var screen_onboarding_education_dropdown_1$1 = "0-6 years of school ";
var screen_onboarding_education_dropdown_10$1 = "Doctorate degree (PhD)";
var screen_onboarding_education_dropdown_2$1 = "7-9 years of school";
var screen_onboarding_education_dropdown_3$1 = "10-11 years of school ";
var screen_onboarding_education_dropdown_4$1 = "High school graduate, diploma or equivalent";
var screen_onboarding_education_dropdown_5$1 = "Some college, no degree";
var screen_onboarding_education_dropdown_6$1 = "Associate degree";
var screen_onboarding_education_dropdown_7$1 = "Bachelor's degree";
var screen_onboarding_education_dropdown_8$1 = "Master's degree";
var screen_onboarding_education_dropdown_9$1 = "Professional degree (MD, JD)";
var screen_onboarding_education_intro$1 = "This information helps us ensure our product is reaching underrepresented groups.";
var screen_onboarding_education_title$1 = "What's the highest level of education you completed? ";
var screen_onboarding_email_intro$1 = "You will use your email address to log in.";
var screen_onboarding_email_optin_marketing$1 = "I want to receive news and helpful tips from Neurotrack.";
var screen_onboarding_email_optin_tospp$1 = "I agree to the terms of service and privacy policy.";
var screen_onboarding_email_slug$1 = "Email address";
var screen_onboarding_email_title$1 = "What's your email address? ";
var screen_onboarding_home_intro$1 = "Test your cognitive health at home and take action to stay sharp.";
var screen_onboarding_home_subhead_registered$1 = "Already have an account?";
var screen_onboarding_home_title$1 = "Protect your mind and your memories";
var screen_onboarding_login_example_email$1 = "Enter email address";
var screen_onboarding_login_example_password$1 = "Enter your password";
var screen_onboarding_login_link_forgot$1 = "Forgot your password?";
var screen_onboarding_login_slug_email$1 = "Email address";
var screen_onboarding_login_slug_password$1 = "Password";
var screen_onboarding_login_subtitle_no_account$1 = "Don't have an account yet? ";
var screen_onboarding_login_title$1 = "Log in to your account";
var screen_onboarding_name_example_first$1 = "Enter first name";
var screen_onboarding_name_example_last$1 = "Enter last name";
var screen_onboarding_name_slug_first$1 = "First name";
var screen_onboarding_name_slug_last$1 = "Last name";
var screen_onboarding_name_title$1 = "What's your name?";
var screen_onboarding_password_example$1 = "Enter your password";
var screen_onboarding_password_example_confirm$1 = "Re-enter password";
var screen_onboarding_password_intro$1 = "Choose something easy to remember with at least 8 characters. (Write down your password to keep it handy.) ";
var screen_onboarding_password_slug$1 = "Password";
var screen_onboarding_password_slug_confirm$1 = "Confirm password";
var screen_onboarding_password_title$1 = "Create a password";
var screen_onboarding_race_dropdown$1 = "Select an option";
var screen_onboarding_race_dropdown_1$1 = "American Indian or Alaskan Native";
var screen_onboarding_race_dropdown_2$1 = "Asian";
var screen_onboarding_race_dropdown_3$1 = "Black or African-American";
var screen_onboarding_race_dropdown_4$1 = "Hispanic or Latino";
var screen_onboarding_race_dropdown_5$1 = "Native Hawaiian or other Pacific Islander";
var screen_onboarding_race_dropdown_6$1 = "White";
var screen_onboarding_race_intro$1 = "This information helps us ensure our product is reaching underrepresented groups.";
var screen_onboarding_race_title$1 = "What's your race or ethnicity? ";
var screen_onboarding_race_title_short$1 = "What's your race? ";
var screen_onboarding_reason_intro$1 = "Select all that apply.";
var screen_onboarding_reason_option1$1 = "I am curious to learn about my cognitive health";
var screen_onboarding_reason_option2$1 = "I'm noticing changes in my thinking or memory";
var screen_onboarding_reason_option3$1 = "Alzheimer's or dementia runs in my family";
var screen_onboarding_reason_option4$1 = "I have another reason or I prefer not to say";
var screen_onboarding_reason_title$1 = "What brings you here today? ";
var screen_onboarding_sex_dropdown$1 = "Select an option";
var screen_onboarding_sex_dropdown_1$1 = "Female";
var screen_onboarding_sex_dropdown_2$1 = "Male";
var screen_onboarding_sex_intro$1 = "We use this information in scoring your assessment.";
var screen_onboarding_sex_title$1 = "What was your sex assigned at birth?";
var screen_results_button_close$1 = "Close";
var screen_results_button_continue$1 = "Continue";
var screen_results_button_see_details$1 = "See details";
var screen_results_measure_explanation_associative_learning_bullet1$1 = "Pairing the face and name of a new friend";
var screen_results_measure_explanation_associative_learning_bullet2$1 = "Learning to duck under a low branch";
var screen_results_measure_explanation_associative_learning_bullet3$1 = "Picking up the word for \"thank you\" in a new language";
var screen_results_measure_explanation_associative_learning_intro$1 = "Your ability to form new associations between items or concepts.";
var screen_results_measure_explanation_associative_memory_bullet1$1 = "Remembering the name of someone you recently met";
var screen_results_measure_explanation_associative_memory_bullet2$1 = "Recognizing a certain row of houses as your neighborhood";
var screen_results_measure_explanation_associative_memory_bullet3$1 = "Recalling which remote goes with which device";
var screen_results_measure_explanation_associative_memory_intro$1 = "Your ability to recall how things relate to each other.";
var screen_results_measure_explanation_attention$1 = "We ask you to figure out if symbols represent equal values, according to the legend.\n\nTaking in this information, making a decision, and responding quickly requires good <strong>processing speed</strong>. This type of attention helps you react to changes in your surroundings and interact with others.";
var screen_results_measure_explanation_executive_function_bullet1$1 = "Getting yourself ready for an appointment";
var screen_results_measure_explanation_executive_function_bullet2$1 = "Planning and taking a trip";
var screen_results_measure_explanation_executive_function_bullet3$1 = "Doing the laundry";
var screen_results_measure_explanation_executive_function_intro$1 = "Your ability to plan and organize tasks and make decisions.";
var screen_results_measure_explanation_memory$1 = "Using eye-tracking technology we follow your gaze and measure how much time you spend looking at images you have and have not seen before. Later, we see if you can correctly identify pairs of images.\n\nThis task measures <strong>associative learning</strong> and <strong>associative memory</strong>. These memory skills help you take in and recall information. ";
var screen_results_measure_explanation_processing_speed_bullet1$1 = "Hitting the breaks when a car in front of you stops";
var screen_results_measure_explanation_processing_speed_bullet2$1 = "Removing food when the over timer beeps";
var screen_results_measure_explanation_processing_speed_bullet3$1 = "Responding to a stranger's greeting";
var screen_results_measure_explanation_processing_speed_intro$1 = "The rate at which you take in information, consider it, and respond.";
var screen_results_measure_explanation_thinking$1 = "We ask you to connect dots in a sequence, 1-A, 2-B, and so on, as quickly as you can.\n\nJuggling the requirements of this task in your mind uses something called <strong>executive function</strong>. It’s a thinking skill you need to manage simple chores and big projects.";
var screen_results_measure_explanation_title_associative_learning$1 = "1. Associative learning";
var screen_results_measure_explanation_title_associative_memory$1 = "2. Associative memory";
var screen_results_measure_explanation_title_executive_function$1 = "Executive function";
var screen_results_measure_explanation_title_processing_speed$1 = "Processing speed";
var screen_results_measure_title_attention$1 = "How do we measure Attention? ";
var screen_results_measure_title_memory$1 = "How do we measure Memory?";
var screen_results_measure_title_thinking$1 = "How do we measure Thinking?";
var screen_results_subtitle_learn_more$1 = "Learn more about this task";
var screen_results_title_attention$1 = "Attention task results";
var screen_results_title_memory$1 = "Memory task results";
var screen_results_title_task$1 = "View result history by task:";
var screen_results_title_thinking$1 = "Thinking task results";
var search_no_result$1 = "No matching records found";
var session_timeout_body$1 = "You will be automatically logged out due to inactivity soon.";
var session_timeout_header$1 = "Your session is about to expire";
var sign_in_body_nonbranded$1 = "Log in to your account to begin your session";
var sign_in_body_sign_in$1 = "Log in to your Neurotrack account";
var sign_in_email_prompt$1 = "Enter your email address";
var sign_in_password_prompt$1 = "Enter your password";
var sleep$1 = "Sleep";
var social_engagement$1 = "Social engagement";
var sompo_email_link$1 = "support.jp@neurotrack.com";
var sompo_registration_instructions_body$1 = "Neurotrack partners with Sompo Himawari Life to provide cognitive evaluations and brain-healthy recommendations. Follow the three steps to activate Neurotrack and start managing your brain.";
var sompo_registration_instructions_header$1 = "Activate Benefits For Your Brain";
var sompo_registration_instructions_mylinkx_login_prompt$1 = "If you have a MyLinkX account";
var sompo_registration_instructions_mylinkx_signup_prompt$1 = "If you do not have a MyLinkX account";
var sompo_registration_instructions_step1_detail$1 = "To ensure a smooth communication with Neurotrack, please go to your email and add braincare@neurotrack.com to your safe sender list.";
var sompo_registration_instructions_step1_header$1 = "Add Neurotrack as your email contact";
var sompo_registration_instructions_step2_detail$1 = "This is required to register to Neurotrack.";
var sompo_registration_instructions_step2_header$1 = "Log in to MyLinkX to access your benefits";
var sompo_registration_instructions_step3_header$1 = "Create an account with Neurotrack";
var spatial_working_memory$1 = "Spatial working memory";
var start_button$1 = "Click here to start";
var start_exam_button$1 = "Begin Assessment";
var start_over_registration_button$1 = "Start again";
var stress$1 = "Stress";
var title_label$1 = "Title";
var title_registration$1 = "Neurotrack Registration";
var title_registration_sompo$1 = "Neurotrack SOMPO Registration";
var tooltip_more$1 = "More";
var visit_website_for_more$1 = "For more information, please visit our website at neurotrack.com.";
var watch_to_expect_profile_body$1 = "You will fill out basic demographic information so that your assessments can be scored. Your performance on the assessments will be compared to other people most similar to you.";
var watch_to_expect_profile_header$1 = "Profile setup";
var web_learn_source_button$1 = "See source";
var welcome_body_confirm_password_placeholder$1 = "Password";
var welcome_body_email_placeholder$1 = "Email address";
var welcome_body_login$1 = "Log in to your Neurotrack account";
var welcome_body_login_mylinkx$1 = "Please log in to your Neurotrack account to connect it to your MyLinkX account.";
var welcome_body_login_sompo$1 = "Good job on successfully completing Step 1 - MyLinkX. Please sign in with your Neurotrack account (Step 2) to continue your benefit activation.";
var welcome_body_password_placeholder$1 = "Password";
var welcome_body_register$1 = "Sign up for a Neurotrack account";
var welcome_body_register_sompo$1 = "Register a Neurotrack account to access the benefits";
var welcome_help_body$1 = "Don’t have a code or not a Sompo customer? Don’t worry. We got you covered. Please contact support@neurotrack.com to get started.";
var welcome_partner_body$1 = "Create an account to start to measure your cognitive health, and receive recommendations to make impactful changes to manage your brain.";
var welcome_partner_body_new$1 = "It’s never too late to start looking after your brain. Here at Neurotrack, you can assess, monitor, and strengthen your brain health.";
var welcome_sompo_body$1 = "For Sompo customers and MyLinkX users";
var what_to_expect_assessments_body$1 = "You’ll be taken to your dashboard where you’ll see instructions on what to do and any available assessments to take.";
var what_to_expect_assessments_header$1 = "Assessment session";
var what_to_expect_camera_check_body$1 = "We will ask you for access to your web camera --- you can update your preferences through your browser at any time. We will provide information on why we ask to record video during your Assessment session; please read through the information thoroughly.";
var what_to_expect_camera_check_header$1 = "Web camera check";
var what_to_expect_header$1 = "What to expect";
var what_to_expect_intro$1 = "Before you begin your Assessment session, there are a couple steps to take:";
var what_to_expect_welcome$1 = "Welcome to your Cognitive Assessment Portal!";
var you_are_logged_in_as$1 = "You are logged in as";
var en = {
	arrow_match_button_continue: arrow_match_button_continue$1,
	arrow_match_button_left_web: arrow_match_button_left_web$1,
	arrow_match_button_right_web: arrow_match_button_right_web$1,
	arrow_match_conclusion_1_heading: arrow_match_conclusion_1_heading$1,
	arrow_match_intro_1_heading: arrow_match_intro_1_heading$1,
	arrow_match_intro_1_paragraph: arrow_match_intro_1_paragraph$1,
	arrow_match_phase_1_intro_1: arrow_match_phase_1_intro_1$1,
	arrow_match_phase_1_intro_2: arrow_match_phase_1_intro_2$1,
	arrow_match_phase_1_intro_2_web: arrow_match_phase_1_intro_2_web$1,
	arrow_match_phase_1_intro_3: arrow_match_phase_1_intro_3$1,
	arrow_match_phase_1_intro_3_web: arrow_match_phase_1_intro_3_web$1,
	arrow_match_phase_1_intro_4: arrow_match_phase_1_intro_4$1,
	arrow_match_phase_1_intro_4_web: arrow_match_phase_1_intro_4_web$1,
	arrow_match_phase_1_intro_5_web: arrow_match_phase_1_intro_5_web$1,
	arrow_match_phase_1_intro_6_header_web: arrow_match_phase_1_intro_6_header_web$1,
	arrow_match_phase_1_intro_6_web: arrow_match_phase_1_intro_6_web$1,
	arrow_match_phase_1_start_1: arrow_match_phase_1_start_1$1,
	arrow_match_phase_1_start_1_header: arrow_match_phase_1_start_1_header$1,
	arrow_match_phase_1_start_2: arrow_match_phase_1_start_2$1,
	arrow_match_start_practice: arrow_match_start_practice$1,
	arrow_match_start_practice_web: arrow_match_start_practice_web$1,
	arrow_match_title: arrow_match_title$1,
	arrow_match_tutorial_feedback_body_left_web: arrow_match_tutorial_feedback_body_left_web$1,
	arrow_match_tutorial_feedback_body_right_web: arrow_match_tutorial_feedback_body_right_web$1,
	arrow_match_tutorial_feedback_header_correct: arrow_match_tutorial_feedback_header_correct$1,
	arrow_match_tutorial_feedback_header_incorrect: arrow_match_tutorial_feedback_header_incorrect$1,
	demographics_age_heading: demographics_age_heading$1,
	demographics_biological_sex_answer_1: demographics_biological_sex_answer_1$1,
	demographics_biological_sex_answer_2: demographics_biological_sex_answer_2$1,
	demographics_biological_sex_heading: demographics_biological_sex_heading$1,
	demographics_button_label: demographics_button_label$1,
	demographics_education_answer_1: demographics_education_answer_1$1,
	demographics_education_answer_10: demographics_education_answer_10$1,
	demographics_education_answer_2: demographics_education_answer_2$1,
	demographics_education_answer_3: demographics_education_answer_3$1,
	demographics_education_answer_4: demographics_education_answer_4$1,
	demographics_education_answer_5: demographics_education_answer_5$1,
	demographics_education_answer_6: demographics_education_answer_6$1,
	demographics_education_answer_7: demographics_education_answer_7$1,
	demographics_education_answer_8: demographics_education_answer_8$1,
	demographics_education_answer_9: demographics_education_answer_9$1,
	demographics_education_heading: demographics_education_heading$1,
	demographics_paragraph: demographics_paragraph$1,
	demographics_race_ethnicity_answer_1: demographics_race_ethnicity_answer_1$1,
	demographics_race_ethnicity_answer_2: demographics_race_ethnicity_answer_2$1,
	demographics_race_ethnicity_answer_3: demographics_race_ethnicity_answer_3$1,
	demographics_race_ethnicity_answer_4: demographics_race_ethnicity_answer_4$1,
	demographics_race_ethnicity_answer_5: demographics_race_ethnicity_answer_5$1,
	demographics_race_ethnicity_answer_6: demographics_race_ethnicity_answer_6$1,
	demographics_race_ethnicity_heading: demographics_race_ethnicity_heading$1,
	demographics_worker_id_heading: demographics_worker_id_heading$1,
	demographics_worker_id_prompt: demographics_worker_id_prompt$1,
	exam_complete_mturk_body: exam_complete_mturk_body$1,
	exam_complete_mturk_error_body: exam_complete_mturk_error_body$1,
	exam_complete_mturk_error_header: exam_complete_mturk_error_header$1,
	exam_complete_mturk_header: exam_complete_mturk_header$1,
	exam_instructions_header: exam_instructions_header$1,
	exam_practice_header: exam_practice_header$1,
	exam_start_exam_button_label: exam_start_exam_button_label$1,
	exam_start_practice_button_label: exam_start_practice_button_label$1,
	exam_start_practice_header: exam_start_practice_header$1,
	experiments_arrow_match_button_correct: experiments_arrow_match_button_correct$1,
	experiments_arrow_match_button_incorrect: experiments_arrow_match_button_incorrect$1,
	experiments_arrow_match_pre_practice_1: experiments_arrow_match_pre_practice_1$1,
	experiments_mouse_arrow_match_phase_1_intro_3_web: experiments_mouse_arrow_match_phase_1_intro_3_web$1,
	experiments_mouse_arrow_match_phase_1_intro_4_web: experiments_mouse_arrow_match_phase_1_intro_4_web$1,
	experiments_timer_arrow_match_post_practice: experiments_timer_arrow_match_post_practice$1,
	experiments_timer_arrow_match_start_practice_web: experiments_timer_arrow_match_start_practice_web$1,
	flanker_prepractice_button_label: flanker_prepractice_button_label$1,
	flanker_prepractice_description: flanker_prepractice_description$1,
	flanker_prepractice_title: flanker_prepractice_title$1,
	go_no_go_button_continue: go_no_go_button_continue$1,
	go_no_go_conclusion_1_heading: go_no_go_conclusion_1_heading$1,
	go_no_go_feedback_body_early: go_no_go_feedback_body_early$1,
	go_no_go_feedback_body_early_web: go_no_go_feedback_body_early_web$1,
	go_no_go_feedback_body_go_correct: go_no_go_feedback_body_go_correct$1,
	go_no_go_feedback_body_go_correct_web: go_no_go_feedback_body_go_correct_web$1,
	go_no_go_feedback_body_go_incorrect: go_no_go_feedback_body_go_incorrect$1,
	go_no_go_feedback_body_go_incorrect_web: go_no_go_feedback_body_go_incorrect_web$1,
	go_no_go_feedback_body_no_go_correct: go_no_go_feedback_body_no_go_correct$1,
	go_no_go_feedback_body_no_go_correct_web: go_no_go_feedback_body_no_go_correct_web$1,
	go_no_go_feedback_body_no_go_incorrect: go_no_go_feedback_body_no_go_incorrect$1,
	go_no_go_feedback_body_no_go_incorrect_web: go_no_go_feedback_body_no_go_incorrect_web$1,
	go_no_go_feedback_header_correct: go_no_go_feedback_header_correct$1,
	go_no_go_feedback_header_early: go_no_go_feedback_header_early$1,
	go_no_go_feedback_header_incorrect: go_no_go_feedback_header_incorrect$1,
	go_no_go_intro_1_heading: go_no_go_intro_1_heading$1,
	go_no_go_intro_1_paragraph: go_no_go_intro_1_paragraph$1,
	go_no_go_phase_1_intro_1: go_no_go_phase_1_intro_1$1,
	go_no_go_phase_1_intro_1_web: go_no_go_phase_1_intro_1_web$1,
	go_no_go_phase_1_intro_2: go_no_go_phase_1_intro_2$1,
	go_no_go_phase_1_intro_2_web: go_no_go_phase_1_intro_2_web$1,
	go_no_go_phase_1_intro_3: go_no_go_phase_1_intro_3$1,
	go_no_go_phase_1_intro_3_web: go_no_go_phase_1_intro_3_web$1,
	go_no_go_phase_1_start_body: go_no_go_phase_1_start_body$1,
	go_no_go_phase_1_start_body_web: go_no_go_phase_1_start_body_web$1,
	go_no_go_phase_1_start_header: go_no_go_phase_1_start_header$1,
	go_no_go_response_button_web: go_no_go_response_button_web$1,
	go_no_go_start_practice: go_no_go_start_practice$1,
	go_no_go_start_practice_web: go_no_go_start_practice_web$1,
	go_no_go_title: go_no_go_title$1,
	image_pairs_button_continue: image_pairs_button_continue$1,
	image_pairs_title: image_pairs_title$1,
	instructions_heading: instructions_heading$1,
	item_price_button_continue: item_price_button_continue$1,
	item_price_button_no_web: item_price_button_no_web$1,
	item_price_button_yes_web: item_price_button_yes_web$1,
	item_price_phase_1_end: item_price_phase_1_end$1,
	item_price_phase_1_end_body: item_price_phase_1_end_body$1,
	item_price_phase_1_intro_1: item_price_phase_1_intro_1$1,
	item_price_phase_1_intro_2: item_price_phase_1_intro_2$1,
	item_price_phase_1_intro_3: item_price_phase_1_intro_3$1,
	item_price_phase_1_intro_3_price: item_price_phase_1_intro_3_price$1,
	item_price_phase_1_intro_4: item_price_phase_1_intro_4$1,
	item_price_phase_1_intro_4_price: item_price_phase_1_intro_4_price$1,
	item_price_phase_1_intro_5_button: item_price_phase_1_intro_5_button$1,
	item_price_phase_1_intro_5_web: item_price_phase_1_intro_5_web$1,
	item_price_phase_2_intro_1: item_price_phase_2_intro_1$1,
	item_price_phase_2_intro_2_web: item_price_phase_2_intro_2_web$1,
	item_price_phase_2_intro_3_web: item_price_phase_2_intro_3_web$1,
	item_price_phase_2_intro_4_web: item_price_phase_2_intro_4_web$1,
	item_price_phase_2_intro_5: item_price_phase_2_intro_5$1,
	item_price_phase_2_intro_6_button: item_price_phase_2_intro_6_button$1,
	item_price_phase_2_intro_6_web: item_price_phase_2_intro_6_web$1,
	item_price_phase_2_trial_prompt: item_price_phase_2_trial_prompt$1,
	item_price_title: item_price_title$1,
	"nt-currency-label": "$",
	"nt-paired-item-price-multiply-factor": "1",
	path_points_button_continue: path_points_button_continue$1,
	path_points_conclusion_1_heading: path_points_conclusion_1_heading$1,
	path_points_intro_1_paragraph: path_points_intro_1_paragraph$1,
	path_points_node_a: path_points_node_a$1,
	path_points_node_b: path_points_node_b$1,
	path_points_node_c: path_points_node_c$1,
	path_points_node_d: path_points_node_d$1,
	path_points_node_e: path_points_node_e$1,
	path_points_node_f: path_points_node_f$1,
	path_points_node_g: path_points_node_g$1,
	path_points_phase_1_intro_1: path_points_phase_1_intro_1$1,
	path_points_phase_1_intro_2: path_points_phase_1_intro_2$1,
	path_points_phase_1_intro_2_web: path_points_phase_1_intro_2_web$1,
	path_points_phase_1_intro_3: path_points_phase_1_intro_3$1,
	path_points_phase_1_intro_3_alternate: path_points_phase_1_intro_3_alternate$1,
	path_points_phase_1_intro_3_web: path_points_phase_1_intro_3_web$1,
	path_points_phase_1_start_body: path_points_phase_1_start_body$1,
	path_points_phase_1_start_header: path_points_phase_1_start_header$1,
	path_points_start_practice: path_points_start_practice$1,
	path_points_title: path_points_title$1,
	path_points_tutorial_incorrect_body: path_points_tutorial_incorrect_body$1,
	path_points_tutorial_incorrect_header: path_points_tutorial_incorrect_header$1,
	path_points_tutorial_prompt: path_points_tutorial_prompt$1,
	path_points_tutorial_prompt_web: path_points_tutorial_prompt_web$1,
	symbol_match_button_continue: symbol_match_button_continue$1,
	symbol_match_button_equal: symbol_match_button_equal$1,
	symbol_match_button_equal_web: symbol_match_button_equal_web$1,
	symbol_match_button_unequal: symbol_match_button_unequal$1,
	symbol_match_button_unequal_web: symbol_match_button_unequal_web$1,
	symbol_match_phase_1_intro_1: symbol_match_phase_1_intro_1$1,
	symbol_match_phase_1_intro_2: symbol_match_phase_1_intro_2$1,
	symbol_match_phase_1_intro_3: symbol_match_phase_1_intro_3$1,
	symbol_match_phase_1_intro_4: symbol_match_phase_1_intro_4$1,
	symbol_match_phase_1_intro_5_web: symbol_match_phase_1_intro_5_web$1,
	symbol_match_phase_1_intro_6_web: symbol_match_phase_1_intro_6_web$1,
	symbol_match_phase_1_intro_7_web: symbol_match_phase_1_intro_7_web$1,
	symbol_match_phase_1_start_header: symbol_match_phase_1_start_header$1,
	symbol_match_phase_1_start_web: symbol_match_phase_1_start_web$1,
	symbol_match_title: symbol_match_title$1,
	symbol_match_tutorial_1_paragraph_web: symbol_match_tutorial_1_paragraph_web$1,
	symbol_match_tutorial_2_paragraph_web: symbol_match_tutorial_2_paragraph_web$1,
	symbol_match_tutorial_3_paragraph_web: symbol_match_tutorial_3_paragraph_web$1,
	symbol_match_tutorial_correct_heading: symbol_match_tutorial_correct_heading$1,
	symbol_match_tutorial_incorrect_heading: symbol_match_tutorial_incorrect_heading$1,
	web_button_next: web_button_next$1,
	web_button_previous: web_button_previous$1,
	account_created_body_confirmation: account_created_body_confirmation$1,
	account_created_body_confirmation_webuser: account_created_body_confirmation_webuser$1,
	account_created_verification_instructions_body: account_created_verification_instructions_body$1,
	account_created_verification_instructions_body_webuser: account_created_verification_instructions_body_webuser$1,
	account_link: account_link$1,
	alert_action_ok: alert_action_ok$1,
	alert_body_expired_coupon: alert_body_expired_coupon$1,
	alert_body_invalid_coupon: alert_body_invalid_coupon$1,
	alert_bulk_create_account_success: alert_bulk_create_account_success$1,
	alert_forgot_password_body_confirm: alert_forgot_password_body_confirm$1,
	alert_forgot_password_body_header: alert_forgot_password_body_header$1,
	alert_header_forgot_password: alert_header_forgot_password$1,
	alert_header_invalid_coupon: alert_header_invalid_coupon$1,
	alert_header_invalid_login: alert_header_invalid_login$1,
	alert_header_reg_error: alert_header_reg_error$1,
	alert_invalid_extension: alert_invalid_extension$1,
	alert_invalid_login_body: alert_invalid_login_body$1,
	alert_invalid_login_email: alert_invalid_login_email$1,
	alert_reg_error_body: alert_reg_error_body$1,
	alert_session_expired: alert_session_expired$1,
	alert_unsupported_media_recorder: alert_unsupported_media_recorder$1,
	apple_app_store: apple_app_store$1,
	assessment_processing: assessment_processing$1,
	assessment_unavailable_camera_body: assessment_unavailable_camera_body$1,
	assessment_unavailable_camera_header: assessment_unavailable_camera_header$1,
	assessments_available_body: assessments_available_body$1,
	assessments_available_empty_body: assessments_available_empty_body$1,
	assessments_available_header: assessments_available_header$1,
	assessments_history_empty_body: assessments_history_empty_body$1,
	assessments_history_header: assessments_history_header$1,
	assessments_history_table_assessment_header: assessments_history_table_assessment_header$1,
	assessments_history_table_bucket_header: assessments_history_table_bucket_header$1,
	assessments_history_table_date_header: assessments_history_table_date_header$1,
	assessments_history_table_domain_header: assessments_history_table_domain_header$1,
	assessments_history_table_percentile_header: assessments_history_table_percentile_header$1,
	assessments_history_with_scores_empty_body: assessments_history_with_scores_empty_body$1,
	associative_learning: associative_learning$1,
	associative_memory: associative_memory$1,
	attention: attention$1,
	available_exams_label: available_exams_label$1,
	back_to_faqs: back_to_faqs$1,
	browser_tab_title: browser_tab_title$1,
	button_agree: button_agree$1,
	button_back_to_assessments: button_back_to_assessments$1,
	button_cancel: button_cancel$1,
	button_check_camera: button_check_camera$1,
	button_close: button_close$1,
	button_continue: button_continue$1,
	button_continue_session: button_continue_session$1,
	button_delete: button_delete$1,
	button_disagree: button_disagree$1,
	button_edit: button_edit$1,
	button_forgot_password: button_forgot_password$1,
	button_forgot_password_log_in: button_forgot_password_log_in$1,
	button_go_back: button_go_back$1,
	button_learn_more: button_learn_more$1,
	button_login: button_login$1,
	button_open_app: button_open_app$1,
	button_register: button_register$1,
	button_save: button_save$1,
	button_set: button_set$1,
	button_sign_in: button_sign_in$1,
	button_sign_out: button_sign_out$1,
	button_sign_up: button_sign_up$1,
	button_skip: button_skip$1,
	button_submit: button_submit$1,
	button_try_again: button_try_again$1,
	camera_check_button_continue_with: camera_check_button_continue_with$1,
	camera_check_button_continue_without: camera_check_button_continue_without$1,
	camera_check_header: camera_check_header$1,
	camera_check_intro: camera_check_intro$1,
	camera_check_media_recorder_unsupported: camera_check_media_recorder_unsupported$1,
	camera_check_more_information: camera_check_more_information$1,
	camera_check_not_found: camera_check_not_found$1,
	camera_check_pre_exam_accepted: camera_check_pre_exam_accepted$1,
	camera_check_prompt: camera_check_prompt$1,
	camera_status_accepted: camera_status_accepted$1,
	camera_status_blocked: camera_status_blocked$1,
	camera_status_dismissed: camera_status_dismissed$1,
	camera_status_header: camera_status_header$1,
	camera_status_more_information: camera_status_more_information$1,
	camera_status_overconstrained: camera_status_overconstrained$1,
	card_body_checkup_instructions_complete: card_body_checkup_instructions_complete$1,
	card_body_checkup_instructions_start: card_body_checkup_instructions_start$1,
	card_footer_brain_animation_complete: card_footer_brain_animation_complete$1,
	card_footer_brain_animation_start: card_footer_brain_animation_start$1,
	card_footer_brain_animation_state_three: card_footer_brain_animation_state_three$1,
	card_footer_brain_animation_state_two: card_footer_brain_animation_state_two$1,
	card_results_date_last_updated: card_results_date_last_updated$1,
	card_results_interp_below_expected: card_results_interp_below_expected$1,
	card_results_interp_expected: card_results_interp_expected$1,
	card_results_interp_percentile: card_results_interp_percentile$1,
	card_results_slug_better_than: card_results_slug_better_than$1,
	card_results_slug_your_result: card_results_slug_your_result$1,
	card_results_status_active: card_results_status_active$1,
	card_results_status_inactive: card_results_status_inactive$1,
	card_results_title_attention: card_results_title_attention$1,
	card_results_title_memory: card_results_title_memory$1,
	card_results_title_thinking: card_results_title_thinking$1,
	card_status_exam_complete: card_status_exam_complete$1,
	card_status_exam_error: card_status_exam_error$1,
	card_status_exam_processing: card_status_exam_processing$1,
	card_status_exam_start: card_status_exam_start$1,
	card_title_brain_animation: card_title_brain_animation$1,
	card_title_checkup_instructions_complete: card_title_checkup_instructions_complete$1,
	card_title_checkup_instructions_start: card_title_checkup_instructions_start$1,
	card_title_exam_attention: card_title_exam_attention$1,
	card_title_exam_memory: card_title_exam_memory$1,
	card_title_exam_thinking: card_title_exam_thinking$1,
	care_category_cognitive: care_category_cognitive$1,
	care_category_lifestyle: care_category_lifestyle$1,
	care_chat_cta: care_chat_cta$1,
	care_chat_file_error: care_chat_file_error$1,
	care_chat_file_tooltip: care_chat_file_tooltip$1,
	care_chat_header: care_chat_header$1,
	care_chat_no_messages: care_chat_no_messages$1,
	care_chat_placeholder: care_chat_placeholder$1,
	care_chat_see_profile: care_chat_see_profile$1,
	care_chat_title: care_chat_title$1,
	care_chat_today: care_chat_today$1,
	care_chat_uploading: care_chat_uploading$1,
	care_general_error: care_general_error$1,
	care_homepage_header: care_homepage_header$1,
	care_nav_home: care_nav_home$1,
	care_nav_logout: care_nav_logout$1,
	care_patient_age: care_patient_age$1,
	care_patient_cognitive_pathway: care_patient_cognitive_pathway$1,
	care_patient_creation_date: care_patient_creation_date$1,
	care_patient_education: care_patient_education$1,
	care_patient_email: care_patient_email$1,
	care_patient_focus: care_patient_focus$1,
	care_patient_fullname: care_patient_fullname$1,
	care_patient_org: care_patient_org$1,
	care_patient_profile_tab: care_patient_profile_tab$1,
	care_patient_program_join_date: care_patient_program_join_date$1,
	care_patient_program_status: care_patient_program_status$1,
	care_patient_program_title: care_patient_program_title$1,
	care_patient_race: care_patient_race$1,
	care_patient_scores_tab: care_patient_scores_tab$1,
	care_patient_sex: care_patient_sex$1,
	care_patients_header: care_patients_header$1,
	care_patients_search_button: care_patients_search_button$1,
	care_patients_search_placeholder: care_patients_search_placeholder$1,
	care_patients_table_email: care_patients_table_email$1,
	care_patients_table_focus: care_patients_table_focus$1,
	care_patients_table_joining_date: care_patients_table_joining_date$1,
	care_patients_table_name: care_patients_table_name$1,
	care_patients_table_no_user: care_patients_table_no_user$1,
	care_patients_table_org: care_patients_table_org$1,
	care_scores_filter_all: care_scores_filter_all$1,
	care_scores_filter_cognitive: care_scores_filter_cognitive$1,
	care_scores_filter_date_range: care_scores_filter_date_range$1,
	care_scores_filter_domain: care_scores_filter_domain$1,
	care_scores_filter_last_six_months: care_scores_filter_last_six_months$1,
	care_scores_filter_last_three_months: care_scores_filter_last_three_months$1,
	care_scores_filter_lifestyle: care_scores_filter_lifestyle$1,
	care_scores_filter_most_recent: care_scores_filter_most_recent$1,
	care_scores_filter_status: care_scores_filter_status$1,
	care_scores_filter_status_flagged: care_scores_filter_status_flagged$1,
	care_scores_filter_status_incomplete: care_scores_filter_status_incomplete$1,
	care_scores_filter_status_successful: care_scores_filter_status_successful$1,
	care_scores_header: care_scores_header$1,
	care_scores_table_assessment: care_scores_table_assessment$1,
	care_scores_table_bucket: care_scores_table_bucket$1,
	care_scores_table_date: care_scores_table_date$1,
	care_scores_table_domain: care_scores_table_domain$1,
	care_scores_table_id: care_scores_table_id$1,
	care_scores_table_score: care_scores_table_score$1,
	care_scores_table_status: care_scores_table_status$1,
	care_users_header: care_users_header$1,
	change_password_attempt_limit_exceeded: change_password_attempt_limit_exceeded$1,
	change_password_body: change_password_body$1,
	change_password_body_header: change_password_body_header$1,
	change_password_body_instructions: change_password_body_instructions$1,
	change_password_close_window: change_password_close_window$1,
	change_password_confirm_new_password: change_password_confirm_new_password$1,
	change_password_enter_new_password_for: change_password_enter_new_password_for$1,
	change_password_enter_new_password_for_personalized: change_password_enter_new_password_for_personalized$1,
	change_password_enter_password: change_password_enter_password$1,
	change_password_go_to_login: change_password_go_to_login$1,
	change_password_invalid_password: change_password_invalid_password$1,
	change_password_success_header: change_password_success_header$1,
	chat_edited_label: chat_edited_label$1,
	coaching_start_date: coaching_start_date$1,
	cognitive_training: cognitive_training$1,
	confirm_start_date_body: confirm_start_date_body$1,
	confirm_start_date_title: confirm_start_date_title$1,
	confirmation_failure_mylinkx_retry_button: confirmation_failure_mylinkx_retry_button$1,
	confirmation_success_mylinkx_body: confirmation_success_mylinkx_body$1,
	confirmation_success_mylinkx_description: confirmation_success_mylinkx_description$1,
	confirmation_success_mylinkx_header: confirmation_success_mylinkx_header$1,
	confirmation_success_mylinkx_next_button: confirmation_success_mylinkx_next_button$1,
	consent_failure_mylinkx_body: consent_failure_mylinkx_body$1,
	consent_failure_mylinkx_description: consent_failure_mylinkx_description$1,
	consent_failure_mylinkx_retry: consent_failure_mylinkx_retry$1,
	contact_support_body: contact_support_body$1,
	contact_support_button: contact_support_button$1,
	contact_support_detail: contact_support_detail$1,
	contact_support_header: contact_support_header$1,
	coupon_body: coupon_body$1,
	coupon_code_placeholder: coupon_code_placeholder$1,
	create_accounts_tab: create_accounts_tab$1,
	default_language_label: default_language_label$1,
	delete_confirm_body: delete_confirm_body$1,
	delete_confirm_title: delete_confirm_title$1,
	demographics_biological_sex_1_answer: demographics_biological_sex_1_answer$1,
	demographics_biological_sex_2_answer: demographics_biological_sex_2_answer$1,
	demographics_biological_sex_field: demographics_biological_sex_field$1,
	demographics_birthday_field: demographics_birthday_field$1,
	demographics_education_10_answer: demographics_education_10_answer$1,
	demographics_education_1_answer: demographics_education_1_answer$1,
	demographics_education_2_answer: demographics_education_2_answer$1,
	demographics_education_3_answer: demographics_education_3_answer$1,
	demographics_education_4_answer: demographics_education_4_answer$1,
	demographics_education_5_answer: demographics_education_5_answer$1,
	demographics_education_6_answer: demographics_education_6_answer$1,
	demographics_education_7_answer: demographics_education_7_answer$1,
	demographics_education_8_answer: demographics_education_8_answer$1,
	demographics_education_field: demographics_education_field$1,
	demographics_experiments_header: demographics_experiments_header$1,
	demographics_header: demographics_header$1,
	demographics_prompt: demographics_prompt$1,
	demographics_race_ethnicity_1_answer: demographics_race_ethnicity_1_answer$1,
	demographics_race_ethnicity_2_answer: demographics_race_ethnicity_2_answer$1,
	demographics_race_ethnicity_3_answer: demographics_race_ethnicity_3_answer$1,
	demographics_race_ethnicity_4_answer: demographics_race_ethnicity_4_answer$1,
	demographics_race_ethnicity_5_answer: demographics_race_ethnicity_5_answer$1,
	demographics_race_ethnicity_6_answer: demographics_race_ethnicity_6_answer$1,
	demographics_race_ethnicity_field: demographics_race_ethnicity_field$1,
	demographics_why_link: demographics_why_link$1,
	description_label: description_label$1,
	disclaimer_header: disclaimer_header$1,
	dob_compliance_error: dob_compliance_error$1,
	domain_measured: domain_measured$1,
	drag_drop_csv: drag_drop_csv$1,
	editing_message: editing_message$1,
	email_address: email_address$1,
	email_prompt: email_prompt$1,
	error_browser_viewport_body: error_browser_viewport_body$1,
	error_browser_viewport_header: error_browser_viewport_header$1,
	error_camera_overconstrained_body: error_camera_overconstrained_body$1,
	error_camera_overconstrained_header: error_camera_overconstrained_header$1,
	error_cookies_disabled_body: error_cookies_disabled_body$1,
	error_cookies_disabled_header: error_cookies_disabled_header$1,
	error_device_display_body: error_device_display_body$1,
	error_device_unsupported_header: error_device_unsupported_header$1,
	error_generic_detail: error_generic_detail$1,
	error_generic_exam_failed_body: error_generic_exam_failed_body$1,
	error_generic_experiments_exam_failed: error_generic_experiments_exam_failed$1,
	error_generic_header: error_generic_header$1,
	error_invalid_code: error_invalid_code$1,
	error_no_user_found: error_no_user_found$1,
	error_password_policy: error_password_policy$1,
	error_too_many_attempts: error_too_many_attempts$1,
	error_unsupported_browser_body: error_unsupported_browser_body$1,
	error_unsupported_browser_header: error_unsupported_browser_header$1,
	error_unsupported_media_recorder_body: error_unsupported_media_recorder_body$1,
	error_unsupported_media_recorder_header: error_unsupported_media_recorder_header$1,
	exam_portal_page_title_nonbranded: exam_portal_page_title_nonbranded$1,
	exam_session_instructions_body: exam_session_instructions_body$1,
	exam_session_instructions_header: exam_session_instructions_header$1,
	executive_function: executive_function$1,
	exercise: exercise$1,
	existing_diagnoses_answer_1: existing_diagnoses_answer_1$1,
	existing_diagnoses_answer_2: existing_diagnoses_answer_2$1,
	existing_diagnoses_answer_3: existing_diagnoses_answer_3$1,
	existing_diagnoses_answer_4: existing_diagnoses_answer_4$1,
	existing_diagnoses_answer_5: existing_diagnoses_answer_5$1,
	existing_diagnoses_answer_6: existing_diagnoses_answer_6$1,
	existing_diagnoses_answer_7: existing_diagnoses_answer_7$1,
	existing_diagnoses_answer_8: existing_diagnoses_answer_8$1,
	existing_diagnoses_answer_9: existing_diagnoses_answer_9$1,
	existing_diagnoses_header: existing_diagnoses_header$1,
	existing_diagnoses_paragraph: existing_diagnoses_paragraph$1,
	experiments_task_complete_header: experiments_task_complete_header$1,
	experiments_task_completion_code: experiments_task_completion_code$1,
	faqs_header: faqs_header$1,
	faqs_link: faqs_link$1,
	filter_no_result: filter_no_result$1,
	first_name_label: first_name_label$1,
	follow_up_days_label: follow_up_days_label$1,
	forgot_password_header: forgot_password_header$1,
	forgot_password_instructions_sompo: forgot_password_instructions_sompo$1,
	free_trial_extension_body_download: free_trial_extension_body_download$1,
	generic_loading_message: generic_loading_message$1,
	generic_log_in_message: generic_log_in_message$1,
	get_started_button: get_started_button$1,
	global_cognitive: global_cognitive$1,
	global_lifestyle: global_lifestyle$1,
	google_play_store: google_play_store$1,
	header_account_created: header_account_created$1,
	header_login: header_login$1,
	header_register: header_register$1,
	header_sign_in: header_sign_in$1,
	header_welcome: header_welcome$1,
	header_welcome_2: header_welcome_2$1,
	implicit_learning: implicit_learning$1,
	inhibition: inhibition$1,
	input_device_answer_1: input_device_answer_1$1,
	input_device_answer_2: input_device_answer_2$1,
	input_device_answer_3: input_device_answer_3$1,
	input_device_header: input_device_header$1,
	input_device_paragraph: input_device_paragraph$1,
	invalid_token_mylinkx_body: invalid_token_mylinkx_body$1,
	invalid_token_mylinkx_header: invalid_token_mylinkx_header$1,
	invalid_token_mylinkx_retry_button: invalid_token_mylinkx_retry_button$1,
	landing_header: landing_header$1,
	landing_image_pairs_header: landing_image_pairs_header$1,
	landing_paragraph: landing_paragraph$1,
	landing_paragraph_innovatemr: landing_paragraph_innovatemr$1,
	landing_processing_speed_header: landing_processing_speed_header$1,
	landing_trails_header: landing_trails_header$1,
	last_name_label: last_name_label$1,
	learn_body: learn_body$1,
	learn_header: learn_header$1,
	linkage_failure_another_mlx_mylinkx_body: linkage_failure_another_mlx_mylinkx_body$1,
	linkage_failure_another_mlx_mylinkx_retry: linkage_failure_another_mlx_mylinkx_retry$1,
	linkage_failure_another_nt_mylinkx_body: linkage_failure_another_nt_mylinkx_body$1,
	linkage_failure_another_nt_mylinkx_retry: linkage_failure_another_nt_mylinkx_retry$1,
	linkage_failure_mylinkx_body: linkage_failure_mylinkx_body$1,
	linkage_failure_mylinkx_header: linkage_failure_mylinkx_header$1,
	linkage_failure_mylinkx_retry: linkage_failure_mylinkx_retry$1,
	logged_out_header: logged_out_header$1,
	login_loggedin_body: login_loggedin_body$1,
	login_loggedin_description: login_loggedin_description$1,
	login_loggedin_header: login_loggedin_header$1,
	login_loggedin_link: login_loggedin_link$1,
	login_loggedin_mylinkx_body: login_loggedin_mylinkx_body$1,
	login_loggedin_mylinkx_description: login_loggedin_mylinkx_description$1,
	login_loggedin_mylinkx_header: login_loggedin_mylinkx_header$1,
	login_loggedin_mylinkx_link: login_loggedin_mylinkx_link$1,
	mailchimp_audience_id_label: mailchimp_audience_id_label$1,
	mailing_address: mailing_address$1,
	maximum_usage_label: maximum_usage_label$1,
	memory: memory$1,
	minutes: minutes$1,
	modal_body_task_error: modal_body_task_error$1,
	modal_contact_support_body: modal_contact_support_body$1,
	modal_contact_support_title: modal_contact_support_title$1,
	modal_cta_task_error: modal_cta_task_error$1,
	modal_log_out_prompt_cta1: modal_log_out_prompt_cta1$1,
	modal_log_out_prompt_cta2: modal_log_out_prompt_cta2$1,
	modal_log_out_prompt_title: modal_log_out_prompt_title$1,
	modal_performance_accuracy: modal_performance_accuracy$1,
	modal_performance_speed: modal_performance_speed$1,
	modal_pullout_performance: modal_pullout_performance$1,
	modal_pullout_task_error: modal_pullout_task_error$1,
	modal_start_task_cta: modal_start_task_cta$1,
	modal_task_pullout_attention: modal_task_pullout_attention$1,
	modal_task_pullout_memory: modal_task_pullout_memory$1,
	modal_task_pullout_thinking: modal_task_pullout_thinking$1,
	modal_task_title_attention: modal_task_title_attention$1,
	modal_task_title_memory: modal_task_title_memory$1,
	modal_task_title_thinking: modal_task_title_thinking$1,
	modal_time_attention: modal_time_attention$1,
	modal_time_memory: modal_time_memory$1,
	modal_time_thinking: modal_time_thinking$1,
	modal_title_task_error: modal_title_task_error$1,
	more_information_demographics_why_detail: more_information_demographics_why_detail$1,
	more_information_demographics_why_header: more_information_demographics_why_header$1,
	more_information_video_why_detail: more_information_video_why_detail$1,
	more_information_video_why_header: more_information_video_why_header$1,
	mylinkx: mylinkx$1,
	mylinkx_authentication_failure_header: mylinkx_authentication_failure_header$1,
	mylinkx_authentication_failure_header_body: mylinkx_authentication_failure_header_body$1,
	mylinkx_login_button: mylinkx_login_button$1,
	mylinkx_signup_button: mylinkx_signup_button$1,
	mylinkx_taken_failure_body: mylinkx_taken_failure_body$1,
	mylinkx_taken_failure_header: mylinkx_taken_failure_header$1,
	mylinkx_usage_qualification_failure_body: mylinkx_usage_qualification_failure_body$1,
	mylinkx_usage_qualification_failure_header: mylinkx_usage_qualification_failure_header$1,
	nav__main_learn: nav__main_learn$1,
	nav_account_log_out: nav_account_log_out$1,
	nav_account_profile: nav_account_profile$1,
	nav_help_contact_support: nav_help_contact_support$1,
	nav_help_faq: nav_help_faq$1,
	nav_help_privacy: nav_help_privacy$1,
	nav_help_terms: nav_help_terms$1,
	nav_main_account: nav_main_account$1,
	nav_main_checkup: nav_main_checkup$1,
	nav_main_help: nav_main_help$1,
	nav_main_results: nav_main_results$1,
	not_selected: not_selected$1,
	nutrition: nutrition$1,
	or_separator: or_separator$1,
	organization_code_label: organization_code_label$1,
	organization_tab: organization_tab$1,
	page_title_checkup: page_title_checkup$1,
	partner_code_label: partner_code_label$1,
	partner_codes_tab: partner_codes_tab$1,
	processing_message_mylinkx_body: processing_message_mylinkx_body$1,
	processing_message_mylinkx_header: processing_message_mylinkx_header$1,
	processing_speed: processing_speed$1,
	profile_link: profile_link$1,
	read_receipt_label: read_receipt_label$1,
	read_receipt_tooltip: read_receipt_tooltip$1,
	recognition_memory: recognition_memory$1,
	redirect_mylinx_signin: redirect_mylinx_signin$1,
	redirecting_body: redirecting_body$1,
	redirecting_description: redirecting_description$1,
	redirecting_header: redirecting_header$1,
	redirecting_link: redirecting_link$1,
	redirecting_mylinkx_body: redirecting_mylinkx_body$1,
	redirecting_mylinkx_description: redirecting_mylinkx_description$1,
	redirecting_mylinkx_header: redirecting_mylinkx_header$1,
	redirecting_mylinkx_link: redirecting_mylinkx_link$1,
	register_body_agreement: register_body_agreement$1,
	register_body_disclaimer_header: register_body_disclaimer_header$1,
	register_body_disclaimer_para: register_body_disclaimer_para$1,
	register_body_pp_link: register_body_pp_link$1,
	register_body_tos_link: register_body_tos_link$1,
	register_email_placeholder: register_email_placeholder$1,
	register_firstname_placeholder: register_firstname_placeholder$1,
	register_lastname_placeholder: register_lastname_placeholder$1,
	register_login_email_compliance_error: register_login_email_compliance_error$1,
	register_marketing_radio_yes: register_marketing_radio_yes$1,
	register_marketing_radio_yes_with_partner: register_marketing_radio_yes_with_partner$1,
	register_password_compliance_error: register_password_compliance_error$1,
	register_password_hint: register_password_hint$1,
	register_password_match_error: register_password_match_error$1,
	register_password_placeholder: register_password_placeholder$1,
	register_scores_sharing_radio_yes: register_scores_sharing_radio_yes$1,
	register_terms_and_privacy_policy_checkbox: register_terms_and_privacy_policy_checkbox$1,
	register_terms_and_privacy_policy_detail: register_terms_and_privacy_policy_detail$1,
	registration_in_progress_wait: registration_in_progress_wait$1,
	required_consent_intro: required_consent_intro$1,
	reset_password_body: reset_password_body$1,
	reset_password_button: reset_password_button$1,
	reset_password_title: reset_password_title$1,
	screen_onboarding_button_continue: screen_onboarding_button_continue$1,
	screen_onboarding_button_create_account: screen_onboarding_button_create_account$1,
	screen_onboarding_button_getstarted: screen_onboarding_button_getstarted$1,
	screen_onboarding_button_large_login: screen_onboarding_button_large_login$1,
	screen_onboarding_button_skip: screen_onboarding_button_skip$1,
	screen_onboarding_button_small_login: screen_onboarding_button_small_login$1,
	screen_onboarding_code_error: screen_onboarding_code_error$1,
	screen_onboarding_code_example: screen_onboarding_code_example$1,
	screen_onboarding_code_example_mobile: screen_onboarding_code_example_mobile$1,
	screen_onboarding_code_intro: screen_onboarding_code_intro$1,
	screen_onboarding_code_slug: screen_onboarding_code_slug$1,
	screen_onboarding_code_title: screen_onboarding_code_title$1,
	screen_onboarding_dob_example_day: screen_onboarding_dob_example_day$1,
	screen_onboarding_dob_example_year: screen_onboarding_dob_example_year$1,
	screen_onboarding_dob_intro: screen_onboarding_dob_intro$1,
	screen_onboarding_dob_month_dropdown_1: screen_onboarding_dob_month_dropdown_1$1,
	screen_onboarding_dob_month_dropdown_10: screen_onboarding_dob_month_dropdown_10$1,
	screen_onboarding_dob_month_dropdown_11: screen_onboarding_dob_month_dropdown_11$1,
	screen_onboarding_dob_month_dropdown_12: screen_onboarding_dob_month_dropdown_12$1,
	screen_onboarding_dob_month_dropdown_13: screen_onboarding_dob_month_dropdown_13$1,
	screen_onboarding_dob_month_dropdown_2: screen_onboarding_dob_month_dropdown_2$1,
	screen_onboarding_dob_month_dropdown_3: screen_onboarding_dob_month_dropdown_3$1,
	screen_onboarding_dob_month_dropdown_4: screen_onboarding_dob_month_dropdown_4$1,
	screen_onboarding_dob_month_dropdown_5: screen_onboarding_dob_month_dropdown_5$1,
	screen_onboarding_dob_month_dropdown_6: screen_onboarding_dob_month_dropdown_6$1,
	screen_onboarding_dob_month_dropdown_7: screen_onboarding_dob_month_dropdown_7$1,
	screen_onboarding_dob_month_dropdown_8: screen_onboarding_dob_month_dropdown_8$1,
	screen_onboarding_dob_month_dropdown_9: screen_onboarding_dob_month_dropdown_9$1,
	screen_onboarding_dob_race_intro: screen_onboarding_dob_race_intro$1,
	screen_onboarding_dob_slug_day: screen_onboarding_dob_slug_day$1,
	screen_onboarding_dob_slug_month: screen_onboarding_dob_slug_month$1,
	screen_onboarding_dob_slug_year: screen_onboarding_dob_slug_year$1,
	screen_onboarding_dob_title: screen_onboarding_dob_title$1,
	screen_onboarding_education_dropdown: screen_onboarding_education_dropdown$1,
	screen_onboarding_education_dropdown_1: screen_onboarding_education_dropdown_1$1,
	screen_onboarding_education_dropdown_10: screen_onboarding_education_dropdown_10$1,
	screen_onboarding_education_dropdown_2: screen_onboarding_education_dropdown_2$1,
	screen_onboarding_education_dropdown_3: screen_onboarding_education_dropdown_3$1,
	screen_onboarding_education_dropdown_4: screen_onboarding_education_dropdown_4$1,
	screen_onboarding_education_dropdown_5: screen_onboarding_education_dropdown_5$1,
	screen_onboarding_education_dropdown_6: screen_onboarding_education_dropdown_6$1,
	screen_onboarding_education_dropdown_7: screen_onboarding_education_dropdown_7$1,
	screen_onboarding_education_dropdown_8: screen_onboarding_education_dropdown_8$1,
	screen_onboarding_education_dropdown_9: screen_onboarding_education_dropdown_9$1,
	screen_onboarding_education_intro: screen_onboarding_education_intro$1,
	screen_onboarding_education_title: screen_onboarding_education_title$1,
	screen_onboarding_email_intro: screen_onboarding_email_intro$1,
	screen_onboarding_email_optin_marketing: screen_onboarding_email_optin_marketing$1,
	screen_onboarding_email_optin_tospp: screen_onboarding_email_optin_tospp$1,
	screen_onboarding_email_slug: screen_onboarding_email_slug$1,
	screen_onboarding_email_title: screen_onboarding_email_title$1,
	screen_onboarding_home_intro: screen_onboarding_home_intro$1,
	screen_onboarding_home_subhead_registered: screen_onboarding_home_subhead_registered$1,
	screen_onboarding_home_title: screen_onboarding_home_title$1,
	screen_onboarding_login_example_email: screen_onboarding_login_example_email$1,
	screen_onboarding_login_example_password: screen_onboarding_login_example_password$1,
	screen_onboarding_login_link_forgot: screen_onboarding_login_link_forgot$1,
	screen_onboarding_login_slug_email: screen_onboarding_login_slug_email$1,
	screen_onboarding_login_slug_password: screen_onboarding_login_slug_password$1,
	screen_onboarding_login_subtitle_no_account: screen_onboarding_login_subtitle_no_account$1,
	screen_onboarding_login_title: screen_onboarding_login_title$1,
	screen_onboarding_name_example_first: screen_onboarding_name_example_first$1,
	screen_onboarding_name_example_last: screen_onboarding_name_example_last$1,
	screen_onboarding_name_slug_first: screen_onboarding_name_slug_first$1,
	screen_onboarding_name_slug_last: screen_onboarding_name_slug_last$1,
	screen_onboarding_name_title: screen_onboarding_name_title$1,
	screen_onboarding_password_example: screen_onboarding_password_example$1,
	screen_onboarding_password_example_confirm: screen_onboarding_password_example_confirm$1,
	screen_onboarding_password_intro: screen_onboarding_password_intro$1,
	screen_onboarding_password_slug: screen_onboarding_password_slug$1,
	screen_onboarding_password_slug_confirm: screen_onboarding_password_slug_confirm$1,
	screen_onboarding_password_title: screen_onboarding_password_title$1,
	screen_onboarding_race_dropdown: screen_onboarding_race_dropdown$1,
	screen_onboarding_race_dropdown_1: screen_onboarding_race_dropdown_1$1,
	screen_onboarding_race_dropdown_2: screen_onboarding_race_dropdown_2$1,
	screen_onboarding_race_dropdown_3: screen_onboarding_race_dropdown_3$1,
	screen_onboarding_race_dropdown_4: screen_onboarding_race_dropdown_4$1,
	screen_onboarding_race_dropdown_5: screen_onboarding_race_dropdown_5$1,
	screen_onboarding_race_dropdown_6: screen_onboarding_race_dropdown_6$1,
	screen_onboarding_race_intro: screen_onboarding_race_intro$1,
	screen_onboarding_race_title: screen_onboarding_race_title$1,
	screen_onboarding_race_title_short: screen_onboarding_race_title_short$1,
	screen_onboarding_reason_intro: screen_onboarding_reason_intro$1,
	screen_onboarding_reason_option1: screen_onboarding_reason_option1$1,
	screen_onboarding_reason_option2: screen_onboarding_reason_option2$1,
	screen_onboarding_reason_option3: screen_onboarding_reason_option3$1,
	screen_onboarding_reason_option4: screen_onboarding_reason_option4$1,
	screen_onboarding_reason_title: screen_onboarding_reason_title$1,
	screen_onboarding_sex_dropdown: screen_onboarding_sex_dropdown$1,
	screen_onboarding_sex_dropdown_1: screen_onboarding_sex_dropdown_1$1,
	screen_onboarding_sex_dropdown_2: screen_onboarding_sex_dropdown_2$1,
	screen_onboarding_sex_intro: screen_onboarding_sex_intro$1,
	screen_onboarding_sex_title: screen_onboarding_sex_title$1,
	screen_results_button_close: screen_results_button_close$1,
	screen_results_button_continue: screen_results_button_continue$1,
	screen_results_button_see_details: screen_results_button_see_details$1,
	screen_results_measure_explanation_associative_learning_bullet1: screen_results_measure_explanation_associative_learning_bullet1$1,
	screen_results_measure_explanation_associative_learning_bullet2: screen_results_measure_explanation_associative_learning_bullet2$1,
	screen_results_measure_explanation_associative_learning_bullet3: screen_results_measure_explanation_associative_learning_bullet3$1,
	screen_results_measure_explanation_associative_learning_intro: screen_results_measure_explanation_associative_learning_intro$1,
	screen_results_measure_explanation_associative_memory_bullet1: screen_results_measure_explanation_associative_memory_bullet1$1,
	screen_results_measure_explanation_associative_memory_bullet2: screen_results_measure_explanation_associative_memory_bullet2$1,
	screen_results_measure_explanation_associative_memory_bullet3: screen_results_measure_explanation_associative_memory_bullet3$1,
	screen_results_measure_explanation_associative_memory_intro: screen_results_measure_explanation_associative_memory_intro$1,
	screen_results_measure_explanation_attention: screen_results_measure_explanation_attention$1,
	screen_results_measure_explanation_executive_function_bullet1: screen_results_measure_explanation_executive_function_bullet1$1,
	screen_results_measure_explanation_executive_function_bullet2: screen_results_measure_explanation_executive_function_bullet2$1,
	screen_results_measure_explanation_executive_function_bullet3: screen_results_measure_explanation_executive_function_bullet3$1,
	screen_results_measure_explanation_executive_function_intro: screen_results_measure_explanation_executive_function_intro$1,
	screen_results_measure_explanation_memory: screen_results_measure_explanation_memory$1,
	screen_results_measure_explanation_processing_speed_bullet1: screen_results_measure_explanation_processing_speed_bullet1$1,
	screen_results_measure_explanation_processing_speed_bullet2: screen_results_measure_explanation_processing_speed_bullet2$1,
	screen_results_measure_explanation_processing_speed_bullet3: screen_results_measure_explanation_processing_speed_bullet3$1,
	screen_results_measure_explanation_processing_speed_intro: screen_results_measure_explanation_processing_speed_intro$1,
	screen_results_measure_explanation_thinking: screen_results_measure_explanation_thinking$1,
	screen_results_measure_explanation_title_associative_learning: screen_results_measure_explanation_title_associative_learning$1,
	screen_results_measure_explanation_title_associative_memory: screen_results_measure_explanation_title_associative_memory$1,
	screen_results_measure_explanation_title_executive_function: screen_results_measure_explanation_title_executive_function$1,
	screen_results_measure_explanation_title_processing_speed: screen_results_measure_explanation_title_processing_speed$1,
	screen_results_measure_title_attention: screen_results_measure_title_attention$1,
	screen_results_measure_title_memory: screen_results_measure_title_memory$1,
	screen_results_measure_title_thinking: screen_results_measure_title_thinking$1,
	screen_results_subtitle_learn_more: screen_results_subtitle_learn_more$1,
	screen_results_title_attention: screen_results_title_attention$1,
	screen_results_title_memory: screen_results_title_memory$1,
	screen_results_title_task: screen_results_title_task$1,
	screen_results_title_thinking: screen_results_title_thinking$1,
	search_no_result: search_no_result$1,
	session_timeout_body: session_timeout_body$1,
	session_timeout_header: session_timeout_header$1,
	sign_in_body_nonbranded: sign_in_body_nonbranded$1,
	sign_in_body_sign_in: sign_in_body_sign_in$1,
	sign_in_email_prompt: sign_in_email_prompt$1,
	sign_in_password_prompt: sign_in_password_prompt$1,
	sleep: sleep$1,
	social_engagement: social_engagement$1,
	sompo_email_link: sompo_email_link$1,
	sompo_registration_instructions_body: sompo_registration_instructions_body$1,
	sompo_registration_instructions_header: sompo_registration_instructions_header$1,
	sompo_registration_instructions_mylinkx_login_prompt: sompo_registration_instructions_mylinkx_login_prompt$1,
	sompo_registration_instructions_mylinkx_signup_prompt: sompo_registration_instructions_mylinkx_signup_prompt$1,
	sompo_registration_instructions_step1_detail: sompo_registration_instructions_step1_detail$1,
	sompo_registration_instructions_step1_header: sompo_registration_instructions_step1_header$1,
	sompo_registration_instructions_step2_detail: sompo_registration_instructions_step2_detail$1,
	sompo_registration_instructions_step2_header: sompo_registration_instructions_step2_header$1,
	sompo_registration_instructions_step3_header: sompo_registration_instructions_step3_header$1,
	spatial_working_memory: spatial_working_memory$1,
	start_button: start_button$1,
	start_exam_button: start_exam_button$1,
	start_over_registration_button: start_over_registration_button$1,
	stress: stress$1,
	title_label: title_label$1,
	title_registration: title_registration$1,
	title_registration_sompo: title_registration_sompo$1,
	tooltip_more: tooltip_more$1,
	visit_website_for_more: visit_website_for_more$1,
	watch_to_expect_profile_body: watch_to_expect_profile_body$1,
	watch_to_expect_profile_header: watch_to_expect_profile_header$1,
	web_learn_source_button: web_learn_source_button$1,
	welcome_body_confirm_password_placeholder: welcome_body_confirm_password_placeholder$1,
	welcome_body_email_placeholder: welcome_body_email_placeholder$1,
	welcome_body_login: welcome_body_login$1,
	welcome_body_login_mylinkx: welcome_body_login_mylinkx$1,
	welcome_body_login_sompo: welcome_body_login_sompo$1,
	welcome_body_password_placeholder: welcome_body_password_placeholder$1,
	welcome_body_register: welcome_body_register$1,
	welcome_body_register_sompo: welcome_body_register_sompo$1,
	welcome_help_body: welcome_help_body$1,
	welcome_partner_body: welcome_partner_body$1,
	welcome_partner_body_new: welcome_partner_body_new$1,
	welcome_sompo_body: welcome_sompo_body$1,
	what_to_expect_assessments_body: what_to_expect_assessments_body$1,
	what_to_expect_assessments_header: what_to_expect_assessments_header$1,
	what_to_expect_camera_check_body: what_to_expect_camera_check_body$1,
	what_to_expect_camera_check_header: what_to_expect_camera_check_header$1,
	what_to_expect_header: what_to_expect_header$1,
	what_to_expect_intro: what_to_expect_intro$1,
	what_to_expect_welcome: what_to_expect_welcome$1,
	you_are_logged_in_as: you_are_logged_in_as$1
};

var arrow_match_button_continue = "次へ";
var arrow_match_button_left_web = "(Z) 左";
var arrow_match_button_right_web = "右 (M)";
var arrow_match_conclusion_1_heading = "テストが完了しました";
var arrow_match_intro_1_heading = "矢印テスト";
var arrow_match_intro_1_paragraph = "注意力を測定するテストです (約 3 分)";
var arrow_match_phase_1_intro_1 = "画面に一連の矢印が表示されます。";
var arrow_match_phase_1_intro_2 = "真ん中の矢印が右を指しているか左を指しているかを選択してください。";
var arrow_match_phase_1_intro_2_web = "キーボードを使用し、中央の矢印が指している方向を選択してください。";
var arrow_match_phase_1_intro_3 = "中央の矢印が左を向いているときは [左] を選択してください。";
var arrow_match_phase_1_intro_3_web = "中央の矢印が左向きの場合は [Z] を押してください。";
var arrow_match_phase_1_intro_4 = "中央の矢印が右を向いているときは [右] を選択してください。";
var arrow_match_phase_1_intro_4_web = "中央の矢印が右向きの場合は [M] を押してください。";
var arrow_match_phase_1_intro_5_web = "このテストはキーボードを使用して回答します。[M] と [Z] の場所を確認してください。";
var arrow_match_phase_1_intro_6_header_web = "その調子。";
var arrow_match_phase_1_intro_6_web = "[スペース] キーで次へ進んでください。";
var arrow_match_phase_1_start_1 = "練習問題が終了したので、テストにうつります。\n回答時間は数秒しかないので、できるだけ早く、正確に回答してください。";
var arrow_match_phase_1_start_1_header = "お疲れさまでした。";
var arrow_match_phase_1_start_2 = "問題と問題の間に、中央を示すマークとして、画面中央にプラスマーク（＋）が表示されます。";
var arrow_match_start_practice = "次に、テストの前に簡単な練習問題を解いてみましょう";
var arrow_match_start_practice_web = "テストを始める前に簡単な練習をしてみましょう。[スペース] キーを押して続行します。";
var arrow_match_title = "矢印テスト";
var arrow_match_tutorial_feedback_body_left_web = "真ん中の矢印は左向きでした。[スペース] キーを押して次に進んでください。";
var arrow_match_tutorial_feedback_body_right_web = "真ん中の矢印は右向きでした。[スペース] キーを押して次に進んでください";
var arrow_match_tutorial_feedback_header_correct = "正解です";
var arrow_match_tutorial_feedback_header_incorrect = "残念。不正解です。";
var demographics_age_heading = "年齢";
var demographics_biological_sex_answer_1 = "女性";
var demographics_biological_sex_answer_2 = "男性";
var demographics_biological_sex_heading = "性別";
var demographics_button_label = "次へ";
var demographics_education_answer_1 = "小学校を卒業";
var demographics_education_answer_10 = "博士課程修了 (博士号)";
var demographics_education_answer_2 = "中学校を卒業";
var demographics_education_answer_3 = "高校を中途退学";
var demographics_education_answer_4 = "高校卒業";
var demographics_education_answer_5 = "大学中退";
var demographics_education_answer_6 = "短期大学を卒業 (3 年以下)";
var demographics_education_answer_7 = "大学を卒業";
var demographics_education_answer_8 = "大学院修了 (修士)";
var demographics_education_answer_9 = "博士課程修了 (医学、法務)";
var demographics_education_heading = "学歴";
var demographics_paragraph = "まず、次の情報を出来るだけ正確に入力してください。個人情報は安全に匿名化されます。";
var demographics_race_ethnicity_answer_1 = "アメリカ インディアンまたはアラスカ先住民";
var demographics_race_ethnicity_answer_2 = "アジア人";
var demographics_race_ethnicity_answer_3 = "黒人";
var demographics_race_ethnicity_answer_4 = "ラテン系";
var demographics_race_ethnicity_answer_5 = "ネイティブ ハワイ、他の太平洋諸島";
var demographics_race_ethnicity_answer_6 = "白人";
var demographics_race_ethnicity_heading = "人種と民族";
var demographics_worker_id_heading = "実施者 ID";
var demographics_worker_id_prompt = "実施者 ID を入力してください";
var exam_complete_mturk_body = "回答が記録されました。\nMTurk 完了コードを使用してください";
var exam_complete_mturk_error_body = "一意のコードを提供することはできません。\nMTurk 完了コードとしてワーカー ID を使用してください。";
var exam_complete_mturk_error_header = "エラーが発生しました。";
var exam_complete_mturk_header = "テストが完了しました。";
var exam_instructions_header = "説明";
var exam_practice_header = "まずは練習しましょう";
var exam_start_exam_button_label = "始めましょう";
var exam_start_practice_button_label = "まずは練習しましょう";
var exam_start_practice_header = "まずは練習しましょう";
var experiments_arrow_match_button_correct = "";
var experiments_arrow_match_button_incorrect = "";
var experiments_arrow_match_pre_practice_1 = "";
var experiments_mouse_arrow_match_phase_1_intro_3_web = "";
var experiments_mouse_arrow_match_phase_1_intro_4_web = "";
var experiments_timer_arrow_match_post_practice = "";
var experiments_timer_arrow_match_start_practice_web = "";
var flanker_prepractice_button_label = "練習を始めましょう";
var flanker_prepractice_description = "テストの前に練習問題を解いてみましょう。[スペース] キーで次に進んでください";
var flanker_prepractice_title = "まずは練習しましょう";
var go_no_go_button_continue = "次へ";
var go_no_go_conclusion_1_heading = "テストが完了しました";
var go_no_go_feedback_body_early = "信号が青になるまで待ってください。";
var go_no_go_feedback_body_early_web = "信号が青になるまで待ってください。\n\n[スペース] キーで次に進んでください";
var go_no_go_feedback_body_go_correct = "信号が青になりました。";
var go_no_go_feedback_body_go_correct_web = "信号が青になりました。\n\n[スペース] キーで次に進んでください。";
var go_no_go_feedback_body_go_incorrect = "信号が青になったら、キーを押してください。";
var go_no_go_feedback_body_go_incorrect_web = "信号が青になった時だけ、キーを押してください。\n\n[スペース] キーで次に進んでください。";
var go_no_go_feedback_body_no_go_correct = "信号が赤になりました。";
var go_no_go_feedback_body_no_go_correct_web = "信号が赤になりました。\n\n[スペース] キーで次に進んでください。";
var go_no_go_feedback_body_no_go_incorrect = "信号が青になった時だけ押してください。";
var go_no_go_feedback_body_no_go_incorrect_web = "信号が青になった時だけ押してください。\n\n[スペース] キーで次に進んでください";
var go_no_go_feedback_header_correct = "正解です。";
var go_no_go_feedback_header_early = "残念。早すぎました。";
var go_no_go_feedback_header_incorrect = "残念。不正解です。";
var go_no_go_intro_1_heading = "信号テスト";
var go_no_go_intro_1_paragraph = "抑制機能を測定するテストです (約 3 分)";
var go_no_go_phase_1_intro_1 = "このテストでは信号の画像と、その下にボタンが表示されます。";
var go_no_go_phase_1_intro_1_web = "このテストでは信号の画像とその下にボタンが表示されますが、実際の操作はボタンを押すのではなく、キーボードの [Enter] (または [Return] キー) を押します。";
var go_no_go_phase_1_intro_2 = "信号が青に変わったら、信号の下のボタンをできるだけ早く押します。";
var go_no_go_phase_1_intro_2_web = "信号が青に変わったら、以下のように「Enter」 (または「Return」) キーをできるだけ早く押します。";
var go_no_go_phase_1_intro_3 = "信号が赤のときには、何も押さないでください。数秒後に自動的に次の画面に進みます。";
var go_no_go_phase_1_intro_3_web = "信号が赤のときには、何も押さないでください。数秒後に自動的に次の画面に進みます。";
var go_no_go_phase_1_start_body = "次に、テストに移ります。\n回答時間が数秒しかないので、できるだけ早く、正確に答えてください。";
var go_no_go_phase_1_start_body_web = "次に、テストに移ります。\n回答時間が数秒しかないので、できるだけ早く、正確に答えてください。\n[スペース] キーで次に進んでください。";
var go_no_go_phase_1_start_header = "お疲れさまでした。";
var go_no_go_response_button_web = "[スペース] キー";
var go_no_go_start_practice = "次に、テストを始める前に簡単な練習をしてみましょう。";
var go_no_go_start_practice_web = "次に、テストを始める前に簡単な練習をしてみましょう。テストでは「Enter」(または「Return」) キーを使用することを忘れないでください。[スペース] キーを押して次に進みます。";
var go_no_go_title = "信号テスト";
var image_pairs_button_continue = "次へ";
var image_pairs_title = "画像ペア";
var instructions_heading = "説明";
var item_price_button_continue = "次へ";
var item_price_button_no_web = "いいえ (M)";
var item_price_button_yes_web = "(Z) はい";
var item_price_phase_1_end = "パート 1 が完了しました";
var item_price_phase_1_end_body = "パート2を開始します。";
var item_price_phase_1_intro_1 = "パート 1: 8 種類の果物や野菜の\n価格が次々表示されますので\n覚えてください。";
var item_price_phase_1_intro_2 = "パート 2 では、パート 1 で覚えた\n果物、野菜のそれぞれの価格を\n確認します。";
var item_price_phase_1_intro_3 = "たとえば、キャベツは￥499 です。\nこの価格を覚えておいてください。";
var item_price_phase_1_intro_3_price = "￥499";
var item_price_phase_1_intro_4 = "覚えている価格はこれですか?\n正解は [いいえ] です。キャベツは￥499 です。";
var item_price_phase_1_intro_4_price = "￥599";
var item_price_phase_1_intro_5_button = "パート 1 を開始";
var item_price_phase_1_intro_5_web = "8 種類の果物や野菜の価格を覚えてください。続けるには、スペースキーを押してください。";
var item_price_phase_2_intro_1 = "パート 2: 再び果物、野菜の横に\n価格を表示します。";
var item_price_phase_2_intro_2_web = "パート 1 で覚えた価格と同じかどうか、キーボードを使用して選んでください。";
var item_price_phase_2_intro_3_web = "価格が正しい場合は (Z) [はい] ボタンを押してください。";
var item_price_phase_2_intro_4_web = "価格が違っている場合は、(M) [いいえ] ボタンを押してください。";
var item_price_phase_2_intro_5 = "回答時間は数秒しかないので、\n早く、正確に答えてください。";
var item_price_phase_2_intro_6_button = "パート 2 を開始";
var item_price_phase_2_intro_6_web = "パート 1 で覚えた価格と同じかどうか、選んでください。続けるには、スパースキーを押してください。";
var item_price_phase_2_trial_prompt = "正しい価格ですか？";
var item_price_title = "価格テスト";
var path_points_button_continue = "次へ";
var path_points_conclusion_1_heading = "テストが完了しました";
var path_points_intro_1_paragraph = "実行機能を測定するテストです (約 3 分)";
var path_points_node_a = "あ";
var path_points_node_b = "い";
var path_points_node_c = "う";
var path_points_node_d = "え";
var path_points_node_e = "お";
var path_points_node_f = "か";
var path_points_node_g = "き";
var path_points_phase_1_intro_1 = "数字とひらがなが表示されます";
var path_points_phase_1_intro_2 = "1→あ→2→い…の順番で、数字とひらがなを交互につないでください";
var path_points_phase_1_intro_2_web = "1→あ→2→い… の順序で、数字とひらがなを交互に押してください。";
var path_points_phase_1_intro_3 = "すべての数字とひらがなを正しい順序でつないだら終了です。";
var path_points_phase_1_intro_3_alternate = "1→あ→2→い…の順番で、つないでください";
var path_points_phase_1_intro_3_web = "すべての数字とひらがなが正しい順序でつながると自動的に終了します。";
var path_points_phase_1_start_body = "練習問題が終了したので、テストを始めましょう。\nできるだけ早く、正確に 1 から順に、数字とひらがなを交互に押してください";
var path_points_phase_1_start_header = "お疲れさまでした。";
var path_points_start_practice = "次に、テストの前に簡単な練習問題を解いてみましょう。";
var path_points_title = "点つなぎテスト";
var path_points_tutorial_incorrect_body = "数字とひらがなを交互に押してください。";
var path_points_tutorial_incorrect_header = "残念";
var path_points_tutorial_prompt = "[1] を押すと開始します。";
var path_points_tutorial_prompt_web = "[1] をクリックして開始します。";
var symbol_match_button_continue = "次へ";
var symbol_match_button_equal = "おなじ";
var symbol_match_button_equal_web = "(Z) おなじ";
var symbol_match_button_unequal = "ちがう";
var symbol_match_button_unequal_web = "ちがう (M)";
var symbol_match_phase_1_intro_1 = "最初に、記号のペアが真ん中に、\nチャートが上に表示されます。";
var symbol_match_phase_1_intro_2 = "チャートを使用して記号の値を把握してください。";
var symbol_match_phase_1_intro_3 = "ここでは星印の意味する数字は 2 で\nマル印に対する数字は 1 です。";
var symbol_match_phase_1_intro_4 = "この例では、記号は両方とも 1 を\n意味しています。";
var symbol_match_phase_1_intro_5_web = "記号に対応する数値が同じ場合は、[おなじ] (Z) ボタンを押します。";
var symbol_match_phase_1_intro_6_web = "記号に対応する数値が違う場合は、[ちがう] (M) ボタンを押します。";
var symbol_match_phase_1_intro_7_web = "チャートを使用して、記号の数値を確認してください。続けるには、スペースキーを押してください。";
var symbol_match_phase_1_start_header = "お疲れさまでした。";
var symbol_match_phase_1_start_web = "チャートを使用して、記号の数値を確認してください。続けるには、スペースキーを押してください。";
var symbol_match_title = "記号テスト";
var symbol_match_tutorial_1_paragraph_web = "左の記号の数値は 1 で、右の記号の数値は 2 です。[ちがう] が正解です。続けるには、スペースキーを押してください。";
var symbol_match_tutorial_2_paragraph_web = "左の記号の数値は 3、右の記号も 3 です。[おなじ] が正解です。続けるには、スペースキーを押してください。";
var symbol_match_tutorial_3_paragraph_web = "左の記号の数値は 5 、右の記号は 4 です。[ちがう] が正解です。続けるには、スペースキーを押してください。";
var symbol_match_tutorial_correct_heading = "正解";
var symbol_match_tutorial_incorrect_heading = "残念。正解ではありません";
var web_button_next = "次へ";
var web_button_previous = "前のページ";
var account_created_body_confirmation = "登録が完了しました。アプリをダウンロードして、今すぐ脳ケアを始めましょう。";
var account_created_body_confirmation_webuser = "{0}にアクセスして、認知評価の実施を開始してください。";
var account_created_verification_instructions_body = "アプリへログインする際は、{0} をメールアドレスとしてご利用ください。\nご登録いただいているメールアドレスに誤りがある場合は、{1} までお問い合わせください。\n\nご登録後、braincare@neurotrack.com  ( 送信専用 ) からご案内のメールが届きますので、以下をご留意ください。\n携帯電話のメール ( docomo、ezweb、softbank等 ) をご利用の方：ドメインが neurotrack.com のメールを受信可能に設定してください。\nフリーメール（gmail、hotmail 等）またはその他をご利用の方：「迷惑メール」に振り分けられる場合がありますので、迷惑メールフォルダをご確認ください。\n上記の理由でご案内メールが届かない場合でもアプリにはログイン頂けます。\nその他のよくある質問は {2} まで。";
var account_created_verification_instructions_body_webuser = "あなたのログイン用メールアドレスは{0}です。\nログインをして認知機能テストを開始しましょう。\nご不明点は{1}までお問い合わせください。";
var account_link = "アカウント";
var alert_action_ok = "OK";
var alert_body_expired_coupon = "入力したクーポンコードは無効です(人数が上限に達しました）。\nもう一度お試しいただくか、クーポンコード提供元にお問い合わせください。";
var alert_body_invalid_coupon = "入力したクーポンコードを認識できません。もう一度やり直すか、クーポンコード提供元にお問い合わせください。";
var alert_bulk_create_account_success = "";
var alert_forgot_password_body_confirm = "登録されたメールアドレスに、パスワードのリセット方法を記載したメールをお送りしました。ページを閉じてください。";
var alert_forgot_password_body_header = "メールアドレスを入力";
var alert_header_forgot_password = "パスワードを忘れた場合";
var alert_header_invalid_coupon = "クーポンコードが無効です";
var alert_header_invalid_login = "ログインに失敗しました";
var alert_header_reg_error = "ご案内";
var alert_invalid_extension = "";
var alert_invalid_login_body = "ユーザー名またはパスワードが間違っています。 \nもう一度入力するか、よくある質問をご確認ください。";
var alert_invalid_login_email = "support.jp@neurotrack.com";
var alert_reg_error_body = "アプリをダウンロード後、ご登録のメールアドレスとパスワードでログインに進んでください。アカウントの作成でお困りの場合は、よくある質問をご覧ください。";
var alert_session_expired = "一定時間操作が行われなかったため、自動的にログアウトされました。再度ログインしてください。";
var alert_unsupported_media_recorder = "お使いのブラウザはビデオ録画に対応していません。Google Chrome または Mozilla Firefox でのご利用をお勧めします。";
var apple_app_store = "Apple App Store";
var assessment_processing = "結果を解析中";
var assessment_unavailable_camera_body = "カメラの設定を確認してください";
var assessment_unavailable_camera_header = "ビデオ録画の要件を満たしていません";
var assessments_available_body = "以下の認知機能テストを受けることができます。受けたいテスト名をクリックしてテストを始めてください。各テストの最初にテストの受け方について説明があります。";
var assessments_available_empty_body = "お疲れさまでした。全てのテストを完了しました。";
var assessments_available_header = "実施可能な認知機能テスト";
var assessments_history_empty_body = "テストを受けた記録がありません。認知機能テストを受けた後、受けたテストと実施日が表示されます。";
var assessments_history_header = "テスト履歴";
var assessments_history_table_assessment_header = "検査";
var assessments_history_table_bucket_header = "テスト結果";
var assessments_history_table_date_header = "検査実施日";
var assessments_history_table_domain_header = "認知領域";
var assessments_history_table_percentile_header = "パーセンタイル";
var assessments_history_with_scores_empty_body = "テストを受けた記録がありません。認知機能テストを受けた後、受けたテストとその得点が表示されます。";
var associative_learning = "連想学習";
var associative_memory = "連想記憶";
var attention = "注意力";
var available_exams_label = "";
var back_to_faqs = "戻る";
var browser_tab_title = "ニューロトラック";
var button_agree = "同意して次に進む";
var button_back_to_assessments = "戻る";
var button_cancel = "キャンセル";
var button_check_camera = "カメラを設定";
var button_close = "閉じる";
var button_continue = "次へ";
var button_continue_session = "セッションを続ける";
var button_delete = "削除";
var button_disagree = "同意しない";
var button_edit = "編集";
var button_forgot_password = "パスワードを忘れた場合";
var button_forgot_password_log_in = "ログイン画面に戻る";
var button_go_back = "戻る";
var button_learn_more = "もっと詳しく";
var button_login = "ログイン";
var button_open_app = "アプリを開く";
var button_register = "登録";
var button_save = "保存";
var button_set = "設定";
var button_sign_in = "ログイン";
var button_sign_out = "ログアウト";
var button_sign_up = "登録";
var button_skip = "スキップ";
var button_submit = "送信";
var button_try_again = "再試行";
var camera_check_button_continue_with = "カメラの設定をしてから続ける";
var camera_check_button_continue_without = "カメラの設定をしないで続ける";
var camera_check_header = "ウェブカメラへのアクセス許可";
var camera_check_intro = "認知機能テストを受ける際は、より正確なテスト結果を算出するためにカメラへのアクセスを許可してください。設定はいつでも変更できますが、視線解析技術を使用するテストを行う際はカメラへのアクセスを許可する必要があります。";
var camera_check_media_recorder_unsupported = "お使いのブラウザはビデオ録画に対応していません。録画をするには Google Chrome または Mozilla Firefox のご利用をお勧めします。録画された映像は、より正確なテスト結果を算出するために使用します。視線解析技術 (アイトラッキング) を使用するテストを行うには、ビデオ録画のアクセスを許可する必要があります。";
var camera_check_more_information = "カメラを使用する目的については、こちらをご覧ください。";
var camera_check_not_found = "ウェブカメラが検出されませんでした。より正確なテスト結果を算出するには、カメラ付きの端末のご利用をお勧めします。視線解析技術 (アイトラッキング) を使用するテストを行うにはカメラが必要です。";
var camera_check_pre_exam_accepted = "テストを受ける前に、ウェブカメラが設定されていることを確認してください。楽な姿勢で顔がカメラに映る机と椅子に座りましょう。必要に応じて部屋の明るさを調整し、顔がはっきりと映るようにしてください。";
var camera_check_prompt = "カメラへのアクセスを許可してください。ここにプレビューが表示されます。";
var camera_status_accepted = "ウェブカメラを検出し、必要なシステム要件を満たしていることを確認できました。";
var camera_status_blocked = "ウェブカメラを検出できません。正確なテスト結果を算出するために、カメラのアクセスを許可してください。カメラのアクセスを許可すると、すべての認知機能テストを受けられる様になります。ブラウザの設定を確認し、更新してください。";
var camera_status_dismissed = "正確なテスト結果を算出するためにカメラのアクセスを許可してください。カメラのアクセスを許可するとすべての認知機能テストを受けられるようになります。";
var camera_status_header = "カメラおよびビデオ録画の設定";
var camera_status_more_information = "録画する理由はこちら";
var camera_status_overconstrained = "ウェブカメラの設定が、必要なシステム要件を満たしていません。";
var card_body_checkup_instructions_complete = "";
var card_body_checkup_instructions_start = "";
var card_footer_brain_animation_complete = "";
var card_footer_brain_animation_start = "";
var card_footer_brain_animation_state_three = "";
var card_footer_brain_animation_state_two = "";
var card_results_date_last_updated = "";
var card_results_interp_below_expected = "";
var card_results_interp_expected = "";
var card_results_interp_percentile = "";
var card_results_slug_better_than = "";
var card_results_slug_your_result = "";
var card_results_status_active = "";
var card_results_status_inactive = "";
var card_results_title_attention = "";
var card_results_title_memory = "";
var card_results_title_thinking = "";
var card_status_exam_complete = "";
var card_status_exam_error = "";
var card_status_exam_processing = "";
var card_status_exam_start = "";
var card_title_brain_animation = "";
var card_title_checkup_instructions_complete = "";
var card_title_checkup_instructions_start = "";
var card_title_exam_attention = "";
var card_title_exam_memory = "";
var card_title_exam_thinking = "";
var care_category_cognitive = "最新の認知機能テストの得点";
var care_category_lifestyle = "最新の生活習慣テストの得点";
var care_chat_cta = "メッセージ";
var care_chat_file_error = "{0}はファイルサイズが大きすぎます";
var care_chat_file_tooltip = "写真やファイルを添付";
var care_chat_header = "メッセージ";
var care_chat_no_messages = "まだメッセージはありません。";
var care_chat_placeholder = "メッセージを入力...";
var care_chat_see_profile = "すべての登録情報を見る";
var care_chat_title = "{0}とチャット";
var care_chat_today = "今日";
var care_chat_uploading = "アップロードしています...";
var care_general_error = "エラーが発生しました";
var care_homepage_header = "ニューロトラック ケア ポータル";
var care_nav_home = "ホーム";
var care_nav_logout = "ログアウト";
var care_patient_age = "年齢";
var care_patient_cognitive_pathway = "脳ケア コース";
var care_patient_creation_date = "アカウント作成日";
var care_patient_education = "学歴";
var care_patient_email = "メールアドレス";
var care_patient_focus = "課題";
var care_patient_fullname = "氏名";
var care_patient_org = "パートナー組織";
var care_patient_profile_tab = "登録情報";
var care_patient_program_join_date = "プログラム開始日";
var care_patient_program_status = "登録状況";
var care_patient_program_title = "コーチング先行登録";
var care_patient_race = "人種";
var care_patient_scores_tab = "得点";
var care_patient_sex = "性別";
var care_patients_header = "クライアント";
var care_patients_search_button = "検索";
var care_patients_search_placeholder = "名前またはメールアドレスで検索";
var care_patients_table_email = "メールアドレス";
var care_patients_table_focus = "課題";
var care_patients_table_joining_date = "申込日";
var care_patients_table_name = "名前";
var care_patients_table_no_user = "ユーザーが見つかりませんでした";
var care_patients_table_org = "パートナー企業";
var care_scores_filter_all = "全て";
var care_scores_filter_cognitive = "認知機能の全領域";
var care_scores_filter_date_range = "日付範囲";
var care_scores_filter_domain = "領域";
var care_scores_filter_last_six_months = "過去 6 か月";
var care_scores_filter_last_three_months = "過去 3 か月";
var care_scores_filter_lifestyle = "生活習慣の全領域";
var care_scores_filter_most_recent = "直近";
var care_scores_filter_status = "テスト実施状況";
var care_scores_filter_status_flagged = "要再テスト";
var care_scores_filter_status_incomplete = "未完了";
var care_scores_filter_status_successful = "完了";
var care_scores_header = "テスト実施履歴";
var care_scores_table_assessment = "テスト名";
var care_scores_table_bucket = "結果";
var care_scores_table_date = "実施日";
var care_scores_table_domain = "認知領域";
var care_scores_table_id = "テストID";
var care_scores_table_score = "得点";
var care_scores_table_status = "テストの実施状況";
var care_users_header = "クライアント";
var change_password_attempt_limit_exceeded = "試行制限を超えました。数分後に再度ご入力ください。";
var change_password_body = "パスワードが変更されました。";
var change_password_body_header = "パスワードを変更する";
var change_password_body_instructions = "パスワードを忘れてしまった場合はメールアドレスを入力してください。パスワードのリセット方法をメールでお送り致します。";
var change_password_close_window = "ウィンドウを閉じる";
var change_password_confirm_new_password = "パスワードを確認";
var change_password_enter_new_password_for = "パスワードは 8 文字以上にしてください。";
var change_password_enter_new_password_for_personalized = "{0}の新しいパスワードを入力します。\nパスワードは 8 文字以上にしてください。";
var change_password_enter_password = "新しいパスワード";
var change_password_go_to_login = "ログイン";
var change_password_invalid_password = "パスワードは8文字以上にしてください。";
var change_password_success_header = "新しいパスワードを取得しました。";
var chat_edited_label = "(編集済み)";
var coaching_start_date = "コーチング開始日";
var cognitive_training = "脳活";
var confirm_start_date_body = "コーチングの開始日が本日に設定されます。一度設定すると元に戻すことはできません。";
var confirm_start_date_title = "開始日の確認";
var confirmation_failure_mylinkx_retry_button = "再試行";
var confirmation_success_mylinkx_body = "ニューロトラック 脳ケアとマイリンククロスのアカウントを連携しました。";
var confirmation_success_mylinkx_description = "マイリンククロス(Webサービス) の被保険者情報欄に証券番号が登録されていることをご確認ください。引き続きサービス制限なしで脳ケア アプリをご利用いただけます。";
var confirmation_success_mylinkx_header = "処理が完了しました";
var confirmation_success_mylinkx_next_button = "ニューロトラック 脳ケアを開く";
var consent_failure_mylinkx_body = "マイリンククロスの情報をニューロトラックに提供することに同意していません。";
var consent_failure_mylinkx_description = "アカウントを連携することができません。";
var consent_failure_mylinkx_retry = "しばらく時間をおいてから再度お試しください。";
var contact_support_body = "このプログラムは、脳の健康を管理し認知機能の低下を防ぐために設計されました。ご意見、ご質問をお寄せください。";
var contact_support_button = "サポートお問い合わせ";
var contact_support_detail = "その他、ご質問がある場合は、ニューロトラックのカスタマーサポート support.jp@neurotrack.com にお問い合わせください。";
var contact_support_header = "お問い合わせ";
var coupon_body = "クーポンコードをご入力ください";
var coupon_code_placeholder = "クーポンコードを入力";
var create_accounts_tab = "";
var default_language_label = "";
var delete_confirm_body = "このメッセージを削除すると、あなたと相手の両方でメッセージが削除されます。この操作は元に戻すことができません。";
var delete_confirm_title = "メッセージを削除しますか?";
var demographics_biological_sex_1_answer = "女性";
var demographics_biological_sex_2_answer = "男性";
var demographics_biological_sex_field = "性別";
var demographics_birthday_field = "生年月日";
var demographics_education_10_answer = "博士課程修了 (博士号)";
var demographics_education_1_answer = "小学校を卒業";
var demographics_education_2_answer = "中学校を卒業";
var demographics_education_3_answer = "高校を中途退学";
var demographics_education_4_answer = "高校卒業";
var demographics_education_5_answer = "大学中退";
var demographics_education_6_answer = "短期大学を卒業 (3 年以下)";
var demographics_education_7_answer = "大学を卒業";
var demographics_education_8_answer = "大学院修了 (修士)";
var demographics_education_field = "学歴";
var demographics_experiments_header = "基本情報";
var demographics_header = "登録情報の設定";
var demographics_prompt = "以下の情報を出来るだけ正確にご入力ください。入力された項目は、テスト結果の算出に使用されます。";
var demographics_race_ethnicity_1_answer = "アメリカ インディアンまたはアラスカ先住民";
var demographics_race_ethnicity_2_answer = "アジア人 (日本人)";
var demographics_race_ethnicity_3_answer = "黒人";
var demographics_race_ethnicity_4_answer = "ラテン系";
var demographics_race_ethnicity_5_answer = "ネイティブ ハワイ、他の太平洋諸島";
var demographics_race_ethnicity_6_answer = "白人";
var demographics_race_ethnicity_field = "人種";
var demographics_why_link = "質問の目的";
var description_label = "";
var disclaimer_header = "免責事項";
var dob_compliance_error = "有効な日付を入力してください。";
var domain_measured = "対象領域";
var drag_drop_csv = "";
var editing_message = "メッセージを編集";
var email_address = "メールアドレス";
var email_prompt = "";
var error_browser_viewport_body = "現在ページ全体が表示されていません。一部の画像が表示されず、認知機能テストの結果に影響を与える可能性があります。ページ全体を表示するためにブラウザの大きさを変更してください。";
var error_browser_viewport_header = "ブラウザを大きくしてください";
var error_camera_overconstrained_body = "お使いのカメラはシステム要件を満たしていません。640 x 480 以上の解像度のカメラのご利用をお勧めします。録画された映像は得点の算出に使用します。また、録画ができない場合は視線解析技術 (アイトラッキング) を使ったテストを受けることができません。";
var error_camera_overconstrained_header = "カメラが対応していません";
var error_cookies_disabled_body = "このWebサイトにアクセスするには Cookie を許可する必要があります。Cookie はサイト上の操作を行う上で厳正に使用され、行動履歴を追うために使用されることはありません。続行するにはブラウザの設定で Cookie を有効にして再度お試しください。";
var error_cookies_disabled_header = "Cookie が無効になっています";
var error_device_display_body = "端末の画面サイズが小さすぎます。一部の画像が表示されず、認知機能テストの結果に影響を与える可能性があります。デスクトップまたはノートパソコンの使用をお勧めします。";
var error_device_unsupported_header = "端末が対応していません";
var error_generic_detail = "リクエストを処理することができませんでした。ページを更新するかもう一度同じ手順を繰り返してください。";
var error_generic_exam_failed_body = "ホームページに戻って再度テストを受け直してください。";
var error_generic_experiments_exam_failed = "タスクを続行できませんでした。別のウェブサイトからこのタスクにアクセスした場合はもう一度やり直すか、お客様窓口までお問い合わせください。";
var error_generic_header = "エラーが発生しました。";
var error_invalid_code = "このリンクは無効です。再度、パスワードをリセットしてください。";
var error_no_user_found = "入力されたメールアドレスで登録されたアカウントが見つかりませんでした。再度入力するか、カスタマーサポート ( support.jp@neurotrack.com ) までお問い合わせください。";
var error_password_policy = "パスワードは英数字8文字以上を指定してください。";
var error_too_many_attempts = "試行制限回数に達しました。セキュリティのため一時的にロックしました。しばらくしてから再度ご入力ください。";
var error_unsupported_browser_body = "お使いのブラウザは認知機能テスト ポータルに対応していません。推奨ブラウザに切り替えてご利用ください。推奨ブラウザ: Google Chrome、Mozilla Firefox、Microsoft Edge";
var error_unsupported_browser_header = "ブラウザが対応していません";
var error_unsupported_media_recorder_body = "お使いのブラウザはビデオ録画に対応していません。録画をするには Google Chrome または Mozilla Firefox のご利用をお勧めします。録画された映像は得点の算出に使用します。また、録画ができない場合は視線解析技術 (アイトラッキング) を使ったテストを受けることができません。";
var error_unsupported_media_recorder_header = "ビデオ録画に対応していません";
var exam_portal_page_title_nonbranded = "認知機能テスト ポータル";
var exam_session_instructions_body = "以下に実施可能な認知機能テストが表示されます。すべてのテストを受けてください。始める前に、テストの説明をよくお読みください。マウスやキーボードを操作して受けるテストもあります。速度と正確さの両方を測定し、テストの得点が算出されます。";
var exam_session_instructions_header = "実施方法";
var executive_function = "実行機能";
var exercise = "運動";
var existing_diagnoses_answer_1 = "";
var existing_diagnoses_answer_2 = "";
var existing_diagnoses_answer_3 = "";
var existing_diagnoses_answer_4 = "";
var existing_diagnoses_answer_5 = "";
var existing_diagnoses_answer_6 = "";
var existing_diagnoses_answer_7 = "";
var existing_diagnoses_answer_8 = "";
var existing_diagnoses_answer_9 = "";
var existing_diagnoses_header = "";
var existing_diagnoses_paragraph = "";
var experiments_task_complete_header = "タスクが完了しました";
var experiments_task_completion_code = "あなたの回答が記録されました。このコードを使ってタスクが完了したことを示してください。";
var faqs_header = "よくある質問";
var faqs_link = "よくある質問";
var filter_no_result = "データがありません";
var first_name_label = "名";
var follow_up_days_label = "";
var forgot_password_header = "パスワードを忘れた場合";
var forgot_password_instructions_sompo = "パスワードをリセットして マイリンククロスにログインしましょう。";
var free_trial_extension_body_download = "アプリをダウンロードして、今すぐ脳ケアを始めましょう。";
var generic_loading_message = "読み込み中";
var generic_log_in_message = "ログインしてテストを開始しましょう";
var get_started_button = "開始登録はこちら";
var global_cognitive = "認知機能の総合得点";
var global_lifestyle = "生活習慣の総合得点";
var google_play_store = "Google Play ストア";
var header_account_created = "ご登録ありがとうございます。";
var header_login = "ニューロトラック 脳ケアへログイン";
var header_register = "登録";
var header_sign_in = "ログイン";
var header_welcome = "はじめに";
var header_welcome_2 = "ニューロトラックにようこそ！";
var implicit_learning = "暗黙的学習";
var inhibition = "抑制機能";
var input_device_answer_1 = "";
var input_device_answer_2 = "";
var input_device_answer_3 = "";
var input_device_header = "";
var input_device_paragraph = "";
var invalid_token_mylinkx_body = "ログインしたマイリンククロスのアカウントが認識できません。もう一度お試しください。";
var invalid_token_mylinkx_header = "認証に失敗しました。";
var invalid_token_mylinkx_retry_button = "再試行";
var landing_header = "";
var landing_image_pairs_header = "";
var landing_paragraph = "";
var landing_paragraph_innovatemr = "";
var landing_processing_speed_header = "";
var landing_trails_header = "";
var last_name_label = "姓";
var learn_body = "認知機能の維持や認知症予防に関する記事一覧です。ニューロトラック米国の臨床チームが科学的な根拠に基づき書いた内容を翻訳しました。";
var learn_header = "学び";
var linkage_failure_another_mlx_mylinkx_body = "このニューロトラック 脳ケアのアカウントはすでにマイリンククロスのアカウントと連携されています。";
var linkage_failure_another_mlx_mylinkx_retry = "ご登録内容を確認の上、引き続きニューロトラック 脳ケアをご利用ください。";
var linkage_failure_another_nt_mylinkx_body = "このマイリンククロスのアカウントはすでに別のニューロトラック 脳ケアのアカウントと連携されています。";
var linkage_failure_another_nt_mylinkx_retry = "他のマイリンククロスのアカウントでお試しください。";
var linkage_failure_mylinkx_body = "ニューロトラック 脳ケアとマイリンククロスのアカウントを連携できませんでした。";
var linkage_failure_mylinkx_header = "処理を続行することができません";
var linkage_failure_mylinkx_retry = "後ほどもう一度お試しください。再度エラーが発生する場合はよくある質問 (https://www.neurotrack.com/jp/faq) を確認の上、お客様窓口にお問い合わせください。";
var logged_out_header = "ログアウトしました。";
var login_loggedin_body = "次のアカウントでログインしています: {0}";
var login_loggedin_description = "別のニューロトラック 脳ケアのアカウントを使用する場合は、ログアウトをして最初からやり直してください。";
var login_loggedin_header = "おかえりなさい";
var login_loggedin_link = "ここクリックして次のページに移動:";
var login_loggedin_mylinkx_body = "次のアカウントでログインしています: {0}";
var login_loggedin_mylinkx_description = "別のニューロトラック 脳ケアのアカウントを使用する場合は、このアカウントからログアウトして最初からやり直してください。";
var login_loggedin_mylinkx_header = "おかえりなさい";
var login_loggedin_mylinkx_link = "マイリンククロスとニューロトラック 脳ケアのアカウントを連携する場合はここをクリックしてください";
var mailchimp_audience_id_label = "";
var mailing_address = "住所";
var maximum_usage_label = "";
var memory = "記憶力";
var minutes = "分";
var modal_body_task_error = "";
var modal_contact_support_body = "NA";
var modal_contact_support_title = "NA";
var modal_cta_task_error = "";
var modal_log_out_prompt_cta1 = "NA";
var modal_log_out_prompt_cta2 = "NA";
var modal_log_out_prompt_title = "NA";
var modal_performance_accuracy = "";
var modal_performance_speed = "";
var modal_pullout_performance = "";
var modal_pullout_task_error = "";
var modal_start_task_cta = "";
var modal_task_pullout_attention = "";
var modal_task_pullout_memory = "";
var modal_task_pullout_thinking = "";
var modal_task_title_attention = "";
var modal_task_title_memory = "";
var modal_task_title_thinking = "";
var modal_time_attention = "";
var modal_time_memory = "";
var modal_time_thinking = "";
var modal_title_task_error = "";
var more_information_demographics_why_detail = "認知機能の状態を同性・同世代のユーザーと比較します。これは、神経心理学で統計集団を定義するための標準的な手法です。";
var more_information_demographics_why_header = "質問の目的";
var more_information_video_why_detail = "テスト中に録画した映像は、テスト結果の算出に利用されます。例えば、周囲の環境が好ましくない場合やテストに集中できなかった場合など、正しい得点が算出されないケースを確認します。また、一部の認知機能テストでは、視線解析技術 (アイトラッキング) を使用し、画面のどこを見ているのかを検出し、得点の計算に用います。";
var more_information_video_why_header = "なぜ録画するのですか ?";
var mylinkx = "マイリンククロス";
var mylinkx_authentication_failure_header = "認証エラーが生じました";
var mylinkx_authentication_failure_header_body = "マイリンククロス アカウントが認識できません。";
var mylinkx_login_button = "マイリンククロスにログイン";
var mylinkx_signup_button = "マイリンククロスに新規登録";
var mylinkx_taken_failure_body = "既にニューロトラックアカウントに登録されている様です。脳ケア アプリにログインできる状態ですので、今すぐアプリをダウンロードして脳ケアを始めましょう。";
var mylinkx_taken_failure_header = "このアカウントは既にご登録済みです";
var mylinkx_usage_qualification_failure_body = "登録できません";
var mylinkx_usage_qualification_failure_header = "ニューロトラックに登録するためには、マイリンククロスの情報をニューロトラックと共有することに同意する必要があります。";
var nav__main_learn = "NA";
var nav_account_log_out = "NA";
var nav_account_profile = "NA";
var nav_help_contact_support = "NA";
var nav_help_faq = "NA";
var nav_help_privacy = "NA";
var nav_help_terms = "NA";
var nav_main_account = "NA";
var nav_main_checkup = "NA";
var nav_main_help = "NA";
var nav_main_results = "NA";
var not_selected = "選択されていません";
var nutrition = "食生活";
var or_separator = "または";
var organization_code_label = "";
var organization_tab = "";
var page_title_checkup = "";
var partner_code_label = "";
var partner_codes_tab = "";
var processing_message_mylinkx_body = "ニューロトラック 脳ケアとマイリンククロスのアカウントを連携しています。";
var processing_message_mylinkx_header = "アカウントを連携します";
var processing_speed = "処理速度";
var profile_link = "利用者情報";
var read_receipt_label = "既読";
var read_receipt_tooltip = "{0} が {1} に既読";
var recognition_memory = "認識記憶";
var redirect_mylinx_signin = "マイリンククロスのログイン ページに移行中です。しばらくお待ち下さい。";
var redirecting_body = "ニューロトラック 脳ケアのアカウントにログインしました。";
var redirecting_description = "リダイレクト（別のページに移動）しようとしています:";
var redirecting_header = "接続中...";
var redirecting_link = "2 秒たっても移動しない場合はこちらをクリックしてください";
var redirecting_mylinkx_body = "";
var redirecting_mylinkx_description = "マイリンククロスのログイン画面に移動します。";
var redirecting_mylinkx_header = "マイリンククロスに接続します";
var redirecting_mylinkx_link = "2 秒たっても移動しない場合はこちらをクリックしてください";
var register_body_agreement = "登録すると、ニューロトラックの {0} と {1} に同意したことになります。";
var register_body_disclaimer_header = "免責事項";
var register_body_disclaimer_para = "このサービスは、専門的な医療アドバイス、診断、または治療に代わるものではありません。症状に関して質問がある場合は、必ず医師または医療機関にご相談ください。";
var register_body_pp_link = "プライバシーポリシー";
var register_body_tos_link = "利用規約";
var register_email_placeholder = "メールアドレス";
var register_firstname_placeholder = "名を入力してください。";
var register_lastname_placeholder = "姓を入力してください。";
var register_login_email_compliance_error = "有効なメールアドレスを入力してください。";
var register_marketing_radio_yes = "ニューロトラックからマーケティング情報を受け取ることに同意します。";
var register_marketing_radio_yes_with_partner = "当社、及び、{0}からマーケティング情報を受け取ることに同意します。";
var register_password_compliance_error = "パスワードは8文字以上にする必要があります。";
var register_password_hint = "パスワードは8文字以上にしてください。";
var register_password_match_error = "パスワードが一致しません。";
var register_password_placeholder = "パスワード";
var register_scores_sharing_radio_yes = "テスト結果を{0}と共有することに同意します。";
var register_terms_and_privacy_policy_checkbox = "ニューロトラックの {0} と {1} を確認し、同意しました。";
var register_terms_and_privacy_policy_detail = "チェックを入れてお進みください。";
var registration_in_progress_wait = "登録中です。しばらくお待ちください。";
var required_consent_intro = "以下の内容に同意の上、次に進んでください。同意しない場合は自動的にログアウトします。";
var reset_password_body = "ボタンをクリックしてもページが開かない場合は、次のURLをコピーして、ブラウザのアドレスバーに直接貼り付けて実行してください :\nhttps://app-dev.neurotrack.com/change-password?code=864849&username=9e2a0bae-f889-4869-a3e6-c2f18deffe07";
var reset_password_button = "パスワードのリセット";
var reset_password_title = "パスワードをリセットしましょう。";
var screen_onboarding_button_continue = "";
var screen_onboarding_button_create_account = "";
var screen_onboarding_button_getstarted = "";
var screen_onboarding_button_large_login = "";
var screen_onboarding_button_skip = "";
var screen_onboarding_button_small_login = "";
var screen_onboarding_code_error = "";
var screen_onboarding_code_example = "";
var screen_onboarding_code_example_mobile = "";
var screen_onboarding_code_intro = "";
var screen_onboarding_code_slug = "";
var screen_onboarding_code_title = "";
var screen_onboarding_dob_example_day = "";
var screen_onboarding_dob_example_year = "";
var screen_onboarding_dob_intro = "";
var screen_onboarding_dob_month_dropdown_1 = "";
var screen_onboarding_dob_month_dropdown_10 = "";
var screen_onboarding_dob_month_dropdown_11 = "";
var screen_onboarding_dob_month_dropdown_12 = "";
var screen_onboarding_dob_month_dropdown_13 = "";
var screen_onboarding_dob_month_dropdown_2 = "";
var screen_onboarding_dob_month_dropdown_3 = "";
var screen_onboarding_dob_month_dropdown_4 = "";
var screen_onboarding_dob_month_dropdown_5 = "";
var screen_onboarding_dob_month_dropdown_6 = "";
var screen_onboarding_dob_month_dropdown_7 = "";
var screen_onboarding_dob_month_dropdown_8 = "";
var screen_onboarding_dob_month_dropdown_9 = "";
var screen_onboarding_dob_race_intro = "";
var screen_onboarding_dob_slug_day = "";
var screen_onboarding_dob_slug_month = "";
var screen_onboarding_dob_slug_year = "";
var screen_onboarding_dob_title = "";
var screen_onboarding_education_dropdown = "";
var screen_onboarding_education_dropdown_1 = "";
var screen_onboarding_education_dropdown_10 = "";
var screen_onboarding_education_dropdown_2 = "";
var screen_onboarding_education_dropdown_3 = "";
var screen_onboarding_education_dropdown_4 = "";
var screen_onboarding_education_dropdown_5 = "";
var screen_onboarding_education_dropdown_6 = "";
var screen_onboarding_education_dropdown_7 = "";
var screen_onboarding_education_dropdown_8 = "";
var screen_onboarding_education_dropdown_9 = "";
var screen_onboarding_education_intro = "";
var screen_onboarding_education_title = "";
var screen_onboarding_email_intro = "";
var screen_onboarding_email_optin_marketing = "";
var screen_onboarding_email_optin_tospp = "";
var screen_onboarding_email_slug = "";
var screen_onboarding_email_title = "";
var screen_onboarding_home_intro = "";
var screen_onboarding_home_subhead_registered = "";
var screen_onboarding_home_title = "";
var screen_onboarding_login_example_email = "";
var screen_onboarding_login_example_password = "";
var screen_onboarding_login_link_forgot = "";
var screen_onboarding_login_slug_email = "";
var screen_onboarding_login_slug_password = "";
var screen_onboarding_login_subtitle_no_account = "";
var screen_onboarding_login_title = "";
var screen_onboarding_name_example_first = "";
var screen_onboarding_name_example_last = "";
var screen_onboarding_name_slug_first = "";
var screen_onboarding_name_slug_last = "";
var screen_onboarding_name_title = "";
var screen_onboarding_password_example = "";
var screen_onboarding_password_example_confirm = "";
var screen_onboarding_password_intro = "";
var screen_onboarding_password_slug = "";
var screen_onboarding_password_slug_confirm = "";
var screen_onboarding_password_title = "";
var screen_onboarding_race_dropdown = "";
var screen_onboarding_race_dropdown_1 = "";
var screen_onboarding_race_dropdown_2 = "";
var screen_onboarding_race_dropdown_3 = "";
var screen_onboarding_race_dropdown_4 = "";
var screen_onboarding_race_dropdown_5 = "";
var screen_onboarding_race_dropdown_6 = "";
var screen_onboarding_race_intro = "";
var screen_onboarding_race_title = "";
var screen_onboarding_race_title_short = "";
var screen_onboarding_reason_intro = "";
var screen_onboarding_reason_option1 = "";
var screen_onboarding_reason_option2 = "";
var screen_onboarding_reason_option3 = "";
var screen_onboarding_reason_option4 = "";
var screen_onboarding_reason_title = "";
var screen_onboarding_sex_dropdown = "";
var screen_onboarding_sex_dropdown_1 = "";
var screen_onboarding_sex_dropdown_2 = "";
var screen_onboarding_sex_intro = "";
var screen_onboarding_sex_title = "";
var screen_results_button_close = "";
var screen_results_button_continue = "";
var screen_results_button_see_details = "";
var screen_results_measure_explanation_associative_learning_bullet1 = "";
var screen_results_measure_explanation_associative_learning_bullet2 = "";
var screen_results_measure_explanation_associative_learning_bullet3 = "";
var screen_results_measure_explanation_associative_learning_intro = "";
var screen_results_measure_explanation_associative_memory_bullet1 = "";
var screen_results_measure_explanation_associative_memory_bullet2 = "";
var screen_results_measure_explanation_associative_memory_bullet3 = "";
var screen_results_measure_explanation_associative_memory_intro = "";
var screen_results_measure_explanation_attention = "";
var screen_results_measure_explanation_executive_function_bullet1 = "";
var screen_results_measure_explanation_executive_function_bullet2 = "";
var screen_results_measure_explanation_executive_function_bullet3 = "";
var screen_results_measure_explanation_executive_function_intro = "";
var screen_results_measure_explanation_memory = "";
var screen_results_measure_explanation_processing_speed_bullet1 = "";
var screen_results_measure_explanation_processing_speed_bullet2 = "";
var screen_results_measure_explanation_processing_speed_bullet3 = "";
var screen_results_measure_explanation_processing_speed_intro = "";
var screen_results_measure_explanation_thinking = "";
var screen_results_measure_explanation_title_associative_learning = "";
var screen_results_measure_explanation_title_associative_memory = "";
var screen_results_measure_explanation_title_executive_function = "";
var screen_results_measure_explanation_title_processing_speed = "";
var screen_results_measure_title_attention = "";
var screen_results_measure_title_memory = "";
var screen_results_measure_title_thinking = "";
var screen_results_subtitle_learn_more = "";
var screen_results_title_attention = "";
var screen_results_title_memory = "";
var screen_results_title_task = "";
var screen_results_title_thinking = "";
var search_no_result = "該当するデータが見つかりませんでした";
var session_timeout_body = "長時間操作が行われていないため、自動的にログアウトします。";
var session_timeout_header = "セッションの有効期限がまもなく切れます";
var sign_in_body_nonbranded = "アカウントにログインしてください。";
var sign_in_body_sign_in = "ニューロトラックのアカウントにログイン";
var sign_in_email_prompt = "メールアドレスを入力";
var sign_in_password_prompt = "パスワードを入力";
var sleep = "睡眠";
var social_engagement = "社会的つながり";
var sompo_email_link = "support.jp@neurotrack.com";
var sompo_registration_instructions_body = "ニューロトラックは、ＳＯＭＰＯひまわり生命との提携において、認知機能テストや脳の健康に良いアドバイスを脳ケア アプリを通じてお客様にご提供しています。脳ケア アプリを無料でご利用頂くためには、次の３つのステップに従ってニューロトラックに登録してください。";
var sompo_registration_instructions_header = "脳ケア アプリのご利用方法";
var sompo_registration_instructions_mylinkx_login_prompt = "マイリンククロス アカウントをお持ちの場合";
var sompo_registration_instructions_mylinkx_signup_prompt = "マイリンククロス アカウントをお持ちでない場合";
var sompo_registration_instructions_step1_detail = "ニューロトラックからのお知らせを受け取るために braincare@neurotrack.com を連絡先に追加して下さい。";
var sompo_registration_instructions_step1_header = "ニューロトラック脳ケアをメールの連絡先に追加する";
var sompo_registration_instructions_step2_detail = "このステップは、脳ケア アプリをご利用頂くために必ず行ってください。";
var sompo_registration_instructions_step2_header = "マイリンククロスにログインして利用する";
var sompo_registration_instructions_step3_header = "ニューロトラックに登録してアプリを使い始めましょう。";
var spatial_working_memory = "空間作業記憶";
var start_button = "ここをクリックして開始";
var start_exam_button = "テストを開始しましょう。";
var start_over_registration_button = "もう一度やり直してください";
var stress = "ストレス管理";
var title_label = "";
var title_registration = "ニューロトラック 登録";
var title_registration_sompo = "ニューロトラック SOMPO 登録";
var tooltip_more = "もっと見る";
var visit_website_for_more = "詳細は当社Webサイトneurotrack.comをご覧ください。";
var watch_to_expect_profile_body = "基本的な属性情報を入力してからテストを受けます。テスト結果には、同じ属性の人と比較した結果が反映されます。";
var watch_to_expect_profile_header = "利用者情報の設定";
var web_learn_source_button = "根拠となる研究";
var welcome_body_confirm_password_placeholder = "パスワード";
var welcome_body_email_placeholder = "メールアドレス";
var welcome_body_login = "ニューロトラックのアカウントにログイン";
var welcome_body_login_mylinkx = "ニューロトラック 脳ケアのアカウントにログインして、マイリンククロスのアカウントと連携してください。";
var welcome_body_login_sompo = "マイリンククロスの登録が完了しました。ニューロトラックのアカウントへログインしてください。";
var welcome_body_password_placeholder = "パスワード";
var welcome_body_register = "ニューロトラックに登録する";
var welcome_body_register_sompo = "脳ケア アプリをご利用になるためにニューロトラックのアカウントを登録してください";
var welcome_help_body = "クーポンコードをお持ちでない場合やＳＯＭＰＯひまわり生命のお客様でない場合は、support.jp@neurotrack.com までお問い合わせください。";
var welcome_partner_body = "アカウントを作成して認知機能を測定しましょう。また脳の健康を維持していくためのアドバイスを受け取りましょう。";
var welcome_partner_body_new = "年齢に関係なく、脳ケアはいつでも始めることができます。ニューロトラックのアプリで認知機能を継続的にチェックして、健全な状態の維持に役立てることができます。";
var welcome_sompo_body = "ＳＯＭＰＯひまわり生命のお客様および マイリンククロス ユーザーはこちら";
var what_to_expect_assessments_body = "認知機能テストの実施手順がダッシュボードに表示されます。";
var what_to_expect_assessments_header = "認知機能テスト";
var what_to_expect_camera_check_body = "テストを受ける前にウェブカメラへのアクセスを許可する必要があります。設定はブラウザでいつでも変更できます。テスト中にカメラを使って録画する理由については次ページの説明をお読みください。";
var what_to_expect_camera_check_header = "ウェブカメラの設定を確認";
var what_to_expect_header = "はじめに";
var what_to_expect_intro = "テストを始める前に、いくつか準備が必要です。";
var what_to_expect_welcome = "認知機能テスト ポータルへようこそ！";
var you_are_logged_in_as = "ユーザー";
var ja = {
	arrow_match_button_continue: arrow_match_button_continue,
	arrow_match_button_left_web: arrow_match_button_left_web,
	arrow_match_button_right_web: arrow_match_button_right_web,
	arrow_match_conclusion_1_heading: arrow_match_conclusion_1_heading,
	arrow_match_intro_1_heading: arrow_match_intro_1_heading,
	arrow_match_intro_1_paragraph: arrow_match_intro_1_paragraph,
	arrow_match_phase_1_intro_1: arrow_match_phase_1_intro_1,
	arrow_match_phase_1_intro_2: arrow_match_phase_1_intro_2,
	arrow_match_phase_1_intro_2_web: arrow_match_phase_1_intro_2_web,
	arrow_match_phase_1_intro_3: arrow_match_phase_1_intro_3,
	arrow_match_phase_1_intro_3_web: arrow_match_phase_1_intro_3_web,
	arrow_match_phase_1_intro_4: arrow_match_phase_1_intro_4,
	arrow_match_phase_1_intro_4_web: arrow_match_phase_1_intro_4_web,
	arrow_match_phase_1_intro_5_web: arrow_match_phase_1_intro_5_web,
	arrow_match_phase_1_intro_6_header_web: arrow_match_phase_1_intro_6_header_web,
	arrow_match_phase_1_intro_6_web: arrow_match_phase_1_intro_6_web,
	arrow_match_phase_1_start_1: arrow_match_phase_1_start_1,
	arrow_match_phase_1_start_1_header: arrow_match_phase_1_start_1_header,
	arrow_match_phase_1_start_2: arrow_match_phase_1_start_2,
	arrow_match_start_practice: arrow_match_start_practice,
	arrow_match_start_practice_web: arrow_match_start_practice_web,
	arrow_match_title: arrow_match_title,
	arrow_match_tutorial_feedback_body_left_web: arrow_match_tutorial_feedback_body_left_web,
	arrow_match_tutorial_feedback_body_right_web: arrow_match_tutorial_feedback_body_right_web,
	arrow_match_tutorial_feedback_header_correct: arrow_match_tutorial_feedback_header_correct,
	arrow_match_tutorial_feedback_header_incorrect: arrow_match_tutorial_feedback_header_incorrect,
	demographics_age_heading: demographics_age_heading,
	demographics_biological_sex_answer_1: demographics_biological_sex_answer_1,
	demographics_biological_sex_answer_2: demographics_biological_sex_answer_2,
	demographics_biological_sex_heading: demographics_biological_sex_heading,
	demographics_button_label: demographics_button_label,
	demographics_education_answer_1: demographics_education_answer_1,
	demographics_education_answer_10: demographics_education_answer_10,
	demographics_education_answer_2: demographics_education_answer_2,
	demographics_education_answer_3: demographics_education_answer_3,
	demographics_education_answer_4: demographics_education_answer_4,
	demographics_education_answer_5: demographics_education_answer_5,
	demographics_education_answer_6: demographics_education_answer_6,
	demographics_education_answer_7: demographics_education_answer_7,
	demographics_education_answer_8: demographics_education_answer_8,
	demographics_education_answer_9: demographics_education_answer_9,
	demographics_education_heading: demographics_education_heading,
	demographics_paragraph: demographics_paragraph,
	demographics_race_ethnicity_answer_1: demographics_race_ethnicity_answer_1,
	demographics_race_ethnicity_answer_2: demographics_race_ethnicity_answer_2,
	demographics_race_ethnicity_answer_3: demographics_race_ethnicity_answer_3,
	demographics_race_ethnicity_answer_4: demographics_race_ethnicity_answer_4,
	demographics_race_ethnicity_answer_5: demographics_race_ethnicity_answer_5,
	demographics_race_ethnicity_answer_6: demographics_race_ethnicity_answer_6,
	demographics_race_ethnicity_heading: demographics_race_ethnicity_heading,
	demographics_worker_id_heading: demographics_worker_id_heading,
	demographics_worker_id_prompt: demographics_worker_id_prompt,
	exam_complete_mturk_body: exam_complete_mturk_body,
	exam_complete_mturk_error_body: exam_complete_mturk_error_body,
	exam_complete_mturk_error_header: exam_complete_mturk_error_header,
	exam_complete_mturk_header: exam_complete_mturk_header,
	exam_instructions_header: exam_instructions_header,
	exam_practice_header: exam_practice_header,
	exam_start_exam_button_label: exam_start_exam_button_label,
	exam_start_practice_button_label: exam_start_practice_button_label,
	exam_start_practice_header: exam_start_practice_header,
	experiments_arrow_match_button_correct: experiments_arrow_match_button_correct,
	experiments_arrow_match_button_incorrect: experiments_arrow_match_button_incorrect,
	experiments_arrow_match_pre_practice_1: experiments_arrow_match_pre_practice_1,
	experiments_mouse_arrow_match_phase_1_intro_3_web: experiments_mouse_arrow_match_phase_1_intro_3_web,
	experiments_mouse_arrow_match_phase_1_intro_4_web: experiments_mouse_arrow_match_phase_1_intro_4_web,
	experiments_timer_arrow_match_post_practice: experiments_timer_arrow_match_post_practice,
	experiments_timer_arrow_match_start_practice_web: experiments_timer_arrow_match_start_practice_web,
	flanker_prepractice_button_label: flanker_prepractice_button_label,
	flanker_prepractice_description: flanker_prepractice_description,
	flanker_prepractice_title: flanker_prepractice_title,
	go_no_go_button_continue: go_no_go_button_continue,
	go_no_go_conclusion_1_heading: go_no_go_conclusion_1_heading,
	go_no_go_feedback_body_early: go_no_go_feedback_body_early,
	go_no_go_feedback_body_early_web: go_no_go_feedback_body_early_web,
	go_no_go_feedback_body_go_correct: go_no_go_feedback_body_go_correct,
	go_no_go_feedback_body_go_correct_web: go_no_go_feedback_body_go_correct_web,
	go_no_go_feedback_body_go_incorrect: go_no_go_feedback_body_go_incorrect,
	go_no_go_feedback_body_go_incorrect_web: go_no_go_feedback_body_go_incorrect_web,
	go_no_go_feedback_body_no_go_correct: go_no_go_feedback_body_no_go_correct,
	go_no_go_feedback_body_no_go_correct_web: go_no_go_feedback_body_no_go_correct_web,
	go_no_go_feedback_body_no_go_incorrect: go_no_go_feedback_body_no_go_incorrect,
	go_no_go_feedback_body_no_go_incorrect_web: go_no_go_feedback_body_no_go_incorrect_web,
	go_no_go_feedback_header_correct: go_no_go_feedback_header_correct,
	go_no_go_feedback_header_early: go_no_go_feedback_header_early,
	go_no_go_feedback_header_incorrect: go_no_go_feedback_header_incorrect,
	go_no_go_intro_1_heading: go_no_go_intro_1_heading,
	go_no_go_intro_1_paragraph: go_no_go_intro_1_paragraph,
	go_no_go_phase_1_intro_1: go_no_go_phase_1_intro_1,
	go_no_go_phase_1_intro_1_web: go_no_go_phase_1_intro_1_web,
	go_no_go_phase_1_intro_2: go_no_go_phase_1_intro_2,
	go_no_go_phase_1_intro_2_web: go_no_go_phase_1_intro_2_web,
	go_no_go_phase_1_intro_3: go_no_go_phase_1_intro_3,
	go_no_go_phase_1_intro_3_web: go_no_go_phase_1_intro_3_web,
	go_no_go_phase_1_start_body: go_no_go_phase_1_start_body,
	go_no_go_phase_1_start_body_web: go_no_go_phase_1_start_body_web,
	go_no_go_phase_1_start_header: go_no_go_phase_1_start_header,
	go_no_go_response_button_web: go_no_go_response_button_web,
	go_no_go_start_practice: go_no_go_start_practice,
	go_no_go_start_practice_web: go_no_go_start_practice_web,
	go_no_go_title: go_no_go_title,
	image_pairs_button_continue: image_pairs_button_continue,
	image_pairs_title: image_pairs_title,
	instructions_heading: instructions_heading,
	item_price_button_continue: item_price_button_continue,
	item_price_button_no_web: item_price_button_no_web,
	item_price_button_yes_web: item_price_button_yes_web,
	item_price_phase_1_end: item_price_phase_1_end,
	item_price_phase_1_end_body: item_price_phase_1_end_body,
	item_price_phase_1_intro_1: item_price_phase_1_intro_1,
	item_price_phase_1_intro_2: item_price_phase_1_intro_2,
	item_price_phase_1_intro_3: item_price_phase_1_intro_3,
	item_price_phase_1_intro_3_price: item_price_phase_1_intro_3_price,
	item_price_phase_1_intro_4: item_price_phase_1_intro_4,
	item_price_phase_1_intro_4_price: item_price_phase_1_intro_4_price,
	item_price_phase_1_intro_5_button: item_price_phase_1_intro_5_button,
	item_price_phase_1_intro_5_web: item_price_phase_1_intro_5_web,
	item_price_phase_2_intro_1: item_price_phase_2_intro_1,
	item_price_phase_2_intro_2_web: item_price_phase_2_intro_2_web,
	item_price_phase_2_intro_3_web: item_price_phase_2_intro_3_web,
	item_price_phase_2_intro_4_web: item_price_phase_2_intro_4_web,
	item_price_phase_2_intro_5: item_price_phase_2_intro_5,
	item_price_phase_2_intro_6_button: item_price_phase_2_intro_6_button,
	item_price_phase_2_intro_6_web: item_price_phase_2_intro_6_web,
	item_price_phase_2_trial_prompt: item_price_phase_2_trial_prompt,
	item_price_title: item_price_title,
	"nt-currency-label": "¥",
	"nt-paired-item-price-multiply-factor": "100",
	path_points_button_continue: path_points_button_continue,
	path_points_conclusion_1_heading: path_points_conclusion_1_heading,
	path_points_intro_1_paragraph: path_points_intro_1_paragraph,
	path_points_node_a: path_points_node_a,
	path_points_node_b: path_points_node_b,
	path_points_node_c: path_points_node_c,
	path_points_node_d: path_points_node_d,
	path_points_node_e: path_points_node_e,
	path_points_node_f: path_points_node_f,
	path_points_node_g: path_points_node_g,
	path_points_phase_1_intro_1: path_points_phase_1_intro_1,
	path_points_phase_1_intro_2: path_points_phase_1_intro_2,
	path_points_phase_1_intro_2_web: path_points_phase_1_intro_2_web,
	path_points_phase_1_intro_3: path_points_phase_1_intro_3,
	path_points_phase_1_intro_3_alternate: path_points_phase_1_intro_3_alternate,
	path_points_phase_1_intro_3_web: path_points_phase_1_intro_3_web,
	path_points_phase_1_start_body: path_points_phase_1_start_body,
	path_points_phase_1_start_header: path_points_phase_1_start_header,
	path_points_start_practice: path_points_start_practice,
	path_points_title: path_points_title,
	path_points_tutorial_incorrect_body: path_points_tutorial_incorrect_body,
	path_points_tutorial_incorrect_header: path_points_tutorial_incorrect_header,
	path_points_tutorial_prompt: path_points_tutorial_prompt,
	path_points_tutorial_prompt_web: path_points_tutorial_prompt_web,
	symbol_match_button_continue: symbol_match_button_continue,
	symbol_match_button_equal: symbol_match_button_equal,
	symbol_match_button_equal_web: symbol_match_button_equal_web,
	symbol_match_button_unequal: symbol_match_button_unequal,
	symbol_match_button_unequal_web: symbol_match_button_unequal_web,
	symbol_match_phase_1_intro_1: symbol_match_phase_1_intro_1,
	symbol_match_phase_1_intro_2: symbol_match_phase_1_intro_2,
	symbol_match_phase_1_intro_3: symbol_match_phase_1_intro_3,
	symbol_match_phase_1_intro_4: symbol_match_phase_1_intro_4,
	symbol_match_phase_1_intro_5_web: symbol_match_phase_1_intro_5_web,
	symbol_match_phase_1_intro_6_web: symbol_match_phase_1_intro_6_web,
	symbol_match_phase_1_intro_7_web: symbol_match_phase_1_intro_7_web,
	symbol_match_phase_1_start_header: symbol_match_phase_1_start_header,
	symbol_match_phase_1_start_web: symbol_match_phase_1_start_web,
	symbol_match_title: symbol_match_title,
	symbol_match_tutorial_1_paragraph_web: symbol_match_tutorial_1_paragraph_web,
	symbol_match_tutorial_2_paragraph_web: symbol_match_tutorial_2_paragraph_web,
	symbol_match_tutorial_3_paragraph_web: symbol_match_tutorial_3_paragraph_web,
	symbol_match_tutorial_correct_heading: symbol_match_tutorial_correct_heading,
	symbol_match_tutorial_incorrect_heading: symbol_match_tutorial_incorrect_heading,
	web_button_next: web_button_next,
	web_button_previous: web_button_previous,
	account_created_body_confirmation: account_created_body_confirmation,
	account_created_body_confirmation_webuser: account_created_body_confirmation_webuser,
	account_created_verification_instructions_body: account_created_verification_instructions_body,
	account_created_verification_instructions_body_webuser: account_created_verification_instructions_body_webuser,
	account_link: account_link,
	alert_action_ok: alert_action_ok,
	alert_body_expired_coupon: alert_body_expired_coupon,
	alert_body_invalid_coupon: alert_body_invalid_coupon,
	alert_bulk_create_account_success: alert_bulk_create_account_success,
	alert_forgot_password_body_confirm: alert_forgot_password_body_confirm,
	alert_forgot_password_body_header: alert_forgot_password_body_header,
	alert_header_forgot_password: alert_header_forgot_password,
	alert_header_invalid_coupon: alert_header_invalid_coupon,
	alert_header_invalid_login: alert_header_invalid_login,
	alert_header_reg_error: alert_header_reg_error,
	alert_invalid_extension: alert_invalid_extension,
	alert_invalid_login_body: alert_invalid_login_body,
	alert_invalid_login_email: alert_invalid_login_email,
	alert_reg_error_body: alert_reg_error_body,
	alert_session_expired: alert_session_expired,
	alert_unsupported_media_recorder: alert_unsupported_media_recorder,
	apple_app_store: apple_app_store,
	assessment_processing: assessment_processing,
	assessment_unavailable_camera_body: assessment_unavailable_camera_body,
	assessment_unavailable_camera_header: assessment_unavailable_camera_header,
	assessments_available_body: assessments_available_body,
	assessments_available_empty_body: assessments_available_empty_body,
	assessments_available_header: assessments_available_header,
	assessments_history_empty_body: assessments_history_empty_body,
	assessments_history_header: assessments_history_header,
	assessments_history_table_assessment_header: assessments_history_table_assessment_header,
	assessments_history_table_bucket_header: assessments_history_table_bucket_header,
	assessments_history_table_date_header: assessments_history_table_date_header,
	assessments_history_table_domain_header: assessments_history_table_domain_header,
	assessments_history_table_percentile_header: assessments_history_table_percentile_header,
	assessments_history_with_scores_empty_body: assessments_history_with_scores_empty_body,
	associative_learning: associative_learning,
	associative_memory: associative_memory,
	attention: attention,
	available_exams_label: available_exams_label,
	back_to_faqs: back_to_faqs,
	browser_tab_title: browser_tab_title,
	button_agree: button_agree,
	button_back_to_assessments: button_back_to_assessments,
	button_cancel: button_cancel,
	button_check_camera: button_check_camera,
	button_close: button_close,
	button_continue: button_continue,
	button_continue_session: button_continue_session,
	button_delete: button_delete,
	button_disagree: button_disagree,
	button_edit: button_edit,
	button_forgot_password: button_forgot_password,
	button_forgot_password_log_in: button_forgot_password_log_in,
	button_go_back: button_go_back,
	button_learn_more: button_learn_more,
	button_login: button_login,
	button_open_app: button_open_app,
	button_register: button_register,
	button_save: button_save,
	button_set: button_set,
	button_sign_in: button_sign_in,
	button_sign_out: button_sign_out,
	button_sign_up: button_sign_up,
	button_skip: button_skip,
	button_submit: button_submit,
	button_try_again: button_try_again,
	camera_check_button_continue_with: camera_check_button_continue_with,
	camera_check_button_continue_without: camera_check_button_continue_without,
	camera_check_header: camera_check_header,
	camera_check_intro: camera_check_intro,
	camera_check_media_recorder_unsupported: camera_check_media_recorder_unsupported,
	camera_check_more_information: camera_check_more_information,
	camera_check_not_found: camera_check_not_found,
	camera_check_pre_exam_accepted: camera_check_pre_exam_accepted,
	camera_check_prompt: camera_check_prompt,
	camera_status_accepted: camera_status_accepted,
	camera_status_blocked: camera_status_blocked,
	camera_status_dismissed: camera_status_dismissed,
	camera_status_header: camera_status_header,
	camera_status_more_information: camera_status_more_information,
	camera_status_overconstrained: camera_status_overconstrained,
	card_body_checkup_instructions_complete: card_body_checkup_instructions_complete,
	card_body_checkup_instructions_start: card_body_checkup_instructions_start,
	card_footer_brain_animation_complete: card_footer_brain_animation_complete,
	card_footer_brain_animation_start: card_footer_brain_animation_start,
	card_footer_brain_animation_state_three: card_footer_brain_animation_state_three,
	card_footer_brain_animation_state_two: card_footer_brain_animation_state_two,
	card_results_date_last_updated: card_results_date_last_updated,
	card_results_interp_below_expected: card_results_interp_below_expected,
	card_results_interp_expected: card_results_interp_expected,
	card_results_interp_percentile: card_results_interp_percentile,
	card_results_slug_better_than: card_results_slug_better_than,
	card_results_slug_your_result: card_results_slug_your_result,
	card_results_status_active: card_results_status_active,
	card_results_status_inactive: card_results_status_inactive,
	card_results_title_attention: card_results_title_attention,
	card_results_title_memory: card_results_title_memory,
	card_results_title_thinking: card_results_title_thinking,
	card_status_exam_complete: card_status_exam_complete,
	card_status_exam_error: card_status_exam_error,
	card_status_exam_processing: card_status_exam_processing,
	card_status_exam_start: card_status_exam_start,
	card_title_brain_animation: card_title_brain_animation,
	card_title_checkup_instructions_complete: card_title_checkup_instructions_complete,
	card_title_checkup_instructions_start: card_title_checkup_instructions_start,
	card_title_exam_attention: card_title_exam_attention,
	card_title_exam_memory: card_title_exam_memory,
	card_title_exam_thinking: card_title_exam_thinking,
	care_category_cognitive: care_category_cognitive,
	care_category_lifestyle: care_category_lifestyle,
	care_chat_cta: care_chat_cta,
	care_chat_file_error: care_chat_file_error,
	care_chat_file_tooltip: care_chat_file_tooltip,
	care_chat_header: care_chat_header,
	care_chat_no_messages: care_chat_no_messages,
	care_chat_placeholder: care_chat_placeholder,
	care_chat_see_profile: care_chat_see_profile,
	care_chat_title: care_chat_title,
	care_chat_today: care_chat_today,
	care_chat_uploading: care_chat_uploading,
	care_general_error: care_general_error,
	care_homepage_header: care_homepage_header,
	care_nav_home: care_nav_home,
	care_nav_logout: care_nav_logout,
	care_patient_age: care_patient_age,
	care_patient_cognitive_pathway: care_patient_cognitive_pathway,
	care_patient_creation_date: care_patient_creation_date,
	care_patient_education: care_patient_education,
	care_patient_email: care_patient_email,
	care_patient_focus: care_patient_focus,
	care_patient_fullname: care_patient_fullname,
	care_patient_org: care_patient_org,
	care_patient_profile_tab: care_patient_profile_tab,
	care_patient_program_join_date: care_patient_program_join_date,
	care_patient_program_status: care_patient_program_status,
	care_patient_program_title: care_patient_program_title,
	care_patient_race: care_patient_race,
	care_patient_scores_tab: care_patient_scores_tab,
	care_patient_sex: care_patient_sex,
	care_patients_header: care_patients_header,
	care_patients_search_button: care_patients_search_button,
	care_patients_search_placeholder: care_patients_search_placeholder,
	care_patients_table_email: care_patients_table_email,
	care_patients_table_focus: care_patients_table_focus,
	care_patients_table_joining_date: care_patients_table_joining_date,
	care_patients_table_name: care_patients_table_name,
	care_patients_table_no_user: care_patients_table_no_user,
	care_patients_table_org: care_patients_table_org,
	care_scores_filter_all: care_scores_filter_all,
	care_scores_filter_cognitive: care_scores_filter_cognitive,
	care_scores_filter_date_range: care_scores_filter_date_range,
	care_scores_filter_domain: care_scores_filter_domain,
	care_scores_filter_last_six_months: care_scores_filter_last_six_months,
	care_scores_filter_last_three_months: care_scores_filter_last_three_months,
	care_scores_filter_lifestyle: care_scores_filter_lifestyle,
	care_scores_filter_most_recent: care_scores_filter_most_recent,
	care_scores_filter_status: care_scores_filter_status,
	care_scores_filter_status_flagged: care_scores_filter_status_flagged,
	care_scores_filter_status_incomplete: care_scores_filter_status_incomplete,
	care_scores_filter_status_successful: care_scores_filter_status_successful,
	care_scores_header: care_scores_header,
	care_scores_table_assessment: care_scores_table_assessment,
	care_scores_table_bucket: care_scores_table_bucket,
	care_scores_table_date: care_scores_table_date,
	care_scores_table_domain: care_scores_table_domain,
	care_scores_table_id: care_scores_table_id,
	care_scores_table_score: care_scores_table_score,
	care_scores_table_status: care_scores_table_status,
	care_users_header: care_users_header,
	change_password_attempt_limit_exceeded: change_password_attempt_limit_exceeded,
	change_password_body: change_password_body,
	change_password_body_header: change_password_body_header,
	change_password_body_instructions: change_password_body_instructions,
	change_password_close_window: change_password_close_window,
	change_password_confirm_new_password: change_password_confirm_new_password,
	change_password_enter_new_password_for: change_password_enter_new_password_for,
	change_password_enter_new_password_for_personalized: change_password_enter_new_password_for_personalized,
	change_password_enter_password: change_password_enter_password,
	change_password_go_to_login: change_password_go_to_login,
	change_password_invalid_password: change_password_invalid_password,
	change_password_success_header: change_password_success_header,
	chat_edited_label: chat_edited_label,
	coaching_start_date: coaching_start_date,
	cognitive_training: cognitive_training,
	confirm_start_date_body: confirm_start_date_body,
	confirm_start_date_title: confirm_start_date_title,
	confirmation_failure_mylinkx_retry_button: confirmation_failure_mylinkx_retry_button,
	confirmation_success_mylinkx_body: confirmation_success_mylinkx_body,
	confirmation_success_mylinkx_description: confirmation_success_mylinkx_description,
	confirmation_success_mylinkx_header: confirmation_success_mylinkx_header,
	confirmation_success_mylinkx_next_button: confirmation_success_mylinkx_next_button,
	consent_failure_mylinkx_body: consent_failure_mylinkx_body,
	consent_failure_mylinkx_description: consent_failure_mylinkx_description,
	consent_failure_mylinkx_retry: consent_failure_mylinkx_retry,
	contact_support_body: contact_support_body,
	contact_support_button: contact_support_button,
	contact_support_detail: contact_support_detail,
	contact_support_header: contact_support_header,
	coupon_body: coupon_body,
	coupon_code_placeholder: coupon_code_placeholder,
	create_accounts_tab: create_accounts_tab,
	default_language_label: default_language_label,
	delete_confirm_body: delete_confirm_body,
	delete_confirm_title: delete_confirm_title,
	demographics_biological_sex_1_answer: demographics_biological_sex_1_answer,
	demographics_biological_sex_2_answer: demographics_biological_sex_2_answer,
	demographics_biological_sex_field: demographics_biological_sex_field,
	demographics_birthday_field: demographics_birthday_field,
	demographics_education_10_answer: demographics_education_10_answer,
	demographics_education_1_answer: demographics_education_1_answer,
	demographics_education_2_answer: demographics_education_2_answer,
	demographics_education_3_answer: demographics_education_3_answer,
	demographics_education_4_answer: demographics_education_4_answer,
	demographics_education_5_answer: demographics_education_5_answer,
	demographics_education_6_answer: demographics_education_6_answer,
	demographics_education_7_answer: demographics_education_7_answer,
	demographics_education_8_answer: demographics_education_8_answer,
	demographics_education_field: demographics_education_field,
	demographics_experiments_header: demographics_experiments_header,
	demographics_header: demographics_header,
	demographics_prompt: demographics_prompt,
	demographics_race_ethnicity_1_answer: demographics_race_ethnicity_1_answer,
	demographics_race_ethnicity_2_answer: demographics_race_ethnicity_2_answer,
	demographics_race_ethnicity_3_answer: demographics_race_ethnicity_3_answer,
	demographics_race_ethnicity_4_answer: demographics_race_ethnicity_4_answer,
	demographics_race_ethnicity_5_answer: demographics_race_ethnicity_5_answer,
	demographics_race_ethnicity_6_answer: demographics_race_ethnicity_6_answer,
	demographics_race_ethnicity_field: demographics_race_ethnicity_field,
	demographics_why_link: demographics_why_link,
	description_label: description_label,
	disclaimer_header: disclaimer_header,
	dob_compliance_error: dob_compliance_error,
	domain_measured: domain_measured,
	drag_drop_csv: drag_drop_csv,
	editing_message: editing_message,
	email_address: email_address,
	email_prompt: email_prompt,
	error_browser_viewport_body: error_browser_viewport_body,
	error_browser_viewport_header: error_browser_viewport_header,
	error_camera_overconstrained_body: error_camera_overconstrained_body,
	error_camera_overconstrained_header: error_camera_overconstrained_header,
	error_cookies_disabled_body: error_cookies_disabled_body,
	error_cookies_disabled_header: error_cookies_disabled_header,
	error_device_display_body: error_device_display_body,
	error_device_unsupported_header: error_device_unsupported_header,
	error_generic_detail: error_generic_detail,
	error_generic_exam_failed_body: error_generic_exam_failed_body,
	error_generic_experiments_exam_failed: error_generic_experiments_exam_failed,
	error_generic_header: error_generic_header,
	error_invalid_code: error_invalid_code,
	error_no_user_found: error_no_user_found,
	error_password_policy: error_password_policy,
	error_too_many_attempts: error_too_many_attempts,
	error_unsupported_browser_body: error_unsupported_browser_body,
	error_unsupported_browser_header: error_unsupported_browser_header,
	error_unsupported_media_recorder_body: error_unsupported_media_recorder_body,
	error_unsupported_media_recorder_header: error_unsupported_media_recorder_header,
	exam_portal_page_title_nonbranded: exam_portal_page_title_nonbranded,
	exam_session_instructions_body: exam_session_instructions_body,
	exam_session_instructions_header: exam_session_instructions_header,
	executive_function: executive_function,
	exercise: exercise,
	existing_diagnoses_answer_1: existing_diagnoses_answer_1,
	existing_diagnoses_answer_2: existing_diagnoses_answer_2,
	existing_diagnoses_answer_3: existing_diagnoses_answer_3,
	existing_diagnoses_answer_4: existing_diagnoses_answer_4,
	existing_diagnoses_answer_5: existing_diagnoses_answer_5,
	existing_diagnoses_answer_6: existing_diagnoses_answer_6,
	existing_diagnoses_answer_7: existing_diagnoses_answer_7,
	existing_diagnoses_answer_8: existing_diagnoses_answer_8,
	existing_diagnoses_answer_9: existing_diagnoses_answer_9,
	existing_diagnoses_header: existing_diagnoses_header,
	existing_diagnoses_paragraph: existing_diagnoses_paragraph,
	experiments_task_complete_header: experiments_task_complete_header,
	experiments_task_completion_code: experiments_task_completion_code,
	faqs_header: faqs_header,
	faqs_link: faqs_link,
	filter_no_result: filter_no_result,
	first_name_label: first_name_label,
	follow_up_days_label: follow_up_days_label,
	forgot_password_header: forgot_password_header,
	forgot_password_instructions_sompo: forgot_password_instructions_sompo,
	free_trial_extension_body_download: free_trial_extension_body_download,
	generic_loading_message: generic_loading_message,
	generic_log_in_message: generic_log_in_message,
	get_started_button: get_started_button,
	global_cognitive: global_cognitive,
	global_lifestyle: global_lifestyle,
	google_play_store: google_play_store,
	header_account_created: header_account_created,
	header_login: header_login,
	header_register: header_register,
	header_sign_in: header_sign_in,
	header_welcome: header_welcome,
	header_welcome_2: header_welcome_2,
	implicit_learning: implicit_learning,
	inhibition: inhibition,
	input_device_answer_1: input_device_answer_1,
	input_device_answer_2: input_device_answer_2,
	input_device_answer_3: input_device_answer_3,
	input_device_header: input_device_header,
	input_device_paragraph: input_device_paragraph,
	invalid_token_mylinkx_body: invalid_token_mylinkx_body,
	invalid_token_mylinkx_header: invalid_token_mylinkx_header,
	invalid_token_mylinkx_retry_button: invalid_token_mylinkx_retry_button,
	landing_header: landing_header,
	landing_image_pairs_header: landing_image_pairs_header,
	landing_paragraph: landing_paragraph,
	landing_paragraph_innovatemr: landing_paragraph_innovatemr,
	landing_processing_speed_header: landing_processing_speed_header,
	landing_trails_header: landing_trails_header,
	last_name_label: last_name_label,
	learn_body: learn_body,
	learn_header: learn_header,
	linkage_failure_another_mlx_mylinkx_body: linkage_failure_another_mlx_mylinkx_body,
	linkage_failure_another_mlx_mylinkx_retry: linkage_failure_another_mlx_mylinkx_retry,
	linkage_failure_another_nt_mylinkx_body: linkage_failure_another_nt_mylinkx_body,
	linkage_failure_another_nt_mylinkx_retry: linkage_failure_another_nt_mylinkx_retry,
	linkage_failure_mylinkx_body: linkage_failure_mylinkx_body,
	linkage_failure_mylinkx_header: linkage_failure_mylinkx_header,
	linkage_failure_mylinkx_retry: linkage_failure_mylinkx_retry,
	logged_out_header: logged_out_header,
	login_loggedin_body: login_loggedin_body,
	login_loggedin_description: login_loggedin_description,
	login_loggedin_header: login_loggedin_header,
	login_loggedin_link: login_loggedin_link,
	login_loggedin_mylinkx_body: login_loggedin_mylinkx_body,
	login_loggedin_mylinkx_description: login_loggedin_mylinkx_description,
	login_loggedin_mylinkx_header: login_loggedin_mylinkx_header,
	login_loggedin_mylinkx_link: login_loggedin_mylinkx_link,
	mailchimp_audience_id_label: mailchimp_audience_id_label,
	mailing_address: mailing_address,
	maximum_usage_label: maximum_usage_label,
	memory: memory,
	minutes: minutes,
	modal_body_task_error: modal_body_task_error,
	modal_contact_support_body: modal_contact_support_body,
	modal_contact_support_title: modal_contact_support_title,
	modal_cta_task_error: modal_cta_task_error,
	modal_log_out_prompt_cta1: modal_log_out_prompt_cta1,
	modal_log_out_prompt_cta2: modal_log_out_prompt_cta2,
	modal_log_out_prompt_title: modal_log_out_prompt_title,
	modal_performance_accuracy: modal_performance_accuracy,
	modal_performance_speed: modal_performance_speed,
	modal_pullout_performance: modal_pullout_performance,
	modal_pullout_task_error: modal_pullout_task_error,
	modal_start_task_cta: modal_start_task_cta,
	modal_task_pullout_attention: modal_task_pullout_attention,
	modal_task_pullout_memory: modal_task_pullout_memory,
	modal_task_pullout_thinking: modal_task_pullout_thinking,
	modal_task_title_attention: modal_task_title_attention,
	modal_task_title_memory: modal_task_title_memory,
	modal_task_title_thinking: modal_task_title_thinking,
	modal_time_attention: modal_time_attention,
	modal_time_memory: modal_time_memory,
	modal_time_thinking: modal_time_thinking,
	modal_title_task_error: modal_title_task_error,
	more_information_demographics_why_detail: more_information_demographics_why_detail,
	more_information_demographics_why_header: more_information_demographics_why_header,
	more_information_video_why_detail: more_information_video_why_detail,
	more_information_video_why_header: more_information_video_why_header,
	mylinkx: mylinkx,
	mylinkx_authentication_failure_header: mylinkx_authentication_failure_header,
	mylinkx_authentication_failure_header_body: mylinkx_authentication_failure_header_body,
	mylinkx_login_button: mylinkx_login_button,
	mylinkx_signup_button: mylinkx_signup_button,
	mylinkx_taken_failure_body: mylinkx_taken_failure_body,
	mylinkx_taken_failure_header: mylinkx_taken_failure_header,
	mylinkx_usage_qualification_failure_body: mylinkx_usage_qualification_failure_body,
	mylinkx_usage_qualification_failure_header: mylinkx_usage_qualification_failure_header,
	nav__main_learn: nav__main_learn,
	nav_account_log_out: nav_account_log_out,
	nav_account_profile: nav_account_profile,
	nav_help_contact_support: nav_help_contact_support,
	nav_help_faq: nav_help_faq,
	nav_help_privacy: nav_help_privacy,
	nav_help_terms: nav_help_terms,
	nav_main_account: nav_main_account,
	nav_main_checkup: nav_main_checkup,
	nav_main_help: nav_main_help,
	nav_main_results: nav_main_results,
	not_selected: not_selected,
	nutrition: nutrition,
	or_separator: or_separator,
	organization_code_label: organization_code_label,
	organization_tab: organization_tab,
	page_title_checkup: page_title_checkup,
	partner_code_label: partner_code_label,
	partner_codes_tab: partner_codes_tab,
	processing_message_mylinkx_body: processing_message_mylinkx_body,
	processing_message_mylinkx_header: processing_message_mylinkx_header,
	processing_speed: processing_speed,
	profile_link: profile_link,
	read_receipt_label: read_receipt_label,
	read_receipt_tooltip: read_receipt_tooltip,
	recognition_memory: recognition_memory,
	redirect_mylinx_signin: redirect_mylinx_signin,
	redirecting_body: redirecting_body,
	redirecting_description: redirecting_description,
	redirecting_header: redirecting_header,
	redirecting_link: redirecting_link,
	redirecting_mylinkx_body: redirecting_mylinkx_body,
	redirecting_mylinkx_description: redirecting_mylinkx_description,
	redirecting_mylinkx_header: redirecting_mylinkx_header,
	redirecting_mylinkx_link: redirecting_mylinkx_link,
	register_body_agreement: register_body_agreement,
	register_body_disclaimer_header: register_body_disclaimer_header,
	register_body_disclaimer_para: register_body_disclaimer_para,
	register_body_pp_link: register_body_pp_link,
	register_body_tos_link: register_body_tos_link,
	register_email_placeholder: register_email_placeholder,
	register_firstname_placeholder: register_firstname_placeholder,
	register_lastname_placeholder: register_lastname_placeholder,
	register_login_email_compliance_error: register_login_email_compliance_error,
	register_marketing_radio_yes: register_marketing_radio_yes,
	register_marketing_radio_yes_with_partner: register_marketing_radio_yes_with_partner,
	register_password_compliance_error: register_password_compliance_error,
	register_password_hint: register_password_hint,
	register_password_match_error: register_password_match_error,
	register_password_placeholder: register_password_placeholder,
	register_scores_sharing_radio_yes: register_scores_sharing_radio_yes,
	register_terms_and_privacy_policy_checkbox: register_terms_and_privacy_policy_checkbox,
	register_terms_and_privacy_policy_detail: register_terms_and_privacy_policy_detail,
	registration_in_progress_wait: registration_in_progress_wait,
	required_consent_intro: required_consent_intro,
	reset_password_body: reset_password_body,
	reset_password_button: reset_password_button,
	reset_password_title: reset_password_title,
	screen_onboarding_button_continue: screen_onboarding_button_continue,
	screen_onboarding_button_create_account: screen_onboarding_button_create_account,
	screen_onboarding_button_getstarted: screen_onboarding_button_getstarted,
	screen_onboarding_button_large_login: screen_onboarding_button_large_login,
	screen_onboarding_button_skip: screen_onboarding_button_skip,
	screen_onboarding_button_small_login: screen_onboarding_button_small_login,
	screen_onboarding_code_error: screen_onboarding_code_error,
	screen_onboarding_code_example: screen_onboarding_code_example,
	screen_onboarding_code_example_mobile: screen_onboarding_code_example_mobile,
	screen_onboarding_code_intro: screen_onboarding_code_intro,
	screen_onboarding_code_slug: screen_onboarding_code_slug,
	screen_onboarding_code_title: screen_onboarding_code_title,
	screen_onboarding_dob_example_day: screen_onboarding_dob_example_day,
	screen_onboarding_dob_example_year: screen_onboarding_dob_example_year,
	screen_onboarding_dob_intro: screen_onboarding_dob_intro,
	screen_onboarding_dob_month_dropdown_1: screen_onboarding_dob_month_dropdown_1,
	screen_onboarding_dob_month_dropdown_10: screen_onboarding_dob_month_dropdown_10,
	screen_onboarding_dob_month_dropdown_11: screen_onboarding_dob_month_dropdown_11,
	screen_onboarding_dob_month_dropdown_12: screen_onboarding_dob_month_dropdown_12,
	screen_onboarding_dob_month_dropdown_13: screen_onboarding_dob_month_dropdown_13,
	screen_onboarding_dob_month_dropdown_2: screen_onboarding_dob_month_dropdown_2,
	screen_onboarding_dob_month_dropdown_3: screen_onboarding_dob_month_dropdown_3,
	screen_onboarding_dob_month_dropdown_4: screen_onboarding_dob_month_dropdown_4,
	screen_onboarding_dob_month_dropdown_5: screen_onboarding_dob_month_dropdown_5,
	screen_onboarding_dob_month_dropdown_6: screen_onboarding_dob_month_dropdown_6,
	screen_onboarding_dob_month_dropdown_7: screen_onboarding_dob_month_dropdown_7,
	screen_onboarding_dob_month_dropdown_8: screen_onboarding_dob_month_dropdown_8,
	screen_onboarding_dob_month_dropdown_9: screen_onboarding_dob_month_dropdown_9,
	screen_onboarding_dob_race_intro: screen_onboarding_dob_race_intro,
	screen_onboarding_dob_slug_day: screen_onboarding_dob_slug_day,
	screen_onboarding_dob_slug_month: screen_onboarding_dob_slug_month,
	screen_onboarding_dob_slug_year: screen_onboarding_dob_slug_year,
	screen_onboarding_dob_title: screen_onboarding_dob_title,
	screen_onboarding_education_dropdown: screen_onboarding_education_dropdown,
	screen_onboarding_education_dropdown_1: screen_onboarding_education_dropdown_1,
	screen_onboarding_education_dropdown_10: screen_onboarding_education_dropdown_10,
	screen_onboarding_education_dropdown_2: screen_onboarding_education_dropdown_2,
	screen_onboarding_education_dropdown_3: screen_onboarding_education_dropdown_3,
	screen_onboarding_education_dropdown_4: screen_onboarding_education_dropdown_4,
	screen_onboarding_education_dropdown_5: screen_onboarding_education_dropdown_5,
	screen_onboarding_education_dropdown_6: screen_onboarding_education_dropdown_6,
	screen_onboarding_education_dropdown_7: screen_onboarding_education_dropdown_7,
	screen_onboarding_education_dropdown_8: screen_onboarding_education_dropdown_8,
	screen_onboarding_education_dropdown_9: screen_onboarding_education_dropdown_9,
	screen_onboarding_education_intro: screen_onboarding_education_intro,
	screen_onboarding_education_title: screen_onboarding_education_title,
	screen_onboarding_email_intro: screen_onboarding_email_intro,
	screen_onboarding_email_optin_marketing: screen_onboarding_email_optin_marketing,
	screen_onboarding_email_optin_tospp: screen_onboarding_email_optin_tospp,
	screen_onboarding_email_slug: screen_onboarding_email_slug,
	screen_onboarding_email_title: screen_onboarding_email_title,
	screen_onboarding_home_intro: screen_onboarding_home_intro,
	screen_onboarding_home_subhead_registered: screen_onboarding_home_subhead_registered,
	screen_onboarding_home_title: screen_onboarding_home_title,
	screen_onboarding_login_example_email: screen_onboarding_login_example_email,
	screen_onboarding_login_example_password: screen_onboarding_login_example_password,
	screen_onboarding_login_link_forgot: screen_onboarding_login_link_forgot,
	screen_onboarding_login_slug_email: screen_onboarding_login_slug_email,
	screen_onboarding_login_slug_password: screen_onboarding_login_slug_password,
	screen_onboarding_login_subtitle_no_account: screen_onboarding_login_subtitle_no_account,
	screen_onboarding_login_title: screen_onboarding_login_title,
	screen_onboarding_name_example_first: screen_onboarding_name_example_first,
	screen_onboarding_name_example_last: screen_onboarding_name_example_last,
	screen_onboarding_name_slug_first: screen_onboarding_name_slug_first,
	screen_onboarding_name_slug_last: screen_onboarding_name_slug_last,
	screen_onboarding_name_title: screen_onboarding_name_title,
	screen_onboarding_password_example: screen_onboarding_password_example,
	screen_onboarding_password_example_confirm: screen_onboarding_password_example_confirm,
	screen_onboarding_password_intro: screen_onboarding_password_intro,
	screen_onboarding_password_slug: screen_onboarding_password_slug,
	screen_onboarding_password_slug_confirm: screen_onboarding_password_slug_confirm,
	screen_onboarding_password_title: screen_onboarding_password_title,
	screen_onboarding_race_dropdown: screen_onboarding_race_dropdown,
	screen_onboarding_race_dropdown_1: screen_onboarding_race_dropdown_1,
	screen_onboarding_race_dropdown_2: screen_onboarding_race_dropdown_2,
	screen_onboarding_race_dropdown_3: screen_onboarding_race_dropdown_3,
	screen_onboarding_race_dropdown_4: screen_onboarding_race_dropdown_4,
	screen_onboarding_race_dropdown_5: screen_onboarding_race_dropdown_5,
	screen_onboarding_race_dropdown_6: screen_onboarding_race_dropdown_6,
	screen_onboarding_race_intro: screen_onboarding_race_intro,
	screen_onboarding_race_title: screen_onboarding_race_title,
	screen_onboarding_race_title_short: screen_onboarding_race_title_short,
	screen_onboarding_reason_intro: screen_onboarding_reason_intro,
	screen_onboarding_reason_option1: screen_onboarding_reason_option1,
	screen_onboarding_reason_option2: screen_onboarding_reason_option2,
	screen_onboarding_reason_option3: screen_onboarding_reason_option3,
	screen_onboarding_reason_option4: screen_onboarding_reason_option4,
	screen_onboarding_reason_title: screen_onboarding_reason_title,
	screen_onboarding_sex_dropdown: screen_onboarding_sex_dropdown,
	screen_onboarding_sex_dropdown_1: screen_onboarding_sex_dropdown_1,
	screen_onboarding_sex_dropdown_2: screen_onboarding_sex_dropdown_2,
	screen_onboarding_sex_intro: screen_onboarding_sex_intro,
	screen_onboarding_sex_title: screen_onboarding_sex_title,
	screen_results_button_close: screen_results_button_close,
	screen_results_button_continue: screen_results_button_continue,
	screen_results_button_see_details: screen_results_button_see_details,
	screen_results_measure_explanation_associative_learning_bullet1: screen_results_measure_explanation_associative_learning_bullet1,
	screen_results_measure_explanation_associative_learning_bullet2: screen_results_measure_explanation_associative_learning_bullet2,
	screen_results_measure_explanation_associative_learning_bullet3: screen_results_measure_explanation_associative_learning_bullet3,
	screen_results_measure_explanation_associative_learning_intro: screen_results_measure_explanation_associative_learning_intro,
	screen_results_measure_explanation_associative_memory_bullet1: screen_results_measure_explanation_associative_memory_bullet1,
	screen_results_measure_explanation_associative_memory_bullet2: screen_results_measure_explanation_associative_memory_bullet2,
	screen_results_measure_explanation_associative_memory_bullet3: screen_results_measure_explanation_associative_memory_bullet3,
	screen_results_measure_explanation_associative_memory_intro: screen_results_measure_explanation_associative_memory_intro,
	screen_results_measure_explanation_attention: screen_results_measure_explanation_attention,
	screen_results_measure_explanation_executive_function_bullet1: screen_results_measure_explanation_executive_function_bullet1,
	screen_results_measure_explanation_executive_function_bullet2: screen_results_measure_explanation_executive_function_bullet2,
	screen_results_measure_explanation_executive_function_bullet3: screen_results_measure_explanation_executive_function_bullet3,
	screen_results_measure_explanation_executive_function_intro: screen_results_measure_explanation_executive_function_intro,
	screen_results_measure_explanation_memory: screen_results_measure_explanation_memory,
	screen_results_measure_explanation_processing_speed_bullet1: screen_results_measure_explanation_processing_speed_bullet1,
	screen_results_measure_explanation_processing_speed_bullet2: screen_results_measure_explanation_processing_speed_bullet2,
	screen_results_measure_explanation_processing_speed_bullet3: screen_results_measure_explanation_processing_speed_bullet3,
	screen_results_measure_explanation_processing_speed_intro: screen_results_measure_explanation_processing_speed_intro,
	screen_results_measure_explanation_thinking: screen_results_measure_explanation_thinking,
	screen_results_measure_explanation_title_associative_learning: screen_results_measure_explanation_title_associative_learning,
	screen_results_measure_explanation_title_associative_memory: screen_results_measure_explanation_title_associative_memory,
	screen_results_measure_explanation_title_executive_function: screen_results_measure_explanation_title_executive_function,
	screen_results_measure_explanation_title_processing_speed: screen_results_measure_explanation_title_processing_speed,
	screen_results_measure_title_attention: screen_results_measure_title_attention,
	screen_results_measure_title_memory: screen_results_measure_title_memory,
	screen_results_measure_title_thinking: screen_results_measure_title_thinking,
	screen_results_subtitle_learn_more: screen_results_subtitle_learn_more,
	screen_results_title_attention: screen_results_title_attention,
	screen_results_title_memory: screen_results_title_memory,
	screen_results_title_task: screen_results_title_task,
	screen_results_title_thinking: screen_results_title_thinking,
	search_no_result: search_no_result,
	session_timeout_body: session_timeout_body,
	session_timeout_header: session_timeout_header,
	sign_in_body_nonbranded: sign_in_body_nonbranded,
	sign_in_body_sign_in: sign_in_body_sign_in,
	sign_in_email_prompt: sign_in_email_prompt,
	sign_in_password_prompt: sign_in_password_prompt,
	sleep: sleep,
	social_engagement: social_engagement,
	sompo_email_link: sompo_email_link,
	sompo_registration_instructions_body: sompo_registration_instructions_body,
	sompo_registration_instructions_header: sompo_registration_instructions_header,
	sompo_registration_instructions_mylinkx_login_prompt: sompo_registration_instructions_mylinkx_login_prompt,
	sompo_registration_instructions_mylinkx_signup_prompt: sompo_registration_instructions_mylinkx_signup_prompt,
	sompo_registration_instructions_step1_detail: sompo_registration_instructions_step1_detail,
	sompo_registration_instructions_step1_header: sompo_registration_instructions_step1_header,
	sompo_registration_instructions_step2_detail: sompo_registration_instructions_step2_detail,
	sompo_registration_instructions_step2_header: sompo_registration_instructions_step2_header,
	sompo_registration_instructions_step3_header: sompo_registration_instructions_step3_header,
	spatial_working_memory: spatial_working_memory,
	start_button: start_button,
	start_exam_button: start_exam_button,
	start_over_registration_button: start_over_registration_button,
	stress: stress,
	title_label: title_label,
	title_registration: title_registration,
	title_registration_sompo: title_registration_sompo,
	tooltip_more: tooltip_more,
	visit_website_for_more: visit_website_for_more,
	watch_to_expect_profile_body: watch_to_expect_profile_body,
	watch_to_expect_profile_header: watch_to_expect_profile_header,
	web_learn_source_button: web_learn_source_button,
	welcome_body_confirm_password_placeholder: welcome_body_confirm_password_placeholder,
	welcome_body_email_placeholder: welcome_body_email_placeholder,
	welcome_body_login: welcome_body_login,
	welcome_body_login_mylinkx: welcome_body_login_mylinkx,
	welcome_body_login_sompo: welcome_body_login_sompo,
	welcome_body_password_placeholder: welcome_body_password_placeholder,
	welcome_body_register: welcome_body_register,
	welcome_body_register_sompo: welcome_body_register_sompo,
	welcome_help_body: welcome_help_body,
	welcome_partner_body: welcome_partner_body,
	welcome_partner_body_new: welcome_partner_body_new,
	welcome_sompo_body: welcome_sompo_body,
	what_to_expect_assessments_body: what_to_expect_assessments_body,
	what_to_expect_assessments_header: what_to_expect_assessments_header,
	what_to_expect_camera_check_body: what_to_expect_camera_check_body,
	what_to_expect_camera_check_header: what_to_expect_camera_check_header,
	what_to_expect_header: what_to_expect_header,
	what_to_expect_intro: what_to_expect_intro,
	what_to_expect_welcome: what_to_expect_welcome,
	you_are_logged_in_as: you_are_logged_in_as
};

/**
 * Detect user's locale based on the browser's navigator.languages
 *
 * @param {object} options
 * @returns {string|null}
 */
// @see https://phrase.com/blog/posts/ultimate-guide-to-vue-localization-with-vue-i18n/
function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false };
  const opt = { ...defaultOptions, ...options };
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language;

  if (!navigatorLocale) {
    return null
  }

  return opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()
}

/**
 * Get starting locale or default
 *
 * @returns {string}
 */
function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true }) || '';
  if (['en', 'ja'].includes(browserLocale)) {
    return browserLocale
  }
  return process.env.VUE_APP_I18N_LOCALE || 'en'
}

var env = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getBrowserLocale: getBrowserLocale,
    getStartingLocale: getStartingLocale
});

function _optionalChain$4(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* TODO: investigate using '@vue/cli-plugin-babel/preset' in babel.config.js
 * so that we can use ?. and ?? here.
 */

/**
 * Get domain of current window
 */
function getDomain() {
  const parts = window.location.hostname.split('.');
  const { length } = parts;
  return length < 2 ? window.location.hostname : `${parts[length - 2]}.${parts[length - 1]}`
}

/**
 * Get the current stage from environment variables
 *
 * @returns {string}
 */
const getStage = () => (process.env.VUE_APP_STAGE || process.env.NODE_ENV || 'dev');

/**
 * Get the current region from environment variables
 *
 * @returns {string}
 */
const getRegion = () => (_optionalChain$4([process, 'optionalAccess', _ => _.env, 'optionalAccess', _2 => _2.VUE_APP_REGION]) || 'us');





/**
 * Enum for apps
 */
const APP_NAMES = {
  auth: 'auth',
  care: 'care',
  exams: 'exams'
};

/**
 * Enum for VUE_APP_STAGE options
 */
const STAGE_OPTIONS = {
  dev: 'dev',
  local: 'local',
  prod: 'prod',
  qa: 'qa',
  staging: 'staging',
  usprod: 'usprod'
};

/**
 * Enum for VUE_APP_REGION options
 */
const REGION_OPTIONS = {
  jp: 'jp',
  us: 'us'
};

/**
 * Urls for global web
 */
const globalAppBaseUrls = {
  [APP_NAMES.auth]: 'https://{stage}app.neurotrack.com/',
  [APP_NAMES.care]: 'https://{stage}care.neurotrack.com/',
  [APP_NAMES.exams]: 'https://{stage}exams.neurotrack.io/'
};

/**
 * Get the app url given the app name, and optionally, the stage
 *
 * @param {APP_NAMES} app The name of the app to fetch the url for
 * @param {string} stage (optional) The name of the stage. Default: current stage set in .env.
 * @returns {string} The appropriate app url, or empty string if something doesn't exist
 */
const getAppUrl = (
  app,
  stage = getStage()
) => {
  // no stage prefix needed if prod or usprod
  stage = ((stage === STAGE_OPTIONS.prod) || (stage === STAGE_OPTIONS.usprod)) ? '' : `${stage}.`;
  return (globalAppBaseUrls[app] || '').replace('{stage}', stage)
};

/**
 * DEPRECATED: retaining for possible future needs
 * URL hash for API in dev and jp prod stages.
 * Because multiple stage options use the same url, this hash reduces repetition.
 * dev stages: dev, devlopment, local
 * prod stages: prod, production
const apiMultiKeyHash = {
  [STAGE_OPTIONS.dev]: {
    [REGION_OPTIONS.jp]: 'https://api.dev.jp.neurotrack.io/',
    [REGION_OPTIONS.us]: 'https://api.dev-neurotrack.io/'
  }
}
 */

/**
 * DEPRECATED: retaining for possible future needs
 * Enum for returning the correct API url, depending on stage and environment.
 
const apiUrlHash = {
  [STAGE_OPTIONS.dev]: apiMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.prod]: 'https://api.jp-neurotrack.io/',
  [STAGE_OPTIONS.qa]: {
    [REGION_OPTIONS.jp]: 'https://api.qa.jp.neurotrack.io/',
    [REGION_OPTIONS.us]: 'https://api.qa-neurotrack.io/'
  },
  [STAGE_OPTIONS.staging]: {
    [REGION_OPTIONS.jp]: 'https://api.staging.jp.neurotrack.io/',
    [REGION_OPTIONS.us]: 'https://api.staging-neurotrack.io/'
  },
  [STAGE_OPTIONS.usprod]: {
    [REGION_OPTIONS.us]: 'https://api.us-neurotrack.io/'
  }
}
 */

/**
 * DEPRECATED: retaining for possible future needs
 * Get the API url, optionally given the stage and region
 *
 * @param {string} stage (optional) The name of the stage. Default: the current stage in .env.
 * @param {string} region (optional) The name of the region. Default: the current region in .env.
 * @returns {string} The appropriate API url, or empty string if something doesn't exist
export const getApiUrl = (stage = getStage(), region = getRegion()) => {
  // if the stage object doesn't exist, don't bother
  const stageObj = apiUrlHash[stage]
  if (!stageObj) {
    return ''
  }
 
  // some stages don't have all the regions
  const url = stageObj[region]
  if (url) { return url }
 
  // the specified region doesn't exist in the stage, so return the first region available
  const keys = Object.keys(stageObj)
  return keys.length < 1 ? '' : stageObj[keys[0]]
}
 */

// #region Auth

/**
 * URL hash for auth in dev and prod stages.
 */
const authMultiKeyHash = {
  [STAGE_OPTIONS.dev]: 'https://dev.auth.neurotrack.io/',
  [STAGE_OPTIONS.prod]: 'https://auth.neurotrack.io/'
};

/**
 * Enum for returning the correct global auth url depending on stage.
 */
const globalAuthHash = {
  [STAGE_OPTIONS.dev]: authMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.local]: authMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.qa]: 'https://qa.auth.neurotrack.io/',
  [STAGE_OPTIONS.staging]: 'https://staging.auth.neurotrack.io/',
  [STAGE_OPTIONS.usprod]: authMultiKeyHash[STAGE_OPTIONS.prod],
  [STAGE_OPTIONS.prod]: authMultiKeyHash[STAGE_OPTIONS.prod]
};

const globalAuthBaseURL = globalAuthHash[getStage() === 'development' ? 'dev' : getStage()];
// #endregion Auth

// #region OAUTH Authentication
/**
 * URL hash for OAUTH authentication in dev and prod stages.
 */
const oauthMultiKeyHash = {
  [STAGE_OPTIONS.dev]: 'https://myidentity-support.platform.athenahealth.com/',
  [STAGE_OPTIONS.usprod]: 'https://myidentity.platform.athenahealth.com/',
  [STAGE_OPTIONS.prod]: 'https://myidentity.platform.athenahealth.com/'
};

/**
 * Enum for returning the correct OAUTH url depending on stage.
 */
const globalOauthHash = {
  [STAGE_OPTIONS.dev]: oauthMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.local]: oauthMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.qa]: oauthMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.staging]: oauthMultiKeyHash[STAGE_OPTIONS.dev],
  [STAGE_OPTIONS.usprod]: oauthMultiKeyHash[STAGE_OPTIONS.usprod],
  [STAGE_OPTIONS.prod]: oauthMultiKeyHash[STAGE_OPTIONS.prod]
};

const globalOauthBaseURL = globalOauthHash[getStage()];
// #endregion Terms and Privacy

const domain = window.location.hostname === 'localhost'
  ? ''
  : `; domain=${getDomain()}`;

/**
 * Set a cookie
 *
 * @param {string} name
 * @param {string} value
 * @param {number} days
 * @param {string} options
 */
const setCookie = (
  name,
  value,
  days = 0,
  options = ''
) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}${domain}; path=/${options}`;
};

/**
 * Get cookie
 *
 * @param {string} name
 * @returns {string | undefined }
 */
const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  // TODO - Modernize
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
};

/**
 * Erase cookie
 *
 * @param {string} name
 */
const eraseCookie = (name) => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT${domain};`;
};

var cookies = /*#__PURE__*/Object.freeze({
    __proto__: null,
    setCookie: setCookie,
    getCookie: getCookie,
    eraseCookie: eraseCookie
});

function _nullishCoalesce$2(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain$3(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }









/**
 * Axios object for global auth
 */
const authHttp = axios.create({
  baseURL: globalAuthBaseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': _nullishCoalesce$2(_optionalChain$3([navigator, 'access', _ => _.language, 'optionalAccess', _2 => _2.split, 'call', _3 => _3('-'), 'access', _4 => _4[0]]), () => ( 'en'))
  }
});

/**
 * @template T
 * @typedef { import('axios').AxiosResponse<T> } AxiosResponse<T>
 */

/**
 * Login in using email and password
 *
 * @param {string} username
 * @param {string} password
 * @returns {Promise<object>}
 */
async function login(username, password) {
  const { data } = await authHttp.post('/v1/global-auth/login', {
    username,
    password
  });

  return data
}

/**
 * Sends a logout request to invalidate auth tokens.
 *
 * @param {string} token
 * @returns {Promise<object>}
 */
async function logout(token) {
  const result = await authHttp.post('/v1/global-auth/logout', {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).catch(() => {});
  return _optionalChain$3([result, 'optionalAccess', _5 => _5.data])
}

/**
 * Generates a new access token for the user when the refresh token provided is valid.
 *
 * @param {string} refresh_token
 * @returns {Promise<object>}
 */
async function refreshToken(refresh_token) {
  const result = await authHttp.post('/v1/global-auth/refresh-token', { refresh_token })
    .catch(() => {});
  return _optionalChain$3([result, 'optionalAccess', _6 => _6.data])
}

/**
 * Starts the forgot password workflow.
 *
 * @param {string} username
 * @returns {Promise<object>}
 */
async function resetPassword(username) {
  const { data, status } = await authHttp.post('/v1/global-auth/forgot-password', { username })
    .catch(ex => ex);
  return { data, status }
}

/**
 * Completes the forgot password process by storing the new password on the system.
 *
 * @param {object} payload
 * @returns {Promise<object>}
 */
async function changePassword$1(payload) {
  return authHttp.post('/v1/global-auth/confirm-forgot-password', payload)
}

// #region User
const renamePayload = ({ first, last, ...remainder }) => ({
  given_name: first,
  family_name: last,
  ...remainder
});

/**
 * @param payload
 */
function register(payload) {
  const postPayload = renamePayload(payload);
  if (postPayload.organization == null) {
    postPayload.organization = process.env.VUE_APP_AUTH_ORG || '';
  }

  const attributionLabel = getCookie('attribution');
  if (attributionLabel) {
    postPayload.extra_fields = { label: attributionLabel };
  }

  return authHttp.post('/v1/users', postPayload)
}

/**
 * @param payload
 */
async function registerMyLinkX(payload) {
  const attributionLabel = getCookie('attribution');
  if (attributionLabel) {
    payload.extra_fields = { label: attributionLabel };
  }

  return authHttp.post('/v1/users', payload)
}

/**
 * @param partnerCode
 */
async function validatePartnerCode(partnerCode) {
  const { data } = await authHttp.get(`/v1/partner-code/${partnerCode}`);
  return data
}
// #endregion User

var auth = /*#__PURE__*/Object.freeze({
    __proto__: null,
    login: login,
    logout: logout,
    refreshToken: refreshToken,
    resetPassword: resetPassword,
    changePassword: changePassword$1,
    register: register,
    registerMyLinkX: registerMyLinkX,
    validatePartnerCode: validatePartnerCode
});

function _nullishCoalesce$1(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain$2(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* eslint-disable camelcase */

let token;
const validateStatus = (status) => status >= 200 && status <= 202;
const httpInstance = axios.create({
  validateStatus,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': _nullishCoalesce$1(_optionalChain$2([navigator, 'access', _ => _.language, 'optionalAccess', _2 => _2.split, 'call', _3 => _3('-'), 'access', _4 => _4[0]]), () => ( 'en'))
  }
});

let refreshFailureHandler;

/**
 * @param handler
 */
function setRefreshFailureHandler(handler) {
  refreshFailureHandler = handler;
}

// Function that will be called to refresh authorization
const refreshAuthLogic = async (failedRequest) => {
  // until we implement the init path, get refresh token from localstorage
  const refresh_token = localStorage.getItem('refresh_token') || '';

  try {
    const tokenRefreshResponse = await refreshToken(refresh_token);

    const access_token = _optionalChain$2([tokenRefreshResponse, 'optionalAccess', _5 => _5.access_token]);
    failedRequest.response.config.headers.Authorization = `Bearer ${access_token}`;
    // TODO: initialize http things rather than expect passive handoff

    if (access_token) {
      window.localStorage.setItem('access_token', access_token);
      return Promise.resolve()
    }
    throw new Error('Unauthorized')
  } catch (ex) {
    window.localStorage.removeItem('refresh_token');
    window.localStorage.removeItem('access_token');

    _optionalChain$2([refreshFailureHandler, 'optionalCall', _6 => _6(ex)]);

    return Promise.reject(new Error('refresh token failed'))
  }
};

createAuthRefreshInterceptor(httpInstance, refreshAuthLogic, {
  pauseInstanceWhileRefreshing: true
});

// expo retry backoff (on 3 retries)
axiosRetry(httpInstance, { retryDelay: axiosRetry.exponentialDelay });
// PAS takes > 20s for Symbol digit data. Temp until BE can fix response time
httpInstance.defaults.timeout = 30000;
httpInstance.interceptors.request.use(
  config => {
    Sentry.addBreadcrumb({
      level: Sentry.Severity.Info,
      category: 'http',
      message: 'http request resolved'
    });

    const tok = _nullishCoalesce$1(token, () => ( localStorage.getItem('access_token')));
    const imageExtensionRegex = /\.(jpg|jpeg|png|gif|svg)$/i;

    if (tok && config.headers && !imageExtensionRegex.test(config.url || '')) {
      config.headers.Authorization = `Bearer ${tok}`;
    }
    return config
  },
  err => {
    Sentry.addBreadcrumb({
      level: Sentry.Severity.Error,
      category: 'http',
      message: 'outbound request failure',
      data: _optionalChain$2([err, 'optionalAccess', _7 => _7.config])
    });
    Sentry.setExtra('error', err);
    Sentry.captureException(err);
    return Promise.reject(err)
  }
);

httpInstance.interceptors.response.use(
  (response) => {
    Sentry.addBreadcrumb({
      level: Sentry.Severity.Info,
      category: 'http',
      message: 'http response resolved'
    });
    if (response.access_token) {
      token = response.access_token;
    }
    return response
  },
  (err) => {
    Sentry.addBreadcrumb({
      level: Sentry.Severity.Error,
      category: 'http',
      message: 'http response not resolved',
      data: _optionalChain$2([err, 'optionalAccess', _8 => _8.config])
    });
    Sentry.setExtra('error', err);
    Sentry.captureException(err);
    /**
     * Send back a response object
     *
     * @see https://github.com/axios/axios/issues/960
     */
    return Promise.reject(err.response)
  }
);

/**
 * Add User Pii consent
 * ---
 * An endpoint to add pii consent to a user, note the new consent
 * will only be added to the user object if it is different from
 * what the user already has.
 *
 * @param {string} userId
 * @param {{ partner: string, accept_consent: boolean }} body
 * @returns {Promise<object>}
 */
async function applyConsent(userId, body) {
  const { partner, accept_consent } = body;
  const { data } = await httpInstance.post(
    `v1/users/${userId}/pii-consents`,
    {
      partner,
      accept_consent
    }
  );
  return data
}

/**
 * Returns a list of (new / processing) activities owned by the given user.
 *
 * @param {string} userId
 * @returns {Promise<object>}
 */
async function getActivities(userId) {
  const { data } = await httpInstance.get(
    `v1/users/${userId}/activities?include_invisible=false&task_details_required=true`
  );

  return data
}

/**
 * Returns a list of completed activities owned by the given user.
 *
 * @param {string} userId
 * @returns {Promise<object>}
 */
async function getActivityHistory(userId) {
  const { data } = await httpInstance.get(
    `v1/users/${userId}/activities?include_invisible=true&task_details_required=true&progress_status=completed`
  );

  return data
}

/**
 * Returns score detail for assessment
 *
 * @param {string} userId
 * @param {string} assessmentId
 * @returns {Promise<object>}
 */
async function getActivityScore(userId, assessmentId) {
  const { data } = await httpInstance.get(
    `v1/users/${userId}/results?translate=true&assessment_id=${assessmentId}`
  );

  return data
}

/**
 * @param uid
 * @param payload
 * @param token
 */
function linkAccount(uid, payload, token) {
  return httpInstance.post(`/v1/users/${uid}/external-link/mylinkx`, payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

/**
 * Get a UUID from an integration partner patient ID
 *
 * @param integration string
 * @param patientId string
 */
async function getNTPatientId(integration, patientId) {
  const { data } = await httpInstance.get(`v1/medical-integrations/nt-user-id/${integration}/${patientId}`);

  return data
}

var user = /*#__PURE__*/Object.freeze({
    __proto__: null,
    applyConsent: applyConsent,
    getActivities: getActivities,
    getActivityHistory: getActivityHistory,
    getActivityScore: getActivityScore,
    linkAccount: linkAccount,
    getNTPatientId: getNTPatientId
});

/**
 * Get user profile
 *
 * @param {string} userId
 *
 * @returns {Promise<Object>}
 */
async function getProfile(userId) {
  const { data } = await httpInstance.get(`/v1/users/${userId}`);
  return data
}

/**
 * Update user's own profile.
 *
 * @param {string} userId
 * @param {Object} body
 *
 * @returns {Promise<Object>}
 */
async function updateProfile(userId, body) {
  const { data } = await httpInstance.patch(`/v1/users/${userId}`, { ...body });
  return data
}

/**
 * @param userId
 * @param body
 */
async function updateProfileJourneySettings(userId, body) {
  const { data } = await httpInstance.patch(`/v1/users/${userId}/journey-settings`, body);
  return data
}

var profile = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getProfile: getProfile,
    updateProfile: updateProfile,
    updateProfileJourneySettings: updateProfileJourneySettings
});

// TODO: File repeated in apps/auth/src/data
/**
 * A mapping of org identifiers in profile data
 * to display name
 */
const orgsById = {
  ozaki_clinic_20: 'Ozaki',
  japan_01: 'ＳＯＭＰＯひまわり生命保険株式会社',
  lawson: '株式会社ローソン',
  docomo: '株式会社NTTドコモ',
  chp_demo_2020: 'Neurotrack',
  web_test_2020: 'Neurotrack',
  chariot: 'Chariot Pro Study',
  'dai-ichi': 'Dai-ichi',
  'demo-org': 'Neurotrack',
  nakano_city: '長野県中野市',
  neurotrack: 'Neurotrack',
  novartis: 'Novartis',
  novartis_2020: 'Novartis',
  nvrts_pre_ad_02: 'Novartis',
  prudential_01: 'Prudential',
  sbir_2021: 'SBIR',
  sompo: 'SOMPO',
  sompo_preview_2019: 'SOMPO',
  stanford_pbs: 'Stanford',
  uark_nitro: 'University of Arkansas',
  healthcare_beta: 'Neurotrack',
  'Fake-001': 'Neurotrack Testing Org'
};

/**
 * Parse a user token.
 *
 * @param {string} token
 * @returns {{
 *   id: string,
 *   role: string,
 *   org: string,
 *   scopes: string[],
 *   username: string
 * }}
 */
function parseToken(token) {
  let parsedToken;
  let groups = [];

  try {
    if (token.split('.').length === 3) {
      parsedToken = JSON.parse(window.atob(token.split('.')[1]));
      // NEW: cognito groups:
      groups = parsedToken['cognito:groups'];
    }
  } catch (e) {
    // TODO track errors? (what error are we expecting here?)
    // eslint-disable-next-line no-console
    console.log(e);
  }

  return {
    ...parsedToken,
    groups
  }
}

/**
 * Get user id from token
 *
 * @param {string} token
 * @returns {string | boolean}
 */
const getUserName = (token) => {
  if (token.split('.').length === 3) {
    // NB: id is now `username` since switch to cognito
    return parseToken(token).username
  }
  return false
};

/**
 * Get organization display name from ID,
 * or return original ID if not mapped
 *
 * @param {string} orgId
 * @returns {string}
 */
function getOrgNameFromId$1(orgId) {
  return orgsById[orgId] || orgId
}

/**
 * Set the API url in the current http object to use for future calls
 */
function setHttpBaseUrl() {
  const apiUrl = getCookie('api_url');
  if (apiUrl) {
    httpInstance.defaults.baseURL = apiUrl;
  }
}

/**
 * Store the custom Token Id value in localStorage so non-auth apps can use it
 *
 * @param {string} key key from login response
 * @param {string} idToken id_token from login response
 * @param {string} options optional extra params for cookie creation
 */
function saveCustomTokenKey(key, idToken, options = '') {
  const content = parseToken(idToken)[`custom:${key}`];
  if (content) {
    setCookie(key, content, 1, options);
  }
}

/**
 * @template T
 * @typedef { import('axios').AxiosResponse<T> } AxiosResponse<T>
 */

/**
 * This API is currently blocked by CORS on the BE
 * leaving stub for ref
 *
 * @param {string} id
 * @param {string} password
 * @returns {Promise<AxiosResponse<any>>}
 */
async function changePassword(id, password) {
  try {
    return await httpInstance.patch(`/v1/users/${id}`, {
      body: {
        password,
        connection: 'Username-Password-Authentication'
      }
    })
  } catch (ex) {
    console.warn('Unable to update password', ex, password);
    return Promise.reject(ex)
  }
}

/**
 * Get a list of user's exam results
 * 
 * @param {string} userId
 * @param {object} params 
 * @returns {Promise<AxiosResponse<any>>}
 */
async function getResultsForUser(
  userId, params
) {
  const { data } = await httpInstance.get(`/v2/results/users/${userId}`,
    { params: { ...params, translate: true } });

  return data
}

/**
 * Executes an ElasticSearch query for the users endpoint
 *
 * @param {any} query
 * @returns {Promise<{ total: number, data: any }>}
 */
async function searchUsers(query) {
  const { data } = await httpInstance.post('/v1/users/search', query);
  const { hits, total } = data.hits;

  return {
    total: total.value,
    data: hits.map((a) => a._source)
  }
}

/**
 * Uses ElasticSearch to get users for a coach
 *
 * @param {string} userId
 * @returns {Promise<any>}
 */
async function getUsersForCoach(userId) {
  return searchUsers({
    size: 1000,
    query: {
      bool: {
        must: [
          {
            match: {
              'coaching.assigned_coach.user_id': userId
            }
          }
        ]
      }
    }
  })
}

/**
 * Get activities (exams) for user
 *
 * @param {string} userId
 * @returns {object}
 */
async function getExamsForUser(userId) {
  // TODO: not being used? Remove?
  const res = await fetch(
    `https://api.dev-neurotrack.io/v0/users/${userId}/activities?include_invisible=true&task_details_required=true`,
    {
      method: 'GET',
      headers: {
        Authorization: 'Token A',
        'Content-Type': 'application/json',
        'Accept-Language': 'en'
      }
    }
  );
  return res.json()
}

/**
 * Get a list of exams?
 *
 * @returns {AxiosResponse<any>}
 */
async function listExams() {
  const exams = await httpInstance.get('/v1/exams');
  console.log('exams', exams);
}

/**
 * Create assessment
 *
 * @param {string} userId
 * @param {object} params
 * @param params.exam_code
 * @param params.platform
 * @returns {object}
 */
async function createAssessment(
  userId, params
) {
  const { data } = await httpInstance.post(
    `/v2/users/${userId}/assessments?trial_phases=true&translate=true`, params
  );
  return data
}

/**
 * Get assessments
 *
 * @param {string} assessmentId
 * @param {string} userId
 * @returns {object}
 */
async function getAssessments(assessmentId, userId) {
  const { data } = await httpInstance.get(
    `/v2/users/${userId}/assessments/${assessmentId}?trial_phases=true&translate=true`
  );
  return data
}

/**
 * Get organization display name from ID (Async)
 *
 * @param {string} orgId
 * @returns {Promise<string>}
 */
async function getOrgNameFromId(orgId) {
  return getOrgNameFromId$1(orgId)
}

var admin = /*#__PURE__*/Object.freeze({
    __proto__: null,
    changePassword: changePassword,
    getResultsForUser: getResultsForUser,
    searchUsers: searchUsers,
    getUsersForCoach: getUsersForCoach,
    getExamsForUser: getExamsForUser,
    listExams: listExams,
    createAssessment: createAssessment,
    getAssessments: getAssessments,
    getOrgNameFromId: getOrgNameFromId
});

/**
 * @template T
 * @typedef { import('axios').AxiosResponse<T> } AxiosResponse<T>
 */

/**
 * Initiate Perception Event:
 * The first call to create an assessment level perception item and initial the exam flow
 *
 * @typedef {{
 *   perception_event_id: string,
 *   status: 'PERCEPTION_STARTED'
 * }} InitResponse
 * @param {string} userId
 * @param {string} assessmentId
 * @returns {Promise<InitResponse>}
 */
async function initPerception(userId, assessmentId) {
  /** @type {AxiosResponse<InitResponse>} */
  const { data } = await httpInstance.post(
    `/v1/users/${userId}/assessments/${assessmentId}/perception-events`, {
      event: 'start'
    }
  );
  return data
}

/**
 * Create Trial Level Perception Items
 * ---
 * Post perception metadata and event timing for each trial; including calibration trials.
 *
 * @typedef { import('./types').Perception } Perception
 * @typedef { import('./types').PerceptionPayload } PerceptionPayload
 * @typedef { import('./types').PerceptionResponse } PerceptionResponse
 * @param {string} userId
 * @param {string} assessmentId
 * @param {PerceptionPayload} payload
 * @returns {Promise<PerceptionResponse>}
 */
async function createPerceptionItems(
  userId,
  assessmentId,
  payload
) {
  const { data } = await httpInstance.post(
    `/v1/users/${userId}/assessments/${assessmentId}/perceptions`,
    payload
  );
  return data
}

/**
 * Stop Perception Event
 * ---
 * The last call to end the perception.
 * This call is only going to be made after all perception data posted/uploaded
 *
 * @param {string} userId
 * @param {string} assessmentId
 * @param {string} perceptionEventId
 * @param {'QUIT_EARLY' | 'COMPLETE'} end_reason
 * @returns {Promise<object>}
 */
async function stopPerceptionEvent(
  userId,
  assessmentId,
  perceptionEventId,
  /** 'COMPLETE' | 'QUIT_EARLY' */
  end_reason = 'COMPLETE'
) {
  const { data } = await httpInstance.patch(
    `/v1/users/${userId}/assessments/${assessmentId}/perception-events/${assessmentId}`, {
      status: 'PERCEPTION_ENDED',
      end_reason
    }
  );
  return data
}

/**
 * Upload video blob
 *
 * @param {string} userId
 * @param {string} assessmentId
 * @param {string} trialId
 * @param {Blob} blob - file blob
 * @param {string} contentType - content type for upload
 * @returns {Promise<object>}
 */
async function videoUpload(
  userId,
  assessmentId,
  trialId,
  blob,
  contentType
) {
  const encodedId = encodeURIComponent(trialId);   // for flex exam compatibility
  const { data } = await httpInstance.post(
    `/v1/users/${userId}/assessments/${assessmentId}/perceptions/${encodedId}/video`,
    blob,
    {
      headers: { 'Content-Type': contentType || 'video/webm' }
    }
  );
  return data
}

/**
 * Upload Eyes On Patient (EoP) Video
 *
 * @param {string} assessmentId
 * @param {string} userId
 * @param {Blob} clip - file blob
 * @param {string} contentType
 * @returns {Promise<object>}
 */
async function eopUpload(
  assessmentId,
  userId,
  clip,
  contentType
) {
  const ts = Date.now();
  const { data } = await httpInstance.post(
    `/v1/users/${userId}/assessments/${assessmentId}/perceptions/eyes-on-patient/${ts}`,
    clip,
    {
      headers: {
        'Content-Type': contentType || 'video/webm'
      }
    }
  );

  return data
}

/**
 * Get Exam media
 *
 * @param {string} imageUrl
 */
async function getExamMedia(imageUrl) {
  const { data } = await httpInstance.get(imageUrl, {
    headers: {
      Accept: '*/*'
    }
  });
  return data
}

var exam = /*#__PURE__*/Object.freeze({
    __proto__: null,
    initPerception: initPerception,
    createPerceptionItems: createPerceptionItems,
    stopPerceptionEvent: stopPerceptionEvent,
    videoUpload: videoUpload,
    eopUpload: eopUpload,
    getExamMedia: getExamMedia
});

function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain$1(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
/**
 * Axios object for Oauth
 */
const oauthHttp = axios.create({
  baseURL: globalOauthBaseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': _nullishCoalesce(_optionalChain$1([navigator, 'access', _ => _.language, 'optionalAccess', _2 => _2.split, 'call', _3 => _3('-'), 'access', _4 => _4[0]]), () => ( 'en'))
  }
});

const generatePkceChallenge = () => pkceChallenge(64);

const getClientId = () => (getStage() === 'usprod'
  ? '0oacbuc163FKzylqR297'
  : '0oacbuddmqiYHMvtY297');

/**
 * Return a promise to Athena authorization endpoint.
 *
 * @param {string} iss
 * @param {string} launch
 * @returns {void}
 */
async function athenaOauthAuthorize(iss, launch) {
  localStorage.removeItem('verifier');

  const { code_verifier, code_challenge } = generatePkceChallenge();

  const careUrl = getAppUrl(APP_NAMES.care);
  const scope = 'launch openid profile email';
  const state = v4();

  const paramList = {
    response_type: 'code',
    client_id: getClientId(),
    redirect_uri: `${careUrl}smart/auth-done`,
    launch,
    scope,
    state,
    aud: iss,
    code_challenge,
    code_challenge_method: 'S256'
  };
  const params = new URLSearchParams(paramList).toString();

  // Set verifier & state in local storage
  localStorage.setItem('verifier', code_verifier);
  localStorage.setItem('state', state);

  window.location.href = `${globalOauthBaseURL}oauth2/v1/authorize?${params}`;
}

/**
 * Return a promise to Athena access token endpoint.
 *
 * @param {string} code
 * @returns {Promise<object>}
 */
async function athenaAccessTokens(code) {
  const careUrl = getAppUrl(APP_NAMES.care);
  const verifier = localStorage.getItem('verifier') || undefined;

  try {
    if (!verifier) {
      return Promise.reject(new Error('Verifier not present'))
    }
    const payload = {
      client_id: getClientId(),
      redirect_uri: `${careUrl}smart/auth-done`,
      grant_type: 'authorization_code',
      code,
      code_verifier: verifier
    };
    localStorage.removeItem('verifier');
    return oauthHttp.post('oauth2/v1/token', payload)
  } catch (err) {
    return Promise.reject(err)
  }
}

var oauth = /*#__PURE__*/Object.freeze({
    __proto__: null,
    athenaOauthAuthorize: athenaOauthAuthorize,
    athenaAccessTokens: athenaAccessTokens
});

const API = {
  auth,
  user,
  profile,
  exam,
  oauth,
  admin: {
    ...admin,
    parseToken
  }
};

const envs = {
  local: 'dev',
  dev: 'dev',
  qa: 'qa',
  staging: 'staging',
  prod: 'jp',
  usprod: 'us'
};

const getUploadURL = (env) => {
  const deployedEnvironment = env.length > 1 ? envs[env] : 'qa';
  return `https://api.${deployedEnvironment}${getRegion() === REGION_OPTIONS.us ? '-' : '.jp.'}neurotrack.io/v0/exams-web-upload/`
};

const getDownloadURL = (env) => {
  const deployedEnvironment = env.length > 1 ? envs[env] : 'qa';
  return `https://api.${deployedEnvironment}${getRegion() === REGION_OPTIONS.us ? '-' : '.jp.'}neurotrack.io/v0/exams-web-download`
};

let uploadStarted = false;
const s3Client = {
  async requestDownloadURL(url) {
    return axios
      .post(getDownloadURL(process.env.VUE_APP_STAGE || ''), {
        object_key: url
      })
      .then(response => response.data.url)
      .catch(err => new Error(`error generated in requesting a download URL: ${err}`))
  },

  async requestUploadURLoadURL(userUUID, taskName) {
    return axios
      .post(getUploadURL(process.env.VUE_APP_STAGE || ''), {
        object_key: `${taskName}/${userUUID}.json`
      })
      .then(response => response.data.url)
      .catch(err => new Error(`error generated in requesting an upload URL: ${err}`))
  },

  async submitExam(signedS3URL, examData) {
    if (!uploadStarted) {
      uploadStarted = true;
      await axios
        .put(signedS3URL, examData)
        .then(response => {
          uploadStarted = false;
          return response
        })
        .catch(err => new Error(`uploadError: ${err}`));
    }
  }
};

/**
 * Returns a Date() string using the current date and time
 *
 * @returns {Date<string>}
 */
const now = () => new Date().toISOString();

/**
 * Returns a Safari -safe- date
 *
 * @param {string|Date} date
 * @returns {Date}
 *
 * Safari cannot manage `-` in dates b/c Apple
 * SO Link - https://stackoverflow.com/questions/4310953/invalid-date-in-safari
 */
const parseDate = (date) => new Date((typeof date === 'string')
  ? date.replace(/-/g, '/')
  : date);

/**
 * Returns a nicely formatted date
 *
 * @param {string|Date} date
 * @param {number} relativeYear
 * @todo - Add tests
 */
const formatDate = (date, relativeYear = 0) => {
  const d = parseDate(date);
  let opts;

  /**
   * If a relative year is present, return a short (numeric) date
   */
  if (relativeYear) {
    if (relativeYear === d.getFullYear()) {
      opts = { month: 'numeric', day: 'numeric' };
    } else {
      opts = { year: 'numeric', month: 'numeric', day: 'numeric' };
    }
  } else {
    opts = { year: 'numeric', month: 'long', day: 'numeric' };
  }
  return d.toLocaleDateString(getBrowserLocale() || 'en', opts)
};

/**
 * Returns a nicely formatted date
 *
 * @param {string|Date} date
 * @returns {Date<object>}
 */
const formatTime = (date) => {
  const d = parseDate(date);

  return new Date(d).toLocaleTimeString(getBrowserLocale() || 'en', {
    hour: 'numeric',
    minute: 'numeric'
  })
};

/**
 * Simplistic date validator.
 * Validates that a date is in the form of `1900-01-01`
 *
 * @param {string} date
 * @returns {boolean}
 */
const isFormattedDate = (date) => isDate(
  date, {
    format: 'YYYY-MM-DD',
    strictMode: true,
    delimiters: ['-']
  }
);

const dateIntervalsAgo = (interval



, date) => {
  if (date == null) {
    date = new Date();
  } else if (typeof date === 'string') {
    date = new Date(date);
  }

  if (interval.days) {
    date.setDate(date.getDate() - interval.days);
  }
  if (interval.months) {
    date.setMonth(date.getMonth() - interval.months);
  }
  if (interval.years) {
    // we could use this to set date and month as well
    // but those two may not always be provided. This keeps the logic format consistent
    date.setFullYear(date.getFullYear() - interval.years);
  }

  return date
};

var ntDate = /*#__PURE__*/Object.freeze({
    __proto__: null,
    now: now,
    formatDate: formatDate,
    formatTime: formatTime,
    isFormattedDate: isFormattedDate,
    dateIntervalsAgo: dateIntervalsAgo
});

function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }const defaultDuration = 15 * 60 * 1000;
const defaultInterval = 60 * 1000;







class ActivityMonitor {
  

  

  

  

  

  // TODO: fix types
  constructor(activityTimeoutLengthMS = defaultDuration) {
    this.duration = activityTimeoutLengthMS;
    this.lastActivityTime = Date.now();
    this.handlers = [];

    // Leaving in case Apple every joins the modern web
    // // use BrodcastChannel to track across tabs
    // // https://developer.mozilla.org/en-US/docs/Web/API/Broadcast_Channel_API
    // this.bcListener = new BroadcastChannel('activity_monitor')
    // this.bcListener.onmessage(msg => {
    //   // respond to message for laast activitty time
    // })

    // track mouse and click as user events. anything else?
    this.listeners = [{
      type: 'click',
      fn: () => this.trackActivity()
    }, {
      type: 'mousemove',
      fn: () => this.trackActivity()
    }, {
      type: 'keydown',
      fn: () => this.trackActivity()
    }];

    this.listeners.forEach(({ type, fn }) => window.addEventListener(type, fn));
    this.timer = window.setInterval(() => this.ticker(), defaultInterval);
  }

  ticker() {
    const now = Date.now();
    const diff = now - this.lastActivityTime;
    if (diff >= this.duration) {
      // check expiration in other tabs:
      const lastStoredTime = +(_optionalChain([localStorage, 'optionalAccess', _ => _.getItem, 'call', _2 => _2('last_activity')]) || 0);
      if (now - lastStoredTime >= this.duration) {
        // this.bcListener.postMessage('time_check') // check if some other tab is active
        this.handlers.forEach((fn) => {
          fn({
            lastActivityTime: this.lastActivityTime,
            now
          });
        });
      } else {
        // update this instance's time to reflect last stored
        this.lastActivityTime = lastStoredTime;
      }
    }
  }

  addTimeoutHandler(newHandler) {
    this.handlers.push(newHandler);
  }

  trackActivity() {
    if (document.hasFocus()) {
      const now = Date.now();
      this.lastActivityTime = now;
      localStorage.setItem('last_activity', now.toString());
    }
  }

  destroy() {
    this.listeners.forEach((el) => {
      document.removeEventListener(el.type, el.fn);
    });
    // this.bcListener?.close() // kill broadcastchannel

    clearInterval(this.timer);
    this.timer = undefined;
  }
}

var ActivityMonitor$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ActivityMonitor: ActivityMonitor
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    env: env
});

/** The import pattern exports contentful as `undefined` */
const contentful = require('contentful');

const config = {
  space: 'h8rjlnxxqo9a',
  accessToken: 'xIVjJIr40_4HtoikGeQyXzeHUOSWeTisIUR0OSpM9bM',
  application: 'MyNT/'
};

const createClient = () => contentful.createClient(config);

var contentful$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createClient: createClient
});

const locales = { en, ja };

export { API, ActivityMonitor$1 as ActivityMonitor, contentful$1 as contentful, cookies, getOrgNameFromId$1 as getOrgNameFromId, getUserName, globalAuthBaseURL, httpInstance as http, locales, ntDate, parseToken, s3Client, saveCustomTokenKey, setHttpBaseUrl, setRefreshFailureHandler, index as util };
